import React, { useState, useRef, useEffect } from "react"
import { TabView, TabPanel } from "primereact/tabview"
import { CardBody, Col, Container, Row, DropdownItem, DropdownMenu, } from "reactstrap"

import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import "primereact/resources/themes/saga-blue/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { Dialog } from "primereact/dialog"
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import { Button } from "primereact/button"
import { Dropdown } from "primereact/dropdown"
import { Accordion, AccordionTab } from "primereact/accordion"
import { TreeSelect } from 'primereact/treeselect';
import { Message } from "primereact/message"
import Modal from "react-bootstrap/Modal";
import { Controller, useForm } from "react-hook-form"
import { emailValidation, MaxLengthValidation, MinLengthValidation, onlyAlphabetsandSpaces, onlyNumbers, passwordPattern } from "utils/Constants"
import axios from "axios"
import moment from "moment"
import { triggerAlert, ConfirmationAlert } from "utils/CommonFunctions"
import AdminDasboardats from "ATSComponents/Common/AdminDasboardats"
import { ProgressSpinner } from 'primereact/progressspinner';
import { FileUpload } from "primereact/fileupload"


const Lookup_Cus = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [visible1, setVisible1] = useState(false)
  const [street1, setStreet1] = useState('');
  const [street2, setStreet2] = useState('')
  //const [selectedCity, setSelectedCity] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [addCountries, setAddCountries] = useState([]);
  const [addStates, setAddStates] = useState([]);
  const [addCities, setaddCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [postalCode, setPostalCode] = useState('');
  const [userRoles, setUserRoles] = useState([])
  const [allCompanies, setAllCompanies] = useState([]);
  const [allDepartments, setAllDepartments] = useState([])
  const [companyItem, setCompanyItem] = useState([])
  const [selectedLabel1, setSelectedLabel1] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  document.title = "ATS - Admin"

  useEffect(() => {
    const code = sessionStorage.getItem("oauth_code");
    // OR localStorage.getItem("oauth_code");

    console.log("Received code:", code);
  }, []);

  const LoadingOverlay = ({ isVisible }) => {
    if (!isVisible) return null;

    return (
      <div style={overlayStyle}>
        <ProgressSpinner />
      </div>
    );
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };



  //  const [groupitem, setgroupitem] = useState([])
  //   const [selectedGroupKey, setSelectedGroupKey] = useState(null);
  //   const [categoriesitem, setcategoriesitem] = useState([])

  const { register, handleSubmit, watch, formState: { errors }, setError, clearErrors, trigger, control, setValue, reset } = useForm();

  // const [selectedOptionReports, setSelectedOptionReports] = useState(null)
  const [isDialogVisible, setDialogVisible] = useState(false) // Controls Dialog visibility
  const [selectedUser, setSelectedUser] = useState(null) // Holds selected user for editing
  const handleEdit = user => {
    setSelectedUser(user) // Set selected user for editing
    setDialogVisible(true) // Show dialog
  }
  const viewIcon = rowData => {
    return (
      <Button icon="pi pi-eye" className="p-button-rounded p-button-info" />
    )
  }

  const deleteIcon = rowData => {
    return (
      <Button icon="pi pi-trash" className="p-button-rounded p-button-info" />
    )
  }

  // categories
  const countries = [
    { name: "Frontend", code: "AU" },
    { name: "Backend", code: "BR" },
    { name: "Cloud", code: "CN" },
    { name: "Tester", code: "test" },
  ]

  const countryOptionTemplate = option => {
    return (
      <div className="flex align-items-center">
        <img
          alt={option.name}
          src="https://primefaces.org/cdn/primereact/images/flag/flag_placeholder.png"
          className={`mr-2 flag flag-${option.code.toLowerCase()}`}
          style={{ width: "18px" }}
        />
        <div>{option.name}</div>
      </div>
    )
  }

  const [outgoingServer, setOutgoingServer] = useState("")
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [fromEmail, setFromEmail] = useState("")
  const [email, setEmail] = useState("")
  const [port, setPort] = useState("")
  const [address, setAddress] = useState("")
  const [useSSL, setUseSSL] = useState(false)
  const [smtpAccounts, setSmtpAccounts] = useState([])
  const [showPassword, setShowPassword] = useState(false)
  const [userList, setUserList] = useState([])
  const [formVisible, setFormVisible] = useState(false) // Controls the form visibility
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    role: "",
    status: "Active", // Default status
    createDate: new Date().toISOString().split("T")[0], // Default to today's date
    password: "", // Password field
  })
  const [isEditMode, setIsEditMode] = useState(null) // True when editing, false when adding
  const [currentIndex, setCurrentIndex] = useState(null) // To track the index of the user being edited


  // Reset form after submit or cancel
  const resetForm = () => {
    reset()
    setFormVisible(false) // Hide the form
    setIsEditMode(null)
  }

  const typeOptions = [
    { label: "User", value: "user" },
    { label: "System", value: "system" },
  ]

  // Options for role and status dropdowns
  const roleOptions = [
    { label: "Admin", value: "Admin" },
    { label: "User", value: "User" },
    { label: "Manager", value: "Manager" },
  ]

  const statusOptions = [
    { label: "Ram, Frontend developer", value: "Active" },
    { label: "Sai, Python developer", value: "Inactive" },
    { label: "Karthik, Data Scientist", value: "Suspended" },
  ]

  // Roles start

  const [isFormVisible, setIsFormVisible] = useState(false)
  const [isEditModeActive, setIsEditModeActive] = useState(false)
  const [userData, setUserData] = useState({
    roleNameField: "",
    creationDateField: "",
    actionField: "",
  })

  const [roleDataList, setRoleDataList] = useState([])

  const [roleOptionsList] = useState([
    { label: "Super Admin", value: "super_admin" },
    { label: "Editor", value: "editor" },
  ])

  const [statusOptionsList] = useState([
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ])

  // Handle form submission for save or update
  const handleFormSubmission = () => {
    if (isEditModeActive) {
      // Update logic
      const updatedList = [...roleDataList]
      const roleIndex = updatedList.findIndex(
        role => role.roleNameField === userData.roleNameField
      )
      updatedList[roleIndex] = userData
      setRoleDataList(updatedList)
    } else {
      // Add new role logic
      setRoleDataList([...roleDataList, userData])
    }

    resetFormFields()
  }

  // Reset form data and hide form
  const resetFormFields = () => {
    setUserData({
      roleNameField: "",
      creationDateField: "",
      actionField: "",
    })
    setIsFormVisible(false)
    setaddrolespopup(false)
    setIsEditModeActive(false)
  }

  //pipeline start

  const [pipelineData, setPipelineData] = useState([]);
  const [isPipelineDialogVisible, setPipelineDialogVisible] = useState(false);
  const [currentPipeline, setCurrentPipeline] = useState({
    id: '',
    value: '',
    description: '',
    type: '',
    order: '',
    // pipeline: ''
  });
  const [isEditingPipeline, setIsEditingPipeline] = useState(false);
  const [paginationParams, setPaginationParams] = useState({ page: 0, rows: 10 });
  const [totalPipelineRecords, setTotalPipelineRecords] = useState(0);

  const fetchPipelineData = async (page = paginationParams.page, rows = paginationParams.rows) => {
    try {
      const response = await axios.get(
        `/api/v1/stages/?page=${page + 1}&size=${rows}`
      );
      if (response.status === 200) {
        const stages = response.data.results.map((stage) => ({
          id: stage.id,
          value: stage.name,
          description: stage.description || '-',
          type: stage.type,
          order: stage.order,
          // pipeline: stage.pipeline || ''
        }));
        setPipelineData(stages);
        // console.log("pipelineeeeeeeeeeee", response.data.count)
        setTotalPipelineRecords(response.data.count || 0);
      }
    } catch (error) {
      //console.error('Error fetching pipeline data:', error);
    }
  };

  const handleSavePipeline = async (data) => {
    if (data.value && data.order !== null && data.order !== undefined) {
      const order = Number(data.order); // Ensure order is a number
      if (isNaN(order) || order < 1 || order > 100) {
        triggerAlert('Order must be a number between 1 and 100.');
        return;
      }

      try {
        const pipelinePayload = {
          name: data.value,
          description: data.description,
          type: data.type,
          order: order,
          // pipeline: data.pipeline || '',
        };

        if (isEditingPipeline) {
          pipelinePayload.id = currentPipeline.id;
          await axios.put(
            `/api/v1/stages/${currentPipeline.id}/`,
            pipelinePayload
          );
          setPipelineData((prevData) =>
            prevData.map((item) =>
              item.id === currentPipeline.id ? { ...currentPipeline, ...data, order } : item
            )
          );
          triggerAlert('success', 'Success', 'Pipeline updated successfully.');
        } else {
          const response = await axios.post(
            `/api/v1/stages/`,
            pipelinePayload
          );
          const newPipeline = {
            id: response.data.id,
            value: response.data.name,
            description: response.data.description || '-',
            type: response.data.type,
            order: response.data.order,
            // pipeline: response.data.pipeline || '',
          };
          setPipelineData((prevData) => [...prevData, newPipeline]);
          triggerAlert('success', 'Success', 'Pipeline created successfully.');
        }
        handleCancelPipeline();
        fetchPipelineData()
      } catch (error) {
        //  console.error('Error saving pipeline:', error);
        triggerAlert('error', 'Error', error?.response.data?.error || error?.response.data?.name || 'An error occurred while saving the pipeline.');
        handleCancelPipeline();
      }
    } else {
      triggerAlert('error', 'Error', 'All required fields must be filled.');
    }
  };

  const handleCancelPipeline = () => {
    setPipelineDialogVisible(false);
    reset();
    setCurrentPipeline({ id: '', value: '', description: '', type: '', order: '' });
    setIsEditingPipeline(false);
  };

  const editPipelineIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          const pipelineData = {
            ...rowData,
            order: rowData.order ? Number(rowData.order) : null,
          };
          setCurrentPipeline(pipelineData);
          setPipelineDialogVisible(true);
          setIsEditingPipeline(true);
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setValue("order", rowData.order ? Number(rowData.order) : null);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const deletePipelineIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeletePipeline(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const handleDeletePipeline = (pipelineId) => {
    ConfirmationAlert('Are you sure you want to delete this pipeline?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/stages/${pipelineId}/`);
        triggerAlert('success', 'Success', 'Pipeline deleted successfully.');
        setPipelineData((prevData) => prevData.filter((item) => item.id !== pipelineId));
        fetchPipelineData()
      } catch (error) {
        console.error('Error deleting pipeline:', error);
        triggerAlert('error', 'Error', error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Failed to delete pipeline.');
        fetchPipelineData()
      }
      finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };



  const addNewPipeline = () => {
    setCurrentPipeline({ id: '', value: '', description: '', type: '', order: '' });
    setPipelineDialogVisible(true);
    setIsEditingPipeline(false);
    reset();
  };

  const onPageChange1 = (event) => {
    const newPaginationParams = { page: event.page, rows: event.rows };
    setPaginationParams(newPaginationParams);
    fetchPipelineData(newPaginationParams.page, newPaginationParams.rows);
  };

  // Resume source start 

  const [jobTitlesData, setJobTitlesData] = useState([])
  const [isEditDialogVisible, setEditDialogVisible] = useState(false)
  const [currentJobTitle, setCurrentJobTitle] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditing, setIsEditing] = useState(false)
  const [lazyParamsResume, setLazyParamsResume] = useState({ page: 0, rows: 10 });
  const [totalRecordsResume, setTotalRecordsResume] = useState(0);
  const [iconFile, setIconFile] = useState(null);
  const [iconError, setIconError] = useState(""); // like other validation fields

  const onPageResume = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setLazyParamsResume(newLazyParams);
    fetchResumeSource(newLazyParams.page, newLazyParams.rows);
  }

  const fetchResumeSource = async (page = lazyParamsResume.page, rows = lazyParamsResume.rows) => {
    try {
      const response = await axios.get(`/api/v1/resume-source/?page=${page + 1}&size=${rows}`);
      const sources = response.data.results.map(source => ({
        id: source.source_id,
        value: source.resume_source,
        description: source.description,
        type: source.type || 'user',
        iconFilename: source.icon_original_name || "",
        iconUrl: source.icon || "" // actual file link
      }));
      setJobTitlesData(sources);
      setTotalRecordsResume(response.data.count || 0);
    } catch (error) {
      // console.error('Error fetching data:', error);
    }
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(',')[1]); // just base64 part
      reader.onerror = error => reject(error);
    });
  };

  const handleSaveJobTitle = async (data) => {
    try {
      // Must have iconFile if adding
      let iconBase64 = null;
      let iconFilename = null;

      if (!isEditing && !data.iconFile) {
        setError("iconFile", { type: "manual", message: "Upload is required." });
        return;
      }

      if (data.iconFile) {
        iconBase64 = await fileToBase64(data.iconFile);
        iconFilename = data.iconFile.name;
      }

      const payload = {
        resume_source: data.value,
        description: data.description,
        type: data.type,
      };
      if (iconBase64 && iconFilename) {
        payload.icon_base64 = iconBase64;
        payload.icon_filename = iconFilename;
      }

      let response;
      if (isEditing) {
        response = await axios.put(`/api/v1/resume-source/${currentJobTitle.id}/`, payload);
      } else {
        response = await axios.post(`/api/v1/resume-source/`, payload);
      }

      triggerAlert('success', 'Success', 'Resume source updated successfully.');
      handleCancelJobTitle();
      fetchResumeSource();
    } catch (error) {
      // console.log(error)
      handleCancelJobTitle();
      triggerAlert('error', 'Error', error?.response.data?.error || error?.response.data?.resume_source || 'Failed to delete resume source.');
    }
  };


  const handleDeleteResume = (resumeId) => {
    ConfirmationAlert('Are you sure you want to delete this resume source?', 'Delete', async () => {
      try {
        await axios.delete(`/api/v1/resume-source/${resumeId}/`, {

        });
        triggerAlert('success', 'Success', 'Resume source deleted successfully.');
        setJobTitlesData(prevData => prevData.filter(resume => resume.id !== resumeId));
        fetchResumeSource()
      } catch (error) {
        triggerAlert('error', 'Error', error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || 'Failed to delete resume source.');
        handleCancelJobTitle();
      }
    });
  };

  // Handle canceling the operation
  const handleCancelJobTitle = () => {
    setEditDialogVisible(false);
    reset();
    setCurrentJobTitle({ id: "", value: "", description: "", type: "", iconFilename: "" });
    setIconFile(null);
    setIconError("");
    setIsEditing(false);
  };

  const editJobTitleIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentJobTitle({ ...rowData });
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setEditDialogVisible(true);
          setIsEditing(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const deleteJobTitleIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => {
          handleDeleteResume(rowData.id)
        }}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new job title button
  const addNewJobTitle = () => {
    setCurrentJobTitle({ id: "", value: "", description: "", type: "" });
    reset();
    setEditDialogVisible(true);
    setIsEditing(false);
  };

  // city start
  const [citiesData, setCitiesData] = useState([])
  const [isCityEditDialogVisible, setCityEditDialogVisible] = useState(false)
  const [currentCity, setCurrentCity] = useState({
    id: "",
    name: "",
    state: "",
    type: "",
  })
  const [isCityEditing, setCityEditing] = useState(false);
  const [cityLazyParams, setCityLazyParams] = useState({ page: 0, rows: 10 });
  const [cityTotalRecords, setCityTotalRecords] = useState(0);

  // Define city type options


  const onPageCity = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setCityLazyParams(newLazyParams);
    fetchAddressCity(newLazyParams.page, newLazyParams.rows);
  }

  const fetchAddressCity = async (page = cityLazyParams.page, rows = cityLazyParams.rows) => {
    const stateObj = statesData.find(s => s.id === selectedState);
    const state_name = stateObj ? stateObj.state_name : "Unknown";
    try {
      const response = await axios.get(`/api/v1/cities/?page=${page + 1}&size=${rows}`);

      if (response.status === 200) {
        const cities = response.data.results.map(city => ({
          id: city.city_id,
          name: city.name,
          state_name: city.state_name,
          state: city.state,
          type: city.type,
        }));
        setCitiesData(cities);
        setCityTotalRecords(response.data.count || 0);
      } else {
        ////console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      ////console.error('Error fetching city data:', error);
    }
  };

  // Handle saving a job title (either add or edit)
  const handleSaveCity = async (data) => {
    try {
      //const stateId = isCityEditing ? currentCity.state : selectedState;
      const cityPayload = {
        name: data.name,
        state: selectedState,
        type: data.type,
      };

      let response;
      if (isCityEditing) {
        response = await axios.put(
          `/api/v1/cities/${currentCity.id}/`,
          cityPayload
        );

        setCitiesData(prevData =>
          prevData.map(item =>
            item.id === currentCity.id ? { ...currentCity, ...data } : item
          )
        );
        triggerAlert('success', 'Success', 'City updated successfully.');
        handleCancelCity();

      } else {
        response = await axios.post(
          `/api/v1/cities/`,
          cityPayload
        );

        const newCity = {
          id: response.data.id,
          name: response.data.name,
          state: response.data.state,
          type: response.data.type,
        };
        setCitiesData(prevData => [...prevData, newCity]);
        triggerAlert('success', 'Success', 'City created successfully.');
      }
      handleCancelCity();
      fetchAddressCity()
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.name || 'Failed to created city');
      handleCancelCity();
    }
  };

  // Handle canceling the operation
  const handleCancelCity = () => {
    setCityEditDialogVisible(false);
    setCurrentCity({ id: "", name: "", state: "", type: "" });
    setSelectedCountry('')
    setCityEditing(false);
    reset()
  };
  // Edit button
  const editCityIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          // Set the current city data
          setCurrentCity({ ...rowData });

          // Set the form values
          setValue("name", rowData.name);
          setSelectedState(rowData.state);
          setValue("type", rowData.type)
          //setValue("state", rowData.state_name); // Use state_name directly

          // Show the dialog
          setCityEditDialogVisible(true);
          setCityEditing(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const handleDeleteCity = (cityId) => {
    if (!cityId) {
      triggerAlert('warning', 'Warning', 'Invalid City ID.');
      return;
    }
    ConfirmationAlert('Are you sure you want to delete this city?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/cities/${cityId}/`, {

        });

        triggerAlert('success', 'Success', 'City deleted successfully.');
        setCitiesData(prevData => prevData.filter(city => city.id !== cityId));
        fetchAddressCity()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete city. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      }
      finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  const deleteCityIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteCity(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  // Add new city button
  const addNewCity = () => {
    setCurrentCity({ id: "", name: "", state: "", type: "" });
    setSelectedState(null);
    reset();
    setCityEditDialogVisible(true);
    setCityEditing(false);
  };



  // Address State

  const [loadingCountries, setLoadingCountries] = useState(false);
  const [statesData, setStatesData] = useState([])
  const [isStateEditDialogVisible, setStateEditDialogVisible] = useState(false)
  const [currentEditingState, setCurrentEditingState] = useState({
    id: "",
    name: "",
    country_name: "",
    type: ""

  })
  const [isStateEditing, setIsStateEditing] = useState(false);
  const [stateLazyParams, setStateLazyParams] = useState({ page: 0, rows: 10 });
  const [stateTotalRecords, setStateTotalRecords] = useState(0);

  // Define type options


  const onPageState = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setStateLazyParams(newLazyParams);
    fetchAddressState(newLazyParams.page, newLazyParams.rows);
  };

  const fetchAddressState = async (page = stateLazyParams.page, rows = stateLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/states/?page=${page + 1}&size=${rows}`);

      if (response.status === 200) {
        const states = response.data.results.map(state => ({
          id: state.state_id,
          name: state.name,
          country: state.country,
          country_name: state.country_name,
          type: state.type
        }));
        setStatesData(states);
        setStateTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching state data:', error);
    }
  };

  // Handle saving a state (either add or edit)
  const handleSaveState = async (data) => {
    try {
      const countryObj = countriesData.find((c) => c.id === data.country) || { name: "Unknown" };
      const countryName = countryObj.name;

      const statePayload = {
        name: data.name,
        country: data.country,
        country_name: countryName,
        type: data.type
      };

      let response;
      if (isStateEditing) {
        response = await axios.put(
          `/api/v1/states/${currentEditingState.id}/`,
          statePayload
        );

        // Update statesData with the API response
        setStatesData((prevData) =>
          prevData.map((item) =>
            item.id === currentEditingState.id
              ? {
                id: response.data.state_id,
                name: response.data.name,
                country: response.data.country,
                country_name: response.data.country_name,
                type: response.data.type // Use API response
              }
              : item
          )
        );
        triggerAlert("success", "Success", "State updated successfully.");
        handleCancelState();
      } else {
        response = await axios.post(
          `/api/v1/states/`,
          statePayload
        );

        const newState = {
          id: response.data.id,
          name: response.data.name,
          country: response.data.country_id,
          country_name: response.data.country_name,
          type: response.data.type
        };
        setStatesData((prevData) => [...prevData, newState]);
        triggerAlert("success", "Success", "State created successfully.");
      }
      handleCancelState();
      fetchAddressState()
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response.data.non_field_errors);
      handleCancelState();
    }
  };

  // Handle canceling the operation
  const handleCancelState = () => {
    setStateEditDialogVisible(false);
    setCurrentEditingState({ id: "", name: "", country: "", type: "" });
    setSelectedCountry(null);
    setIsStateEditing(false);
    reset({ country: null, name: "" }); // Reset form with default values
  };

  const editStateIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={async () => {
          // Ensure addCountries is populated
          if (!addCountries.length) {
            await getaddCountries();
          }

          // Use country ID if available, otherwise find by country_name
          const selectedCountryId = rowData.country || (
            addCountries.find((country) => country.name === rowData.country_name)?.id || null
          );

          // Set the current editing state
          setCurrentEditingState({ ...rowData });

          // Set form values
          setValue("name", rowData.name);
          setValue("country", selectedCountryId);
          setValue("type", rowData.type)

          // Set selectedCountry
          setSelectedCountry(selectedCountryId);

          // Open the dialog and set editing mode
          setStateEditDialogVisible(true);
          setIsStateEditing(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  // Delete button

  const handleDeleteState = (stateId) => {
    ConfirmationAlert('Are you sure you want to delete this state?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/states/${stateId}/`);

        triggerAlert('success', 'Success', 'State deleted successfully.');
        setStatesData(prevData => prevData.filter(state => state.id !== stateId));
        fetchAddressState()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete state. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      }
      finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const deleteStateIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteState(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>

  );


  // Add new state button
  const addNewState = () => {
    setCurrentEditingState({ id: "", name: "", country: "", type: "" });
    reset();
    setSelectedCountry(null);
    setStateEditDialogVisible(true);
    setIsStateEditing(false);
    getaddCountries();
  };

  // Address country start
  const [countriesData, setCountriesData] = useState([])
  const [isCountryDialogVisible, setCountryDialogVisible] = useState(false)
  const [currentCountry, setCurrentCountry] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isCountryBeingEdited, setCountryBeingEdited] = useState(false)
  const [countryLazyParams, setCountryLazyParams] = useState({ page: 0, rows: 10 });
  const [countryTotalRecords, setCountryTotalRecords] = useState(0);

  const fetchAddressCountry = async (page = countryLazyParams.page, rows = countryLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/countries/?page=${page + 1}&size=${rows}`
      );
      if (response.status === 200) {
        const countries = response.data.results.map(country => ({
          id: country.country_id,
          name: country.name,
          description: country.name,
          type: country.type,
        }));
        setCountriesData(countries);
        setCountryTotalRecords(response.data.count || 0);
      } else {
        ////console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      ////console.error('Error fetching country data:', error);
    }
  };



  const onPageCountry = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setCountryLazyParams(newLazyParams);
    fetchAddressCountry(newLazyParams.page, newLazyParams.rows);
  };
  useEffect(() => {
    fetchAddressCountry()
    fetchAddressState();
  }, [])

  const handleSaveCountry = async () => {
    // Ensure name is not empty
    if (!currentCountry.name.trim()) {
      setCountryDialogVisible(false);
      triggerAlert('error', 'Error', 'Please provide a valid country name.');
      handleCancelCountry();
      return;
    }

    // Ensure type has a valid value
    if (!currentCountry.type) {
      currentCountry.type = ''; // Default to "Country" if empty
    }

    // Auto-fill description if missing
    if (!currentCountry.description) {
      currentCountry.description = currentCountry.name;
    }

    try {
      if (isCountryBeingEdited) {
        await axios.put(
          `/api/v1/countries/${currentCountry.id}/`,
          {
            name: currentCountry.name,
            description: currentCountry.description,
            type: currentCountry.type,
          }
        );

        setCountriesData(prevData =>
          prevData.map(item => (item.id === currentCountry.id ? { ...currentCountry } : item))
        );

        triggerAlert('success', 'Success', 'Country updated successfully.');
        handleCancelCountry();
      } else {
        const response = await axios.post(
          `/api/v1/countries/`,
          {
            name: currentCountry.name,
            description: currentCountry.description,
            type: currentCountry.type,
          }
        );

        setCountriesData(prevData => [...prevData, { ...currentCountry, id: response.data.id }]);

        triggerAlert('success', 'Success', 'Country created successfully.');
        fetchAddressCountry()
      }

      handleCancelCountry();
    } catch (error) {
      setCountryDialogVisible(false);
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.name);
      handleCancelCountry();
    }
  };


  const editCountryIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentCountry({ ...rowData });
          setValue("name", rowData.name);
          setValue("type", rowData.type)
          setCountryDialogVisible(true);
          setCountryBeingEdited(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const handleCancelCountry = () => {
    setCountryDialogVisible(false);
    setCurrentCountry({ id: "", name: "", description: "", type: "" });
    setCountryBeingEdited(false);
    reset();
  };


  const deleteCountryIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteCountry(rowData.id)} // Pass only rowData.id
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const handleDeleteCountry = (countryId) => {
    ConfirmationAlert('Are you sure you want to delete this country?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/countries/${countryId}/`
        );

        triggerAlert('success', 'Success', 'Country deleted successfully.');
        setCountriesData(prevData => prevData.filter(country => country.id !== countryId));
        fetchAddressCountry()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete country. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const addNewCountry = () => {
    setCurrentCountry({ id: "", name: "", description: "", type: "" });
    reset();
    setCountryDialogVisible(true);
    setCountryBeingEdited(false);
  };



  // Address country end


  //Address Label start
  const [addressLabelsData, setAddressLabelsData] = useState([])
  const [isAddressLabelEditDialogVisible, setAddressLabelEditDialogVisible] =
    useState(false)
  const [currentAddressLabel, setCurrentAddressLabel] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingAddressLabel, setIsEditingAddressLabel] = useState(false)
  const [addressLazyParams, setAddressLazyParams] = useState({ page: 0, rows: 10 });
  const [addressTotalRecords, setAddressTotalRecords] = useState(0);

  const onPageAddress = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setAddressLazyParams(newLazyParams);
    fetchAddrLabel(newLazyParams.page, newLazyParams.rows);
  };

  const fetchAddrLabel = async (page = addressLazyParams.page, rows = addressLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/address-label/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const address = response.data.results.map(skill => ({
          id: skill.id,
          value: skill.address_label,
          description: skill.description,
          type: skill.type,
        }));
        setAddressLabelsData(address);
        setAddressTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };

  // Handle saving an address label (either add or edit)
  const handleSaveAddressLabel = async (data) => {
    try {
      const addressPayload = {
        address_label: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingAddressLabel) {
        // Update existing skill
        response = await axios.put(
          `/api/v1/address-label/${currentAddressLabel.id}/`,
          addressPayload
        );

        setAddressLabelsData(prevData =>
          prevData.map(item =>
            item.id === currentAddressLabel.id ? { ...item, ...data } : item
          )
        );
        handleCancelAddressLabel();
        triggerAlert('success', 'Success', 'Address Label updated successfully.');
      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/address-label/`,
          addressPayload

        );

        const newSkill = {
          id: response.data.id,
          value: response.data.address_label,
          description: response.data.description,
          type: response.data.type,
        };
        setAddressLabelsData(prevData => [...prevData, newSkill]);
        triggerAlert('success', 'Success', 'Address Label created successfully.');
        fetchAddrLabel()
      }
      handleCancelAddressLabel(); // Close modal on success
    } catch (error) {
      handleCancelAddressLabel();
      // console.log("erooooooooooo", error);
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.address_label || "Failed to create address label");
    }
  };

  // Handle canceling the operation
  const handleCancelAddressLabel = () => {
    setAddressLabelEditDialogVisible(false)
    setCurrentAddressLabel({ id: "", label: "", output: "", type: "" })
    setIsEditingAddressLabel(false);
    clearErrors();
  }

  // Edit button
  const editAddressLabelIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setValue("value", rowData.value); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setCurrentAddressLabel({ ...rowData })
          setAddressLabelEditDialogVisible(true)
          setIsEditingAddressLabel(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const handleDeleteAdr = (addrId) => {
    ConfirmationAlert('Are you sure you want to delete this address label?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/address-label/${addrId}/`
        );

        setAddressLabelsData(prevData => prevData.filter(skill => skill.id !== addrId));
        triggerAlert('success', 'Success', 'Address Label deleted successfully.');
        fetchAddrLabel();
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete address label. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  // Delete button
  const deleteAddressLabelIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteAdr(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new address label button
  const addNewAddressLabel = () => {
    reset({ value: "", description: "", type: "" });
    setCurrentAddressLabel({ id: "", value: "", description: "", type: "" })
    setAddressLabelEditDialogVisible(true)
    setIsEditingAddressLabel(false)
  }

  // Address Label end

  // Skill start

  const [skillsData, setSkillsData] = useState([])
  const [isSkillEditDialogVisible, setSkillEditDialogVisible] = useState(false)
  const [currentSkill, setCurrentSkill] = useState({
    id: "",
    name: "",
    description: "",
    type: "", // Added type field
  })
  const [isEditingSkill, setIsEditingSkill] = useState(false);
  const [skillsLazyParams, setSkillsLazyParams] = useState({ page: 0, rows: 10 });
  const [skillsTotalRecords, setSkillsTotalRecords] = useState(0);

  // Define skill type options

  const onPageSkills = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setSkillsLazyParams(newLazyParams);
    fetchSkills(newLazyParams.page, newLazyParams.rows);
  };

  // Fetch data from the API
  const fetchSkills = async (page = skillsLazyParams.page, rows = skillsLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/skills/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const skills = response.data.results.map(skill => ({
          id: skill.skill_id,
          name: skill.skill_name,
          description: skill.description,
          type: skill.type,
        }));
        setSkillsData(skills);
        setSkillsTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };
  // Handle saving a skill (either add or edit)
  const handleSaveSkill = async (data) => {
    try {
      const skillPayload = {
        skill_name: data.name,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingSkill) {
        // Update existing skill
        response = await axios.put(
          `/api/v1/skills/${currentSkill.id}/`,
          skillPayload
        );

        setSkillsData(prevData =>
          prevData.map(item =>
            item.id === currentSkill.id ? { ...item, ...data } : item
          )
        );
        handleCancelSkill();
        triggerAlert('success', 'Success', 'Skill updated successfully.');
      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/skills/`,
          skillPayload

        );

        const newSkill = {
          id: response.data.skill_id,
          name: response.data.skill_name,
          description: response.data.description,
          type: response.data.type,
        };
        setSkillsData(prevData => [...prevData, newSkill]);
        triggerAlert('success', 'Success', 'Skill created successfully.');
        fetchSkills()
      }
      handleCancelSkill(); // Close modal on success
    } catch (error) {
      handleCancelSkill();
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.skill_name);
    }
  };

  // Handle canceling the operation
  const handleCancelSkill = () => {
    setSkillEditDialogVisible(false);
    setCurrentSkill({ id: "", name: "", description: "", type: "" });
    setIsEditingSkill(false);
  };
  // Edit button
  const editSkillIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentSkill({ ...rowData });
          setValue("name", rowData.name); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setSkillEditDialogVisible(true);
          setIsEditingSkill(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );


  //Delete function
  const handleDeleteSkill = (skillId) => {
    ConfirmationAlert('Are you sure you want to delete this skill?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/skills/${skillId}/`
        );

        setSkillsData(prevData => prevData.filter(skill => skill.id !== skillId));
        triggerAlert('success', 'Success', 'Skill deleted successfully.');
        fetchSkills();
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete skill. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };
  // Delete button
  const deleteSkillIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteSkill(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new skill button
  const addNewSkill = () => {
    reset({ name: "", description: "", type: "" });
    setCurrentSkill({ id: "", name: "", description: "", type: "" });
    setSkillEditDialogVisible(true);
    setIsEditingSkill(false);
    clearErrors
  };


  // Skill end

  // Employee type start

  const [employeesData, setEmployeesData] = useState([])
  const [isEmployeeEditDialogVisible, setEmployeeEditDialogVisible] =
    useState(false)
  const [currentEmployee, setCurrentEmployee] = useState({
    id: "",
    value: "",
    description: "",
    type: "", // Added type field
  })
  const [isEditingEmployee, setIsEditingEmployee] = useState(false);
  const [employeesLazyParams, setEmployeesLazyParams] = useState({ page: 0, rows: 10 });
  const [employeesTotalRecords, setEmployeesTotalRecords] = useState(0);

  // Define employee type options

  const onPageEmployees = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setEmployeesLazyParams(newLazyParams);
    fetchEmployeeType(newLazyParams.page, newLazyParams.rows);
  };

  const fetchEmployeeType = async (page = employeesLazyParams.page, rows = employeesLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/employee-type/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const employees = response.data.results.map(employee => ({
          id: employee.id,
          name: employee.employee_type,
          description: employee.description,
          type: employee.type || 'user',
        }));
        setEmployeesData(employees);
        setEmployeesTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching employees data:', error);
    }
  };


  // Handle saving an employee (either add or edit)
  const handleSaveEmployee = async (data) => {
    try {
      const req = {
        employee_type: data.name,
        description: data.description,
        type: data.type,
      };

      let response;
      let updatedData;

      if (isEditingEmployee) {
        // Update existing employee
        response = await axios.put(
          `/api/v1/employee-type/${currentEmployee.id}/`,
          req
        );

        updatedData = employeesData.map(item =>
          item.id === currentEmployee.id ? { ...data, id: currentEmployee.id } : item
        );
        triggerAlert('success', 'Success', 'Employee type updated successfully.');
        setEmployeesData(updatedData);
        handleCancelEmployee();
      } else {
        // Add new employee
        response = await axios.post(
          `/api/v1/employee-type/`,
          req
        );

        const newEmployee = {
          id: response.data.id,
          name: response.data.employee_type,
          description: response.data.description,
          type: response.data.type,
        };
        updatedData = [...employeesData, newEmployee];
        triggerAlert('success', 'Success', 'Employee type created successfully.');
        setEmployeesData(updatedData);
        handleCancelEmployee();
        fetchEmployeeType()

      }

      handleCancelEmployee(); // Close modal on success
    } catch (error) {
      // console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.employee_type
      );
      handleCancelEmployee(); // Close modal on failure
    }
  };


  // Handle canceling the operation
  const handleCancelEmployee = () => {
    setEmployeeEditDialogVisible(false)
    setCurrentEmployee({ id: "", value: "", description: "", type: "" })
    setIsEditingEmployee(false);
    reset();
  }

  // Edit button
  const editEmployeeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentEmployee({ ...rowData });
          setValue("name", rowData.name);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setEmployeeEditDialogVisible(true)
          setIsEditingEmployee(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )
  const handleDeleteEmployee = (employeeId) => {
    ConfirmationAlert('Are you sure you want to delete this employee type?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/employee-type/${employeeId}/`);

        triggerAlert('success', 'Success', 'Employee type deleted successfully.');
        setEmployeesData(prevData => prevData.filter(employee => employee.id !== employeeId));
        fetchEmployeeType()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete employee type. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };



  const deleteEmployeeIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteEmployee(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );


  // Add new employee button
  const addNewEmployee = () => {
    setCurrentEmployee({ id: "", name: "", description: "", type: "" })
    reset();
    setEmployeeEditDialogVisible(true)
    setIsEditingEmployee(false);
    clearErrors();

  }

  // Employee type end

  // Source type start

  const [sourcesData, setSourcesData] = useState([])
  const [isSourceEditDialogVisible, setSourceEditDialogVisible] =
    useState(false)
  const [currentSource, setCurrentSource] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isEditingSource, setIsEditingSource] = useState(false)

  // Define source type options


  // Handle saving a source (either add or edit)
  const handleSaveSource = () => {
    if (currentSource.name && currentSource.description && currentSource.type) {
      if (isEditingSource) {
        // Update existing source
        setSourcesData(prevData =>
          prevData.map(item =>
            item.id === currentSource.id ? { ...currentSource } : item
          )
        )
      } else {
        // Add new source with a unique id
        const newSource = {
          ...currentSource,
          id: Date.now().toString(),
        }
        setSourcesData(prevData => [...prevData, newSource])
      }
      handleCancelSource()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  // Handle canceling the operation
  const handleCancelSource = () => {
    setSourceEditDialogVisible(false)
    setCurrentSource({ id: "", name: "", description: "", type: "" })
    setIsEditingSource(false)
  }

  // Edit button
  const editSourceIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentSource({ ...rowData })
          setSourceEditDialogVisible(true)
          setIsEditingSource(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Delete button
  const deleteSourceIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => {
          setSourcesData(prevData =>
            prevData.filter(item => item.id !== rowData.id)
          )
        }}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new source button
  const addNewSource = () => {
    setCurrentSource({ id: "", name: "", description: "", type: "" })
    setSourceEditDialogVisible(true)
    setIsEditingSource(false)
  }

  // Source type end

  // Reffered by start

  const [referredData, setReferredData] = useState([])
  const [isReferredEditDialogVisible, setReferredEditDialogVisible] =
    useState(false)
  const [currentReferred, setCurrentReferred] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isEditingReferred, setIsEditingReferred] = useState(false);
  const [reffredLazyParams, setRefferedLazyParams] = useState({ page: 0, rows: 10 });
  const [reffredTotalRecords, setReffredTotalRecords] = useState(0);

  const onPageReffer = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setRefferedLazyParams(newLazyParams);
    fetchReffredBy(newLazyParams.page, newLazyParams.rows);
  };

  // Fetch data from the API
  const fetchReffredBy = async (page = reffredLazyParams.page, rows = reffredLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/create-referred-by/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const reffered = response.data.results.map((reffer) => ({
          id: reffer.id,
          name: reffer.value,
          description: reffer.description,
          type: reffer.type,
        }));
        setReferredData(reffered);
        setReffredTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };
  // Handle saving a referred (either add or edit)
  const handleSaveReferred = async (data) => {
    try {
      const reffredPayload = {
        value: data.name,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingReferred) {
        response = await axios.put(
          `/api/v1/create-referred-by/${currentReferred.id}/`,
          reffredPayload
        );

        setReferredData(prevData =>
          prevData.map(item =>
            item.id === currentReferred.id ? { ...item, ...data } : item
          )
        );
        triggerAlert('success', 'Success', 'Referred by updated successfully.');
        handleCancelReferred();

      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/create-referred-by/`,
          reffredPayload

        );
        if (response.status === 201) {
          triggerAlert('success', 'Success', 'Referred by created successfully.');
          const newReffer = {
            id: response.data.id,
            name: response.data.value,
            description: response.data.description,
            type: response.data.type,
          };
          setReferredData(prevData => [...prevData, newReffer]);
        }

      }
      handleCancelReferred(); // Close modal on success
      fetchReffredBy()
    } catch (error) {
      console.log(error)
      handleCancelReferred();
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.value || "Failed to create a Reffered by");
    }
  };

  // Handle canceling the operation
  const handleCancelReferred = () => {
    setReferredEditDialogVisible(false)
    setCurrentReferred({ id: "", name: "", description: "", type: "" })
    setIsEditingReferred(false)
    clearErrors();
  }

  // Edit button
  const editReferredIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentReferred({ ...rowData });
          setValue("name", rowData.name); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setReferredEditDialogVisible(true)
          setIsEditingReferred(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const handleDeleteReffered = (refferedId) => {
    ConfirmationAlert('Are you sure you want to delete this reffered by?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/create-referred-by/${refferedId}/`
        );

        setReferredData(prevData => prevData.filter(reffer => reffer.id !== refferedId));
        triggerAlert('success', 'Success', 'Reffered by deleted successfully.');
        fetchReffredBy();
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete reffered. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  // Delete button
  const deleteReferredIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteReffered(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new referred button
  const addNewReferred = () => {
    reset({ name: "", description: "", type: "" });
    setCurrentReferred({ id: "", name: "", description: "", type: "" })
    setReferredEditDialogVisible(true)
    setIsEditingReferred(false)
  }

  // Reffered by end

  // Doc type start

  const [docTypeData, setDocTypeData] = useState([])
  const [isDocTypeEditDialogVisible, setDocTypeEditDialogVisible] =
    useState(false)
  const [currentDocType, setCurrentDocType] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isEditingDocType, setIsEditingDocType] = useState(false)
  const [docLazyParams, setDocLazyParams] = useState({ page: 0, rows: 10 });
  const [docTotalRecords, setDocTotalRecords] = useState(0);

  // Define Doc. Type options
  const onPageDoc = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setDocLazyParams(newLazyParams);
    fetchDocuments(newLazyParams.page, newLazyParams.rows);
  };

  // Fetch data from the API
  const fetchDocuments = async (page = docLazyParams.page, rows = docLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/document-type/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const documents = response.data.results.map(docu => ({
          id: docu.id,
          name: docu.value,
          description: docu.description,
          type: docu.type,
        }));
        setDocTypeData(documents);
        setDocTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };
  // Handl

  // Handle saving a Doc. Type (either add or edit)
  const handleSaveDocu = async (data) => {
    try {
      const docuPayload = {
        value: data.name,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingDocType) {
        // Update existing skill
        response = await axios.put(
          `/api/v1/document-type/${currentDocType.id}/`,
          docuPayload
        );

        setDocTypeData(prevData =>
          prevData.map(item =>
            item.id === currentDocType.id ? { ...item, ...data } : item
          )
        );
        handleCancelDocType();
        triggerAlert('success', 'Success', 'Documents updated successfully.');
        fetchDocuments();
      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/document-type/`,
          docuPayload

        );

        const newSkill = {
          id: response.data.id,
          name: response.data.value,
          description: response.data.description,
          type: response.data.type,
        };
        setDocTypeData(prevData => [...prevData, newSkill]);
        triggerAlert('success', 'Success', 'Documents created successfully.');
        fetchDocuments();
      }
      handleCancelDocType(); // Close modal on success
    } catch (error) {
      //console.log(error)
      handleCancelDocType();
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.value || "Failed to create document type");
    }
  };


  // Handle canceling the operation
  const handleCancelDocType = () => {
    setDocTypeEditDialogVisible(false)
    setCurrentDocType({ id: "", name: "", description: "", type: "" })
    setIsEditingDocType(false);
    clearErrors();
  }

  // Edit button
  const editDocTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setValue("name", rowData.name); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setCurrentDocType({ ...rowData })
          setDocTypeEditDialogVisible(true)
          setIsEditingDocType(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const handleDeleteDocu = (docId) => {
    ConfirmationAlert('Are you sure you want to delete this document?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/document-type/${docId}/`
        );

        setDocTypeData(prevData => prevData.filter(doc => doc.id !== docId));
        triggerAlert('success', 'Success', 'Document deleted successfully.');
        fetchDocuments();
      } catch (error) {
        console.log("eroooo", error.response?.data)
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete document. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  // Delete button
  const deleteDocTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteDocu(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new Doc. Type button
  const addNewDocType = () => {
    reset({ id: "", name: "", description: "", type: "" });
    setCurrentDocType({ id: "", name: "", description: "", type: "" })
    setDocTypeEditDialogVisible(true)
    setIsEditingDocType(false)
  }

  // Job type end

  // Degree start

  const [degreeData, setDegreeData] = useState([])
  const [isDegreeEditDialogVisible, setDegreeEditDialogVisible] =
    useState(false)
  const [currentDegree, setCurrentDegree] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingDegree, setIsEditingDegree] = useState(false);
  const [degreeLazyParams, setDegreeLazyParams] = useState({ page: 0, rows: 10 });
  const [degreeTotalRecords, setDegreeTotalRecords] = useState(0);


  const onPageDegree = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated Degree lazyParams:', newLazyParams);
    setDegreeLazyParams(newLazyParams);
    fetchDegree(newLazyParams.page, newLazyParams.rows);
  };

  const fetchDegree = async (page = degreeLazyParams.page, rows = degreeLazyParams.rows) => {
    ////console.log('Fetching Degree data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/degrees/`,

      );
      ////console.log('API Response:', response.data);
      if (response.status === 200) {
        const degrees = response.data.results.map((degree) => ({
          id: degree.id,
          value: degree.institution_type,
          description: degree.description,
          type: degree.type,
        }));
        setDegreeData(degrees);
        setDegreeTotalRecords(degrees.length);
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching degree data:', error.response ? error.response.data : error.message);
    }
  };

  const handleSaveDegree = async (data) => {
    if (!data.value) {
      setDegreeEditDialogVisible(false);
      triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
      return;
    }

    const degreePayload = {
      institution_type: data.value, // Use the correct field name
      description: data.description,
      type: data.type,
    };

    try {
      if (isEditingDegree) {
        // Update existing degree
        await axios.put(
          `/api/v1/degrees/${currentDegree.id}/`,
          degreePayload
        );
        triggerAlert('success', 'Success', 'Degree updated successfully.');
        handleCancelDegree();
        fetchDegree();
        setDegreeData((prevData) =>
          prevData.map((item) =>
            item.id === currentDegree.id ? { ...item, institution_type: data.value, description: data.description, type: data.type } : item
          )
        );
      } else {
        // Create a new degree
        const response = await axios.post(
          `/api/v1/degrees/`,
          degreePayload
        );
        triggerAlert('success', 'Success', 'Degree created successfully.');
        handleCancelDegree();

        // Add new degree
        setDegreeData((prevData) => [
          ...prevData,
          { id: response.data.id, institution_type: response.data.institution_type, description: response.data.description, type: response.data.type },
        ]);
        fetchDegree();
      }

      handleCancelDegree();
    } catch (error) {
      //console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.institution_type);
      handleCancelDegree();
    }
  };



  // Handle canceling the operation
  const handleCancelDegree = () => {
    setDegreeEditDialogVisible(false)
    setCurrentDegree({ id: "", value: "", description: "", type: "" })
    setIsEditingDegree(false)
    reset()
  }

  // Edit button
  const editDegreeIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          ////console.log('Editing row data:', rowData);
          setCurrentDegree({ ...rowData });
          setValue("value", rowData.value); // Use the correct field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setDegreeEditDialogVisible(true);
          setIsEditingDegree(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );


  //Delete function
  const handleDeleteDegree = (degreeId) => {
    if (!degreeId) {
      triggerAlert('warning', 'Warning', 'Invalid degree ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this degree?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/degrees/${degreeId}/`, {

        });

        triggerAlert('success', 'Success', 'Degree deleted successfully.');
        setDegreeData((prevData) => prevData.filter((degree) => degree.id !== degreeId));
        fetchDegree()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete degree. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  // Delete button
  const deleteDegreeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteDegree(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new Degree button
  const addNewDegree = () => {
    setCurrentDegree({ id: "", value: "", description: "", type: "" });
    reset();
    setDegreeEditDialogVisible(true)
    setIsEditingDegree(false)

  }

  // degree end


  // Institute start

  const [institutionData, setInstitutionData] = useState([])
  const [isInstitutionEditDialogVisible, setInstitutionEditDialogVisible] =
    useState(false)
  const [currentInstitution, setCurrentInstitution] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isEditingInstitution, setIsEditingInstitution] = useState(false)
  const [instiLazyParams, setInstiLazyParams] = useState({ page: 0, rows: 10 });
  const [instiTotalRecords, setInstiTotalRecords] = useState(0);

  // Define Institution type options
  const onPageInsti = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setInstiLazyParams(newLazyParams);
    fetchInstitution(newLazyParams.page, newLazyParams.rows);
  };

  const fetchInstitution = async (page = instiLazyParams.page, rows = instiLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/create-school/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const institution = response.data.results.map(insti => ({
          id: insti.id,
          name: insti.value,
          description: insti.description,
          type: insti.type,
        }));
        setInstitutionData(institution);
        setInstiTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };

  // Handle saving an Institution (either add or edit)
  const handleSaveInstitution = async (data) => {
    try {
      const instiPayload = {
        value: data.name,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingInstitution) {
        // Update existing skill
        response = await axios.put(
          `/api/v1/create-school/${currentInstitution.id}/`,
          instiPayload
        );

        setInstitutionData(prevData =>
          prevData.map(item =>
            item.id === currentInstitution.id ? { ...item, ...data } : item
          )
        );
        handleCancelInstitution();
        triggerAlert('success', 'Success', 'Institution updated successfully.');
      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/create-school/`,
          instiPayload

        );

        const newSkill = {
          id: response.data.id,
          name: response.data.value,
          description: response.data.description,
          type: response.data.type,
        };
        setInstitutionData(prevData => [...prevData, newSkill]);
        triggerAlert('success', 'Success', 'Institution created successfully.');
        fetchInstitution()
      }
      handleCancelInstitution(); // Close modal on success
    } catch (error) {
      // console.log(error)
      handleCancelInstitution();
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.value || "Failed to create institution");
    }
  };

  // Handle canceling the operation
  const handleCancelInstitution = () => {
    setInstitutionEditDialogVisible(false)
    setCurrentInstitution({ id: "", value: "", description: "", type: "" })
    setIsEditingInstitution(false);
    clearErrors();
  }

  // Edit button
  const editInstitutionIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setValue("name", rowData.name); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setCurrentInstitution({ ...rowData })
          setInstitutionEditDialogVisible(true)
          setIsEditingInstitution(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const handleDeleteInsti = (instiId) => {
    ConfirmationAlert('Are you sure you want to delete this institution?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/create-school/${instiId}/`
        );

        setInstitutionData(prevData => prevData.filter(skill => skill.id !== instiId));
        triggerAlert('success', 'Success', 'Intitution deleted successfully.');
        fetchInstitution();
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete Intitution. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };
  // Delete button
  const deleteInstitutionIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => {
          handleDeleteInsti(rowData.id)
        }}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new Institution button

  const addNewInstitution = () => {
    reset({ name: "", description: "", type: "" });
    setCurrentInstitution({ id: "", name: "", description: "", type: "" })
    setInstitutionEditDialogVisible(true)
    setIsEditingInstitution(false)
  }

  // institute end

  // Job status start


  const [jobStatusData, setJobStatusData] = useState([])
  const [isJobStatusDialogVisible, setJobStatusDialogVisible] = useState(false)
  const [currentJobStatus, setCurrentJobStatus] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingJobStatus, setIsEditingJobStatus] = useState(false)
  const [jobStatusLazyParams, setJobStatusLazyParams] = useState({ page: 0, rows: 10 });
  const [jobStatusTotalRecords, setJobStatusTotalRecords] = useState(0);

  // Define Job Status type options


  const onPageJobStatus = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated Degree lazyParams:', newLazyParams);
    setJobStatusLazyParams(newLazyParams);
    fetchJobStatus(newLazyParams.page, newLazyParams.rows);
  };

  const fetchJobStatus = async (page = jobStatusLazyParams.page, rows = jobStatusLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/job-status/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const jobStatus = response.data.results.map(status => ({
          id: status.id,
          value: status.job_status,
          description: status.description,
          type: status.type || 'user',
        }));
        setJobStatusData(jobStatus);
        setJobStatusTotalRecords(response.data.count || 0);
      } else {
        ////console.error('Unexpected status code:', response.status);
      }
    }
    catch (error) {
      ////console.error('Error fetching Job status data:', error);
    }

  }

  // Handle saving a Job Status (either add or edit)
  const handleSaveJobStatus = async (data) => {
    if (!data.value) {
      setJobStatusDialogVisible(false);
      triggerAlert('error', 'Missing Fields', 'Please fill all fields before saving.');
      return;
    }

    const jobStatusPayload = {
      job_status: data.value,
      description: data.description,
      type: data.type,
    };

    try {
      if (isEditingJobStatus) {
        await axios.put(
          `/api/v1/job-status/${currentJobStatus.id}/`,
          jobStatusPayload,
        );
        triggerAlert('success', 'Success', 'Job status updated successfully.');
        handleCancelJobStatus()
        setJobStatusData((prevData) =>
          prevData.map((item) =>
            item.id === currentJobStatus.id ? { ...data, id: currentJobStatus.id } : item
          )
        );
      } else {
        const response = await axios.post(
          `/api/v1/job-status/`,
          jobStatusPayload,
        );
        triggerAlert('success', 'Success', 'Job status created successfully.');
        setJobStatusData((prevData) => [
          ...prevData,
          { id: response.data.id, ...jobStatusPayload },
        ]);
      }
      handleCancelJobStatus();
      fetchJobStatus()
    } catch (error) {
      // console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.job_status);
      handleCancelJobStatus()
    }
  };


  // Handle canceling the operation
  const handleCancelJobStatus = () => {
    setJobStatusDialogVisible(false)
    setCurrentJobStatus({ id: "", value: "", description: "", type: "" })
    setIsEditingJobStatus(false)
  }

  // Edit button
  const editJobStatusIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          clearErrors();
          setCurrentJobStatus({ ...rowData })
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setJobStatusDialogVisible(true)
          setIsEditingJobStatus(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  //Delete function
  const handleDeleteJobStatus = (statusId) => {
    if (!statusId) {
      triggerAlert("warning", "Warning", "Invalid Job status ID.");
      return;
    }
    ConfirmationAlert(
      "Are you sure you want to delete this job status?",
      "Delete",
      async () => {
        setIsDeleting(true);
        try {
          await axios.delete(`/api/v1/job-status/${statusId}/`);
          triggerAlert("success", "Success", "Job status deleted successfully.");
          setJobStatusData((prevData) =>
            prevData.filter((status) => status.id !== statusId)
          );
          fetchJobStatus();
        } catch (error) {
          console.log("error", error)
          const errorMessage =
            error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message ||
            `Failed to delete job status. Status code: ${error.response?.status}` ||
            "Please try again.";
          triggerAlert("error", "Error", errorMessage);
        } finally {
          setIsDeleting(false); // Reset loading state
        }
      }
    );
  };

  // Delete button
  const deleteJobStatusIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteJobStatus(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  // Add new Job Status button
  const addNewJobStatus = () => {
    setCurrentJobStatus({ id: "", value: "", description: "", type: "" })
    reset();
    setJobStatusDialogVisible(true)
    setIsEditingJobStatus(false)
  }

  // Job status end

  // worktype start

  const [workTypeData, setWorkTypeData] = useState([])
  const [isWorkTypeDialogVisible, setWorkTypeDialogVisible] = useState(false)
  const [currentWorkType, setCurrentWorkType] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingWorkType, setIsEditingWorkType] = useState(false)
  const [workTypeLazyParams, setWorkTypeLazyParams] = useState({ page: 0, rows: 10 });
  const [workTypeTotalRecords, setWorkTypeTotalRecords] = useState(0);


  const onPageWorkType = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated WorkType lazyParams:', newLazyParams); // Debug log
    setWorkTypeLazyParams(newLazyParams);
    fetchWorkPlace(newLazyParams.page, newLazyParams.rows);
  };

  const fetchWorkPlace = async (page = workTypeLazyParams.page, rows = workTypeLazyParams.rows) => {
    ////console.log('Fetching Workplace Type data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/workplace-type/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const workPlaces = response.data.results.map((workPlace) => ({
          id: workPlace.id,
          value: workPlace.workplace_type,
          description: workPlace.description,
          type: workPlace.type || 'user', // Default to 'user' if type is missing
        }));
        setWorkTypeData(workPlaces);
        setWorkTypeTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching workplace type data:', error.response ? error.response.data : error.message);
    }
  };

  const handleSaveWorkType = async (data) => {
    try {
      const req = {
        workplace_type: data.value,
        description: data.description,
        type: data.type,
      };

      let response;
      if (isEditingWorkType) {
        response = await axios.put(
          `/api/v1/workplace-type/${currentWorkType.id}/`,
          req
        );
        setWorkTypeData((prevData) =>
          prevData.map((item) =>
            item.id === currentWorkType.id ? { ...item, ...data } : item
          )
        );
        triggerAlert('success', 'Success', 'Work type updated successfully.');
        handleCancelWorkType();
      } else {
        response = await axios.post(
          `/api/v1/workplace-type/`,
          req
        );

        triggerAlert('success', 'Success', 'Work type created successfully.');
        handleCancelWorkType();
        setWorkTypeData((prevData) => [
          ...prevData,
          { id: response.data.id, value: response.data.workplace_type, description: response.data.description, type: response.data.type },
        ]);
      }
      fetchWorkPlace()
    } catch (error) {
      // console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.workplace_type);
      handleCancelWorkType();
    }
  };


  const handleCancelWorkType = () => {
    setWorkTypeDialogVisible(false)
    setCurrentWorkType({ id: "", value: "", description: "", type: "" })
    setIsEditingWorkType(false);
    reset();
  }

  const editWorkTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentWorkType({ ...rowData })
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setWorkTypeDialogVisible(true)
          setIsEditingWorkType(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  //Delete function
  const handleDeleteWorkType = (workId) => {
    if (!workId) {
      triggerAlert('warning', 'Warning', 'Invalid work type ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this work type?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(`/api/v1/workplace-type/${workId}/`, {

        });

        triggerAlert('success', 'Success', 'Work type deleted successfully.');
        setWorkTypeData((prevData) => prevData.filter((workType) => workType.id !== workId));
        fetchWorkPlace()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete work type. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const deleteWorkTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteWorkType(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewWorkType = () => {
    setCurrentWorkType({ id: "", value: "", description: "", type: "" })
    reset();
    setWorkTypeDialogVisible(true)
    setIsEditingWorkType(false)
  }

  // work type end

  // Job type start

  const [jobTypeData, setJobTypeData] = useState([])
  const [isJobTypeDialogVisible, setJobTypeDialogVisible] = useState(false)
  const [currentJobType, setCurrentJobType] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingJobType, setIsEditingJobType] = useState(false)
  const [jobTypeLazyParams, setJobTypeLazyParams] = useState({ page: 0, rows: 10 });
  const [jobTypeTotalRecords, setJobTypeTotalRecords] = useState(0);



  const onPageJobType = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated JobType lazyParams:', newLazyParams);
    setJobTypeLazyParams(newLazyParams);
    fetchJobType(newLazyParams.page, newLazyParams.rows);
  };

  const fetchJobType = async (page = jobTypeLazyParams.page, rows = jobTypeLazyParams.rows) => {
    ////console.log('Fetching Job Type data with page:', page + 1, 'rows:', rows);
    try {
      const response = await axios.get(
        `/api/v1/job-type/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data);
      if (response.status === 200) {
        const jobTypes = response.data.results.map((jobType) => ({
          id: jobType.id,
          value: jobType.job_type,
          description: jobType.description,
          type: jobType.type || 'user',
        }));
        setJobTypeData(jobTypes);
        setJobTypeTotalRecords(response.data.count || 0);
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching job type data:', error.response ? error.response.data : error.message);
    }
  };


  const handleSaveJobType = async (data) => {
    ////console.log("Form data:", data);
    ////console.log("Current JobType:", currentJobType);

    // Use form data directly to ensure consistency
    const jobTypePayload = {
      job_type: data.value,
      description: data.description,
      type: data.type || "user", // Fallback to "user" if type is empty
    };

    ////console.log("Payload to API:", jobTypePayload); // Debug: Log payload

    // Validate payload
    if (!jobTypePayload.job_type) {
      triggerAlert("error", "Error", "Value is required.");
      handleCancelJobType();
      return;
    }

    try {
      let response;
      if (isEditingJobType) {
        // Update existing job type
        response = await axios.put(
          `/api/v1/job-type/${currentJobType.id}/`,
          jobTypePayload,

        );

        setJobTypeData((prevData) =>
          prevData.map((item) =>
            item.id === currentJobType.id
              ? { ...item, value: data.value, description: data.description, type: data.type }
              : item
          )
        );

        triggerAlert("success", "Success", "Job type updated successfully.");
        handleCancelJobType();
      } else {
        // Create a new job type
        response = await axios.post(
          `/api/v1/job-type/`,
          jobTypePayload,

        );

        setJobTypeData((prevData) => [
          ...prevData,
          {
            id: response.data.id,
            value: response.data.job_type,
            description: response.data.description,
            type: response.data.type,
          },
        ]);

        triggerAlert("success", "Success", "Job type created successfully.");
      }
      handleCancelJobType();
      fetchJobType()
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.job_type);
      handleCancelJobType();
    }
  };

  const handleCancelJobType = () => {
    setJobTypeDialogVisible(false)
    setCurrentJobType({ id: "", value: "", description: "", type: "" })
    setIsEditingJobType(false)
    reset();
  }

  const editJobTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentJobType({ ...rowData })
          setValue("value", rowData.value); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setJobTypeDialogVisible(true)
          setIsEditingJobType(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )
  //Delete function
  const handleDeleteJobType = (jobTypeId) => {
    if (!jobTypeId) {
      triggerAlert('warning', 'Warning', 'Invalid job type ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this job type?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/job-type/${jobTypeId}/`,

        );

        setJobTypeData((prevData) => prevData.filter((jobType) => jobType.id !== jobTypeId));
        fetchJobType()

        triggerAlert('success', 'Success', 'Job type deleted successfully.');
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete job type. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const deleteJobTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteJobType(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewJobType = () => {
    setCurrentJobType({ id: "", value: "", description: "", type: "" }); // Default type to "user"
    reset({ value: "", description: "", type: "" }); // Reset form with defaults
    setJobTypeDialogVisible(true);
    setIsEditingJobType(false);
  };
  // job type end

  ////// job function start ////////////////
  // Job type start
  const [jobFunctionData, setJobFunctionData] = useState([]);
  const [isJobFunctionDialogVisible, setJobFunctionDialogVisible] = useState(false);
  const [currentJobFunction, setCurrentJobFunction] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  });
  const [isEditingJobFunction, setIsEditingJobFunction] = useState(false);
  const [jobFunctionLazyParams, setJobFunctionLazyParams] = useState({ page: 0, rows: 10 }); // Default rows set to 5
  const [jobFunctionTotalRecords, setJobFunctionTotalRecords] = useState(0);


  const onPageJobFunction = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setJobFunctionLazyParams(newLazyParams);
    fetchJobFunction(newLazyParams.page, newLazyParams.rows);
  };

  const fetchJobFunction = async (page = jobFunctionLazyParams.page, rows = jobFunctionLazyParams.rows) => {
    ////console.log('Fetching Job Function data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/get-all-jobfunction-type/`
      );
      ////console.log('API Response:', response.data);
      if (response.status === 200) {
        const jobFunctions = response.data.results.map((jobFunction) => ({
          id: jobFunction.id,
          value: jobFunction.jobfunction_type,
          description: jobFunction.description,
          type: jobFunction.type || 'user',
        }));
        setJobFunctionData(jobFunctions);
        setJobFunctionTotalRecords(jobFunctions.length);
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching job function data:', error.response ? error.response.data : error.message);
    }
  };

  //functionality for create and edit
  const handleSaveJobFunction = async (data) => {
    try {
      const jobFunctionPayload = {
        jobfunction_type: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingJobFunction) {
        // Update existing job function
        await axios.put(
          `/api/v1/job-functions-type/${currentJobFunction.id}/`,
          jobFunctionPayload
        );

        setJobFunctionData((prevData) =>
          prevData.map((item) =>
            item.id === currentJobFunction.id ? { ...item, ...data } : item
          )
        );
        triggerAlert('success', 'Success', 'Job function updated successfully.');
        handleCancelJobFunction()
      } else {
        // Create a new job function
        response = await axios.post(
          `/api/v1/job-functions-type/`,
          jobFunctionPayload
        );
        triggerAlert('success', 'Success', 'Job function created successfully.');
        setJobFunctionData((prevData) => [
          ...prevData,
          { id: response.data.id, ...jobFunctionPayload },
        ]);
      }
      handleCancelJobFunction();
      fetchJobFunction()
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.jobfunction_type);
      handleCancelJobFunction()
    }
  };

  //  Reset Dialog & State
  const handleCancelJobFunction = () => {
    setJobFunctionDialogVisible(false);
    setCurrentJobFunction({ id: "", value: "", description: "", type: "" });
    setIsEditingJobFunction(false);
    reset();
  };

  //  Edit Button
  const editJobFunction = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentJobFunction({ ...rowData });
          setValue("value", rowData.value); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setJobFunctionDialogVisible(true);
          setIsEditingJobFunction(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  //  Delete Job Function
  const handleDeleteJobFunction = (jobFunctionId) => {
    if (!jobFunctionId) {
      triggerAlert('warning', 'Warning', 'Invalid job function ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this job function?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        // await new Promise(resolve => setTimeout(resolve, 3000));
        await axios.delete(
          `/api/v1/job-functions-type/${jobFunctionId}/`,

        );

        triggerAlert('success', 'Success', 'Job function deleted successfully.');
        setJobFunctionData((prevData) => prevData.filter((jobFunction) => jobFunction.id !== jobFunctionId));
        fetchJobFunction()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete job function. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      }
      finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  //  Delete Button
  const deleteJobFunctionIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteJobFunction(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  //  Add New Job Function
  const addNewJobFunction = () => {
    setCurrentJobFunction({ id: "", value: "", description: "", type: "" });
    reset()
    setJobFunctionDialogVisible(true);
    setIsEditingJobFunction(false);
  };
  // job type end
  ///////// job functin end ////////////////

  // Department start
  const [departmentData, setDepartmentData] = useState([])
  const [isDepartmentDialogVisible, setDepartmentDialogVisible] =
    useState(false)
  const [currentDepartment, setCurrentDepartment] = useState({
    id: "",
    value: "",
    description: "",
    company: null,
    type: "",
    companyname: ""
  })
  const [isEditingDepartment, setIsEditingDepartment] = useState(false)
  const [departmentLazyParams, setDepartmentLazyParams] = useState({ page: 0, rows: 10 }); // Default rows set to 20
  const [departmentTotalRecords, setDepartmentTotalRecords] = useState(0);


  const onPageDepartment = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setDepartmentLazyParams(newLazyParams);
    fetchDepartment(newLazyParams.page, newLazyParams.rows);
  };

  const fetchDepartment = async (page = departmentLazyParams.page, rows = departmentLazyParams.rows) => {
    ////console.log('Fetching Department data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/departments/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const departments = response.data.results.map((source) => ({
          id: source.department_id,
          value: source.name,
          description: source.description,
          company: source.company, // Store company_id
          companyname: source.company_name,
          type: source.type, // Default to 'user' if type is missing
        }));
        setDepartmentData(departments);
        setDepartmentTotalRecords(response.data.count || 0); // Assuming API returns a count field
        await fetchAllCompanies(); // Fetch companies for dropdown
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching department data:', error.response ? error.response.data : error.message);
    }
  };

  const handleSaveDepartment = async (data) => {
    try {
      // Prepare payload
      const departmentPayload = {
        name: data.value,
        description: data.description,
        type: data.type,
        // ...(isEditingDepartment
        //   ? { company: data.company }      // For PUT
        //   : { company_id: data.company })  // For POST
      };

      let response;

      if (isEditingDepartment) {
        // PUT request for update
        response = await axios.put(`/api/v1/departments/${currentDepartment.id}/`, departmentPayload);
        setDepartmentData((prevData) =>
          prevData.map((item) =>
            item.id === currentDepartment.id
              ? {
                ...item,
                value: data.value,
                description: data.description,
                company: data.company,
                type: data.type
              }
              : item
          )
        );
        triggerAlert("success", "Success", "Department updated successfully.");
      } else {
        // POST request for create
        response = await axios.post(`/api/v1/departments/`, departmentPayload);
        if (response.status === 201) {
          triggerAlert("success", "Success", "Department created successfully.");
          const newDepartment = {
            id: response.data.department_id,
            value: response.data.name,
            description: response.data.description,
            company: response.data.company_id,
            type: response.data.type,
          };
          setDepartmentData((prevData) => [...prevData, newDepartment]);
        }
      }

      handleCancelDepartment();
      fetchDepartment();
    } catch (error) {
      triggerAlert("error", "Error", error.response?.data?.error || "Failed to save department.");
      handleCancelDepartment();
    }
  };


  const deleteDepartment = (departmentId) => {
    if (!departmentId) {
      triggerAlert('warning', 'Warning', 'Invalid department ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this department?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        const response = await axios.delete(
          `/api/v1/departments/${departmentId}/`,

        );

        triggerAlert('success', 'Success', 'Department deleted successfully.');
        setDepartmentData((prevData) => prevData.filter(dept => dept.id !== departmentId));
        fetchDepartment()
      } catch (error) {
        const errorMessage =
          error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message ||
          `Failed to delete department. Status code: ${error.response?.status}` ||
          "Please try again.";
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const handleCancelDepartment = () => {
    setDepartmentDialogVisible(false)
    setCurrentDepartment({ id: "", value: "", description: "", company: "", type: "" })
    setIsEditingDepartment(false)
    reset()
  }

  const editDepartmentIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentDepartment({
            id: rowData.id,
            value: rowData.value,
            description: rowData.description,
            company: rowData.company, // Set company_id
            type: rowData.type
          });
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("company", rowData.company); // Set company_id in form
          setValue("type", rowData.type);
          setDepartmentDialogVisible(true);
          setIsEditingDepartment(true);
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const deleteDepartmentIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => {
          //////console.log('Deleting department with ID:', rowData.id); // Debug the ID
          deleteDepartment(rowData.id);
        }}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  );

  const addNewDepartment = () => {
    setCurrentDepartment({ id: "", value: "", description: "", company: "", type: "" })
    reset()
    setDepartmentDialogVisible(true)
    setIsEditingDepartment(false)
  }
  // Department end

  // Seniority start

  const [seniorityData, setSeniorityData] = useState([])
  const [isSeniorityDialogVisible, setSeniorityDialogVisible] = useState(false)
  const [currentSeniority, setCurrentSeniority] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingSeniority, setIsEditingSeniority] = useState(false);
  const [seniorityLazyParams, setSeniorityLazyParams] = useState({ page: 0, rows: 10 }); // Default rows set to 5
  const [seniorityTotalRecords, setSeniorityTotalRecords] = useState(0);

  const onPageSeniority = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated Seniority lazyParams:', newLazyParams); // Debug log
    setSeniorityLazyParams(newLazyParams);
    fetchSeniority(newLazyParams.page, newLazyParams.rows);
  };
  // Fetch data from the API
  const fetchSeniority = async (page = seniorityLazyParams.page, rows = seniorityLazyParams.rows) => {
    ////console.log('Fetching Seniority data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/seniority-levels/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const levels = response.data.results.map((level) => ({
          id: level.id,
          value: level.seniority_level,
          description: level.description,
          type: level.type || 'user', // Default to 'user' if type is missing
        }));
        setSeniorityData(levels);
        setSeniorityTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching seniority data:', error.response ? error.response.data : error.message);
    }
  };

  const handleSaveSeniority = async (data) => {
    try {
      const req = {
        seniority_level: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      let updatedData;

      if (isEditingSeniority) {
        // Update existing seniority level
        response = await axios.put(
          `/api/v1/seniority-levels/${currentSeniority.id}/`,
          req,

        );

        if (response.status === 200) {
          updatedData = seniorityData.map(item =>
            item.id === currentSeniority.id ? { ...currentSeniority } : item
          );
          triggerAlert("success", "Success", "Seniority level updated successfully.");
          handleCancelSeniority();
          fetchSeniority()
        } else {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
      } else {
        // Create a new seniority level
        response = await axios.post(
          `/api/v1/seniority-levels/`,
          req,

        );

        if (response.status === 201) {
          const newSeniority = {
            id: response.data.id,
            value: response.data.seniority_level,
            description: response.data.description,
            type: response.data.type,
          };
          updatedData = [...seniorityData, newSeniority];
          triggerAlert("success", "Success", "Seniority level created successfully.");
          handleCancelSeniority();
          fetchSeniority()
        } else {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
      }

      setSeniorityData(updatedData);
      setSeniorityDialogVisible(false);
      handleCancelSeniority();
    } catch (error) {
      console.error(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.seniority_level);
      handleCancelSeniority();
    }
  };


  const handleCancelSeniority = () => {
    setSeniorityDialogVisible(false)
    setCurrentSeniority({ id: "", value: "", description: "", type: "" })
    setIsEditingSeniority(false)
    reset()
  }

  const editSeniorityIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentSeniority({ ...rowData })
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setSeniorityDialogVisible(true)
          setIsEditingSeniority(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  //Delete function
  const handleDeleteSeniority = (seniorityId) => {
    ConfirmationAlert('Are you sure you want to delete this seniority level?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        const response = await axios.delete(
          `/api/v1/seniority-levels/${seniorityId}/`,

        );

        if (response.status === 204) {
          setSeniorityData(prevData => prevData.filter(seniority => seniority.id !== seniorityId));
          triggerAlert('success', 'Success', 'Seniority level deleted successfully.');
          fetchSeniority()
        } else {
          throw new Error(`Unexpected response status: ${response.status}`);
        }
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete seniority level. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  const deleteSeniorityIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteSeniority(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewSeniority = () => {
    setCurrentSeniority({ id: "", value: "", description: "", type: "" })
    reset();
    setSeniorityDialogVisible(true)
    setIsEditingSeniority(false)
  }

  // Seniority end

  const [specialtiesData, setSpecialtiesData] = useState([])
  const [isSpecialtiesDialogVisible, setSpecialtiesDialogVisible] =
    useState(false)
  const [currentSpecialty, setCurrentSpecialty] = useState({
    id: "",
    name: "",
    description: "",
    type: "",
  })
  const [isEditingSpecialty, setIsEditingSpecialty] = useState(false)
  const [specialityLazyParams, setSpecialityLazyParams] = useState({ page: 0, rows: 10 });
  const [specialityTotalRecords, setSpecialityTotalRecords] = useState(0);

  const onPageSpeciality = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    setSpecialityLazyParams(newLazyParams);
    fetchSpeciality(newLazyParams.page, newLazyParams.rows);
  };

  const fetchSpeciality = async (page = specialityLazyParams.page, rows = specialityLazyParams.rows) => {
    try {
      const response = await axios.get(`/api/v1/create-speciality/?page=${page + 1}&size=${rows}`);
      if (response.status === 200) {
        const skills = response.data.results.map(skill => ({
          id: skill.id,
          name: skill.value,
          description: skill.description,
          type: skill.type,
        }));
        setSpecialtiesData(skills);
        setSpecialityTotalRecords(response.data.count || 0);
      }
    } catch (error) {
      ////console.error('Error fetching skills data:', error);
    }
  };

  const handleSaveSpeciality = async (data) => {
    try {
      const skillPayload = {
        value: data.name,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingSpecialty) {
        // Update existing skill
        response = await axios.put(
          `/api/v1/create-speciality/${currentSpecialty.id}/`,
          skillPayload
        );

        setSpecialtiesData(prevData =>
          prevData.map(item =>
            item.id === currentSpecialty.id ? { ...item, ...data } : item
          )
        );
        handleCancelSpecialty();
        triggerAlert('success', 'Success', 'Speciality updated successfully.');
      } else {
        // Add new skill
        response = await axios.post(
          `/api/v1/create-speciality/`,
          skillPayload

        );

        const newSkill = {
          id: response.data.id,
          name: response.data.value,
          description: response.data.description,
          type: response.data.type,
        };
        setSpecialtiesData(prevData => [...prevData, newSkill]);
        triggerAlert('success', 'Success', 'Speciality created successfully.');
        fetchSpeciality()
      }
      handleCancelSpecialty(); // Close modal on success
    } catch (error) {
      console.log(error)
      handleCancelSpecialty();
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.value);
    }
  };


  const handleCancelSpecialty = () => {
    setSpecialtiesDialogVisible(false)
    setCurrentSpecialty({ id: "", name: "", description: "", type: "" })
    setIsEditingSpecialty(false)
    clearErrors();
  }

  const editSpecialtyIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setValue("name", rowData.name); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setCurrentSpecialty({ ...rowData })
          setSpecialtiesDialogVisible(true)
          setIsEditingSpecialty(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )
  const handleDeleteSpeciality = (speciaId) => {
    ConfirmationAlert('Are you sure you want to delete this speciality?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/create-speciality/${speciaId}/`
        );

        setSpecialtiesData(prevData => prevData.filter(skill => skill.id !== speciaId));
        triggerAlert('success', 'Success', 'Speciality deleted successfully.');
        fetchSpeciality();
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete Speciality. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };
  const deleteSpecialtyIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteSpeciality(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewSpecialty = () => {
    reset({ name: "", description: "", type: "" });
    setCurrentSpecialty({ id: "", name: "", description: "", type: "" })
    setSpecialtiesDialogVisible(true)
    setIsEditingSpecialty(false)
  }

  // industry start

  const [industryData, setIndustryData] = useState([])
  const [isIndustryDialogVisible, setIndustryDialogVisible] = useState(false)
  const [currentIndustry, setCurrentIndustry] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingIndustry, setIsEditingIndustry] = useState(false)
  const [industryLazyParams, setIndustryLazyParams] = useState({ page: 0, rows: 10 });
  const [industryTotalRecords, setIndustryTotalRecords] = useState(0);


  const onPageIndustry = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated Industry lazyParams:', newLazyParams); // Debug log
    setIndustryLazyParams(newLazyParams);
    fetchIndustry(newLazyParams.page, newLazyParams.rows);
  };

  // Fetch data from the API
  const fetchIndustry = async (page = industryLazyParams.page, rows = industryLazyParams.rows) => {
    ////console.log('Fetching Industry data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/industry/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const industries = response.data.results.map((industry) => ({
          id: industry.industry_id,
          value: industry.industry_name,
          description: industry.description,
          type: industry.type || 'user', // Default to 'user' if type is missing
        }));
        setIndustryData(industries);
        setIndustryTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching industry data:', error.response ? error.response.data : error.message);
    }
  };


  const handleSaveIndustry = async (data) => {
    try {
      const industryPayload = {
        industry_name: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingIndustry) {
        // Update Industry
        response = await axios.put(
          `/api/v1/industry/${currentIndustry.id}/`,
          industryPayload,

        );

        if (response.status === 200) {
          setIndustryData((prevData) =>
            prevData.map((item) =>
              item.id === currentIndustry.id ? { ...currentIndustry } : item
            )
          );
          triggerAlert('success', 'Success', 'Industry updated successfully.');
          handleCancelIndustry();
          fetchIndustry()
        } else {
          throw new Error(`Failed to update industry. Status code: ${response.status}`);
        }
      } else {
        // Create a new industry
        response = await axios.post(
          `/api/v1/industry/`,
          industryPayload,

        );

        if (response.status === 201) {
          setIndustryData((prevData) => [
            ...prevData,
            {
              id: response.data.industry_id,
              value: response.data.industry_name,
              description: response.data.description,
              type: response.data.type,
            },
          ]);
          triggerAlert('success', 'Success', 'Industry created successfully.');
          fetchIndustry()
        } else {
          throw new Error(`Failed to create industry. Status code: ${response.status}`);
        }
      }

      setIndustryDialogVisible(false);
      handleCancelIndustry();
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.industry_name);
      handleCancelIndustry();
    }
  };


  const handleCancelIndustry = () => {
    setIndustryDialogVisible(false)
    setCurrentIndustry({ id: "", value: "", description: "", type: "" })
    setIsEditingIndustry(false)
    reset()
  }

  const editIndustryIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentIndustry({ ...rowData })
          setValue("value", rowData.value); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setIndustryDialogVisible(true)
          setIsEditingIndustry(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )
  //Delete function
  const handleDeleteIndustry = (industryId) => {
    if (!industryId) {
      triggerAlert('warning', 'Warning', 'Invalid Industry ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this industry?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/industry/${industryId}/`,

        );

        triggerAlert('success', 'Success', 'Industry deleted successfully.');
        setIndustryData((prevData) => prevData.filter((industry) => industry.id !== industryId));
        fetchIndustry()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete industry. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const deleteIndustryIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteIndustry(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewIndustry = () => {
    setCurrentIndustry({ id: "", value: "", description: "", type: "" })
    reset()
    setIndustryDialogVisible(true)
    setIsEditingIndustry(false)
  }

  // industry end

  // company size start

  const [companySizeData, setCompanySizeData] = useState([])
  const [isCompanySizeDialogVisible, setCompanySizeDialogVisible] =
    useState(false)
  const [currentCompanySize, setCurrentCompanySize] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingCompanySize, setIsEditingCompanySize] = useState(false)
  const [companySizeLazyParams, setCompanySizeLazyParams] = useState({ page: 0, rows: 10 });
  const [companySizeTotalRecords, setCompanySizeTotalRecords] = useState(0);


  const onPageCompanySize = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated CompanySize lazyParams:', newLazyParams); // Debug log
    setCompanySizeLazyParams(newLazyParams);
    fetchCompanySize(newLazyParams.page, newLazyParams.rows);
  };

  const fetchCompanySize = async (page = companySizeLazyParams.page, rows = companySizeLazyParams.rows) => {
    ////console.log('Fetching Company Size data with page:', page + 1, 'rows:', rows); // Debug log
    let response;
    try {
      response = await axios.get(
        `/api/v1/company-size/?page=${page + 1}&size=${rows}`,

      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const sizes = response.data.results.map((size) => ({
          id: size.id,
          value: size.company_size,
          description: size.description,
          type: size.type || 'user', // Default to 'user' if type is missing
        }));
        setCompanySizeData(sizes);
        setCompanySizeTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching company size data:', error.response ? error.response.data : error.message);
    }
  };


  const handleSaveCompanySize = async (data) => {
    try {
      const companySizePayload = {
        company_size: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingCompanySize) {
        response = await axios.put(
          `/api/v1/company-size/${currentCompanySize.id}/`,
          companySizePayload,

        );

        if (response.status === 200) {
          triggerAlert('success', 'Success', 'Company size updated successfully.');
          handleCancelCompanySize();
          fetchCompanySize();
        } else {
          throw new Error(`Failed to update company size. Status code: ${response.status}`);
        }
      } else {
        response = await axios.post(
          `/api/v1/company-size/`,
          companySizePayload,

        );

        if (response.status === 201) {
          setCompanySizeData((prevData) => [
            ...prevData,
            {
              id: response.data.id,
              value: response.data.company_size,
              description: response.data.description,
              type: response.data.type,
            },
          ]);
          triggerAlert('success', 'Success', 'Company size created successfully.');
          handleCancelCompanySize();
          fetchCompanySize()
        } else {
          throw new Error(`Failed to create company size. Status code: ${response.status}`);
        }
      }

      setCompanySizeDialogVisible(false);
      handleCancelCompanySize();
    } catch (error) {
      console.log(error)
      const errorMessage = error.response?.data?.error || error.response?.data?.company_size || `Failed to save company size. Status code: ${error.response?.status}` || 'Please try again.';
      triggerAlert('error', 'Error', errorMessage);
      handleCancelCompanySize();
    }
  };


  const handleCancelCompanySize = () => {
    setCompanySizeDialogVisible(false)
    setCurrentCompanySize({ id: "", value: "", description: "", type: "" })
    setIsEditingCompanySize(false)
    reset()
  }

  const editCompanySizeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentCompanySize({ ...rowData })
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setCompanySizeDialogVisible(true)
          setIsEditingCompanySize(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const deleteCompanySize = (id) => {
    if (!id) {
      triggerAlert('warning', 'Warning', 'Invalid Company size ID.');
      return;
    }
    ConfirmationAlert('Are you sure you want to delete this company size?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        const response = await axios.delete(
          `/api/v1/company-size/${id}/`,

        );

        if (response.status === 204) {
          setCompanySizeData((prevData) => prevData.filter((item) => item.id !== id));
          triggerAlert('success', 'Success', 'Company size deleted successfully.');
          fetchCompanySize()
        } else {
          throw new Error(`Failed to delete company size. Status code: ${response.status}`);
        }
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete company size. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };


  const deleteCompanySizeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => deleteCompanySize(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewCompanySize = () => {
    setCurrentCompanySize({ id: "", value: "", description: "", type: "" })
    reset()
    setCompanySizeDialogVisible(true)
    setIsEditingCompanySize(false)
  }

  // company size end

  // Schedule type start

  const fetchScheduleType = async (page = scheduleTypeLazyParams.page, rows = scheduleTypeLazyParams.rows) => {
    ////console.log('Fetching Schedule Type data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/schedule-type/?page=${page + 1}&size=${rows}`
      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const scheduled = response.data.results.map((schedule) => ({
          id: schedule.id,
          value: schedule.schedule_type,
          description: schedule.description,
          type: schedule.type || 'user', // Default to 'user' if type is missing
        }));
        setScheduleTypeData(scheduled);
        setScheduleTypeTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching schedule type data:', error.response ? error.response.data : error.message);
    }
  };

  const [scheduleTypeData, setScheduleTypeData] = useState([])
  const [isScheduleTypeDialogVisible, setScheduleTypeDialogVisible] =
    useState(false)
  const [currentScheduleType, setCurrentScheduleType] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingScheduleType, setIsEditingScheduleType] = useState(false)
  const [scheduleTypeLazyParams, setScheduleTypeLazyParams] = useState({ page: 0, rows: 10 });
  const [scheduleTypeTotalRecords, setScheduleTypeTotalRecords] = useState(0);


  const onPageScheduleType = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated ScheduleType lazyParams:', newLazyParams); // Debug log
    setScheduleTypeLazyParams(newLazyParams);
    fetchScheduleType(newLazyParams.page, newLazyParams.rows);
  };

  const handleSaveScheduleType = async (data) => {
    try {
      const scheduleTypePayload = {
        schedule_type: data.value,
        description: data.description,
        type: data.type,
      };
      let response;
      if (isEditingScheduleType) {
        response = await axios.put(
          `/api/v1/schedule-type/${currentScheduleType.id}/`,
          scheduleTypePayload,

        );

        if (response.status === 200) {
          const updatedItem = {
            id: response.data.id,
            value: response.data.schedule_type,
            description: response.data.description,
            type: response.data.type,
          };

          setScheduleTypeData((prevData) =>
            prevData.map((item) =>
              item.id === updatedItem.id ? updatedItem : item
            )
          );

          triggerAlert('success', 'Success', 'Schedule type updated successfully.');
          handleCancelScheduleType();
        } else {
          throw new Error(`Failed to update schedule type. Status code: ${response.status}`);
        }
      } else {
        response = await axios.post(
          `/api/v1/schedule-type/`,
          scheduleTypePayload,

        );

        if (response.status === 201) {
          setScheduleTypeData((prevData) => [
            ...prevData,
            {
              id: response.data.id,
              value: response.data.schedule_type,
              description: response.data.description,
              type: response.data.type,
            },
          ]);
          triggerAlert('success', 'Success', 'Schedule type created successfully.');
          handleCancelScheduleType();
          fetchScheduleType()
        } else {
          throw new Error(`Failed to create schedule type. Status code: ${response.status}`);
        }
      }

      setScheduleTypeDialogVisible(false);
      handleCancelScheduleType();
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.schedule_type);
      handleCancelScheduleType();
    }
  };

  const handleCancelScheduleType = () => {
    setScheduleTypeDialogVisible(false)
    setCurrentScheduleType({ id: "", value: "", description: "", type: "" })
    setIsEditingScheduleType(false)
    reset()
  }

  const editScheduleTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        onClick={() => {
          setCurrentScheduleType({ ...rowData })
          setValue("value", rowData.value); // Corrected field name
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setScheduleTypeDialogVisible(true)
          setIsEditingScheduleType(true)
        }}
        className="p-button-rounded p-button-info"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  //Delete function
  const handleDeleteScheduleType = (scheduleId) => {
    if (!scheduleId) {
      triggerAlert('warning', 'Warning', 'Invalid Schedule Type ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this schedule type?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/schedule-type/${scheduleId}/`,

        );

        triggerAlert('success', 'Success', 'Schedule type deleted successfully.');
        setScheduleTypeData((prevData) => prevData.filter((schedule) => schedule.id !== scheduleId));
        fetchScheduleType()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete schedule type. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert('error', 'Error', errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  const deleteScheduleTypeIcon = rowData => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        onClick={() => handleDeleteScheduleType(rowData.id)}
        className="p-button-rounded p-button-danger"
        disabled={rowData.type === "system"}
      />
    </div>
  )

  const addNewScheduleType = () => {
    setCurrentScheduleType({ id: "", value: "", description: "", type: "" })
    reset()
    setScheduleTypeDialogVisible(true)
    setIsEditingScheduleType(false)
  }

  // schedle typ end

  // Schedule sub-type


  const [scheduleSubTypeData, setScheduleSubTypeData] = useState([]);
  const [isScheduleSubTypeDialogVisible, setIsScheduleSubTypeDialogVisible] =
    useState(false);
  const [isEditingScheduleSubType, setIsEditingScheduleSubType] =
    useState(false);
  const [scheduleSubTypeLazyParams, setScheduleSubTypeLazyParams] = useState({ page: 0, rows: 10 });
  const [scheduleSubTypeTotalRecords, setScheduleSubTypeTotalRecords] = useState(0);
  const [currentScheduleSubType, setCurrentScheduleSubType] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
    schedule_id: null,
    scheduleType: ""
  });


  const onPageScheduleSubType = (event) => {
    const newLazyParams = { page: event.page, rows: event.rows };
    ////console.log('Updated ScheduleSubType lazyParams:', newLazyParams); // Debug log
    setScheduleSubTypeLazyParams(newLazyParams);
    fetchScheduleSubType(newLazyParams.page, newLazyParams.rows);
  };


  // Fetch Schedule Sub-Type Data
  const fetchScheduleSubType = async (page = scheduleSubTypeLazyParams.page, rows = scheduleSubTypeLazyParams.rows) => {
    ////console.log('Fetching Schedule Sub-Type data with page:', page + 1, 'rows:', rows); // Debug log
    try {
      const response = await axios.get(
        `/api/v1/schedule-sub-type/?&page=${page + 1}&size=${rows}`
      );
      ////console.log('API Response:', response.data); // Debug log
      if (response.status === 200) {
        const subTypes = response.data.results.map((subType) => ({
          id: subType.id,
          scheduleType: subType.schedule_type_name,
          value: subType.schedule_subtype,
          description: subType.description,
          type: subType.type,
          schedule_id: subType.schedule_id
        }));
        setScheduleSubTypeData(subTypes);
        setScheduleSubTypeTotalRecords(response.data.count || 0); // Assuming API returns a count field
      } else {
        //console.error('Unexpected status code:', response.status);
      }
    } catch (error) {
      //console.error('Error fetching schedule sub-type data:', error.response ? error.response.data : error.message);
    }
  };
  // Save (Create or Update) Schedule Sub-Type
  const handleSaveScheduleSubType = async (data) => {
    try {
      const scheduleSubTypePayload = {
        schedule_subtype: data.value,
        description: data.description,
        type: data.type,
        schedule_id: currentScheduleSubType.scheduleType,
      };

      let response;
      if (isEditingScheduleSubType) {
        response = await axios.put(
          `/api/v1/schedule-sub-type/${currentScheduleSubType.id}/`,
          scheduleSubTypePayload,

        );

        if (response.status === 200) {
          setScheduleSubTypeData((prevData) =>
            prevData.map((item) =>
              item.id === currentScheduleSubType.id ? { ...response.data } : item
            )
          );
          triggerAlert("success", "Success", "Schedule subtype updated successfully.");
          await fetchScheduleSubType();
          handleCancelScheduleSubType();
        } else {
          throw new Error(`Failed to update schedule subtype. Status code: ${response.status}`);
        }
      } else {
        response = await axios.post(
          `/api/v1/schedule-sub-type/`,
          scheduleSubTypePayload,

        );

        if (response.status === 201) {
          setScheduleSubTypeData((prevData) => [
            ...prevData,
            {
              id: response.data.id,
              value: response.data.schedule_subtype,
              description: response.data.description,
              type: response.data.type,
              scheduleType: response.data.schedule_type_name
            },
          ]);
          handleCancelScheduleSubType();
          fetchScheduleSubType()
          triggerAlert('success', 'Success', 'Schedule subtype created successfully.');
        } else {
          throw new Error(`Failed to create schedule subtype. Status code: ${response.status}`);
        }
      }

      setIsScheduleSubTypeDialogVisible(false);
      handleCancelScheduleSubType();
    } catch (error) {
      console.log(error)
      triggerAlert('error', 'Error', error.response?.data?.error || error.response?.data?.schedule_subtype);
      handleCancelScheduleSubType();
    }
  };


  // Delete Schedule Sub-Type
  const handleDeleteScheduleSubType = async (id) => {
    if (!id) {
      triggerAlert('warning', 'Warning', 'Invalid Schedule SubType ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this schedule subtype?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await axios.delete(
          `/api/v1/schedule-sub-type/${id}/`,

        );

        triggerAlert("success", "Success", "Schedule subtype deleted successfully.");
        setScheduleSubTypeData(prevData => prevData.filter(item => item.id !== id));
        fetchScheduleSubType()
      } catch (error) {
        const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message || `Failed to delete schedule subtype. Status code: ${error.response?.status}` || 'Please try again.';
        triggerAlert("error", "Error", errorMessage);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  const handleCancelScheduleSubType = () => {
    setIsScheduleSubTypeDialogVisible(false);
    setCurrentScheduleSubType({ id: "", scheduleType: "", value: "", description: "", type: "" });
    setIsEditingScheduleSubType(false);
    reset();
  };

  const addNewScheduleSubType = () => {
    setIsEditingScheduleSubType(false);
    setCurrentScheduleSubType({ id: "", scheduleType: "", value: "", description: "", type: "" });
    reset()
    setIsScheduleSubTypeDialogVisible(true);
  };

  const editScheduleSubTypeIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-pencil"
        className="p-button-rounded p-button-info"
        onClick={() => {
          setIsEditingScheduleSubType(true);
          setCurrentScheduleSubType({
            id: rowData.id,
            value: rowData.value,
            description: rowData.description,
            type: rowData.type,
            scheduleType: rowData.schedule_id, // Ensure scheduleType is included
          });
          setValue("value", rowData.value);
          setValue("description", rowData.description);
          setValue("type", rowData.type);
          setValue("scheduleType", rowData.schedule_id); // Set the scheduleType value
          setIsScheduleSubTypeDialogVisible(true);
        }}
        disabled={rowData.type === "system"} // Disable only if type is "system"
      />
    </div>
  );


  const deleteScheduleSubTypeIcon = (rowData) => (
    <div
      style={{
        cursor: rowData.type === "system" ? "not-allowed" : "pointer",
      }}
    >
      <Button
        icon="pi pi-trash"
        className="p-button-rounded p-button-text p-button-danger"
        disabled={rowData.type === "system"}
        onClick={() => handleDeleteScheduleSubType(rowData.id)}
      />
    </div>
  );


  // schedule sub-type

  // Received System start

  const [receivedSystemData, setReceivedSystemData] = useState([])
  const [isReceivedSystemDialogVisible, setReceivedSystemDialogVisible] =
    useState(false)
  const [currentReceivedSystem, setCurrentReceivedSystem] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingReceivedSystem, setIsEditingReceivedSystem] = useState(false)



  const handleSaveReceivedSystem = () => {
    if (
      currentReceivedSystem.value &&
      currentReceivedSystem.description &&
      currentReceivedSystem.type
    ) {
      if (isEditingReceivedSystem) {
        setReceivedSystemData(prevData =>
          prevData.map(item =>
            item.id === currentReceivedSystem.id
              ? { ...currentReceivedSystem }
              : item
          )
        )
      } else {
        const newReceivedSystem = {
          ...currentReceivedSystem,
          id: Date.now().toString(),
        }
        setReceivedSystemData(prevData => [...prevData, newReceivedSystem])
      }
      handleCancelReceivedSystem()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelReceivedSystem = () => {
    setReceivedSystemDialogVisible(false)
    setCurrentReceivedSystem({ id: "", value: "", description: "", type: "" })
    setIsEditingReceivedSystem(false)
  }

  const editReceivedSystemIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentReceivedSystem({ ...rowData })
        setReceivedSystemDialogVisible(true)
        setIsEditingReceivedSystem(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteReceivedSystemIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setReceivedSystemData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewReceivedSystem = () => {
    setCurrentReceivedSystem({ id: "", value: "", description: "", type: "" })
    setReceivedSystemDialogVisible(true)
    setIsEditingReceivedSystem(false)
  }

  // Received type end


  // Potential system start

  const [potentialSystemData, setPotentialSystemData] = useState([])
  const [isPotentialSystemDialogVisible, setPotentialSystemDialogVisible] =
    useState(false)
  const [currentPotentialSystem, setCurrentPotentialSystem] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingPotentialSystem, setIsEditingPotentialSystem] =
    useState(false)



  const handleSavePotentialSystem = () => {
    if (
      currentPotentialSystem.value &&
      currentPotentialSystem.description &&
      currentPotentialSystem.type
    ) {
      if (isEditingPotentialSystem) {
        setPotentialSystemData(prevData =>
          prevData.map(item =>
            item.id === currentPotentialSystem.id
              ? { ...currentPotentialSystem }
              : item
          )
        )
      } else {
        const newPotentialSystem = {
          ...currentPotentialSystem,
          id: Date.now().toString(),
        }
        setPotentialSystemData(prevData => [...prevData, newPotentialSystem])
      }
      handleCancelPotentialSystem()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelPotentialSystem = () => {
    setPotentialSystemDialogVisible(false)
    setCurrentPotentialSystem({ id: "", value: "", description: "", type: "" })
    setIsEditingPotentialSystem(false)
  }

  const editPotentialSystemIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentPotentialSystem({ ...rowData })
        setPotentialSystemDialogVisible(true)
        setIsEditingPotentialSystem(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deletePotentialSystemIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setPotentialSystemData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewPotentialSystem = () => {
    setCurrentPotentialSystem({ id: "", value: "", description: "", type: "" })
    setPotentialSystemDialogVisible(true)
    setIsEditingPotentialSystem(false)
  }

  // potential system end

  // Submitted system start

  const [submittedSystemData, setSubmittedSystemData] = useState([])
  const [isSubmittedSystemDialogVisible, setSubmittedSystemDialogVisible] =
    useState(false)
  const [currentSubmittedSystem, setCurrentSubmittedSystem] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingSubmittedSystem, setIsEditingSubmittedSystem] =
    useState(false)



  const handleSaveSubmittedSystem = () => {
    if (
      currentSubmittedSystem.value &&
      currentSubmittedSystem.description &&
      currentSubmittedSystem.type
    ) {
      if (isEditingSubmittedSystem) {
        setSubmittedSystemData(prevData =>
          prevData.map(item =>
            item.id === currentSubmittedSystem.id
              ? { ...currentSubmittedSystem }
              : item
          )
        )
      } else {
        const newSubmittedSystem = {
          ...currentSubmittedSystem,
          id: Date.now().toString(),
        }
        setSubmittedSystemData(prevData => [...prevData, newSubmittedSystem])
      }
      handleCancelSubmittedSystem()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelSubmittedSystem = () => {
    setSubmittedSystemDialogVisible(false)
    setCurrentSubmittedSystem({ id: "", value: "", description: "", type: "" })
    setIsEditingSubmittedSystem(false)
  }

  const editSubmittedSystemIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentSubmittedSystem({ ...rowData })
        setSubmittedSystemDialogVisible(true)
        setIsEditingSubmittedSystem(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteSubmittedSystemIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setSubmittedSystemData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewSubmittedSystem = () => {
    setCurrentSubmittedSystem({ id: "", value: "", description: "", type: "" })
    setSubmittedSystemDialogVisible(true)
    setIsEditingSubmittedSystem(false)
  }

  // submitted system end


  // all user start

  const [userTableData, setUserTableData] = useState([])
  const [isUserDialogVisible, setUserDialogVisible] = useState(false)
  const [selectedUserRecord, setSelectedUserRecord] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditUserMode, setEditUserMode] = useState(false)



  const handleSaveUserRecord = () => {
    if (
      selectedUserRecord.value &&
      selectedUserRecord.description &&
      selectedUserRecord.type
    ) {
      if (isEditUserMode) {
        setUserTableData(prevData =>
          prevData.map(user =>
            user.id === selectedUserRecord.id ? { ...selectedUserRecord } : user
          )
        )
      } else {
        const newUserRecord = {
          ...selectedUserRecord,
          id: Date.now().toString(),
        }
        setUserTableData(prevData => [...prevData, newUserRecord])
      }
      handleCancelUserDialog()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelUserDialog = () => {
    setUserDialogVisible(false)
    setSelectedUserRecord({ id: "", value: "", description: "", type: "" })
    setEditUserMode(false)
  }

  const renderEditButton = user => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setSelectedUserRecord({ ...user })
        setUserDialogVisible(true)
        setEditUserMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderDeleteButton = user => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setUserTableData(prevData =>
          prevData.filter(item => item.id !== user.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewUserRecord = () => {
    setSelectedUserRecord({ id: "", value: "", description: "", type: "" })
    setUserDialogVisible(true)
    setEditUserMode(false)
  }

  // All user end

  // shortlisted start

  const [shortlistedData, setShortlistedData] = useState([])
  const [isShortlistedDialogVisible, setShortlistedDialogVisible] =
    useState(false)
  const [currentShortlisted, setCurrentShortlisted] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditShortlistedMode, setEditShortlistedMode] = useState(false)



  const handleSaveShortlisted = () => {
    if (
      currentShortlisted.value &&
      currentShortlisted.description &&
      currentShortlisted.type
    ) {
      if (isEditShortlistedMode) {
        setShortlistedData(prevData =>
          prevData.map(item =>
            item.id === currentShortlisted.id ? { ...currentShortlisted } : item
          )
        )
      } else {
        const newShortlisted = {
          ...currentShortlisted,
          id: Date.now().toString(),
        }
        setShortlistedData(prevData => [...prevData, newShortlisted])
      }
      handleCancelShortlisted()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelShortlisted = () => {
    setShortlistedDialogVisible(false)
    setCurrentShortlisted({ id: "", value: "", description: "", type: "" })
    setEditShortlistedMode(false)
  }

  const renderShortlistedEditButton = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentShortlisted({ ...rowData })
        setShortlistedDialogVisible(true)
        setEditShortlistedMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderShortlistedDeleteButton = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setShortlistedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewShortlisted = () => {
    setCurrentShortlisted({ id: "", value: "", description: "", type: "" })
    setShortlistedDialogVisible(true)
    setEditShortlistedMode(false)
  }

  // Shortlisted end



  // Interview start

  const [interviewData, setInterviewData] = useState([])
  const [isInterviewDialogVisible, setInterviewDialogVisible] = useState(false)
  const [currentInterview, setCurrentInterview] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditInterviewMode, setEditInterviewMode] = useState(false)



  const handleSaveInterview = () => {
    if (
      currentInterview.value &&
      currentInterview.description &&
      currentInterview.type
    ) {
      if (isEditInterviewMode) {
        setInterviewData(prevData =>
          prevData.map(item =>
            item.id === currentInterview.id ? { ...currentInterview } : item
          )
        )
      } else {
        const newInterview = {
          ...currentInterview,
          id: Date.now().toString(),
        }
        setInterviewData(prevData => [...prevData, newInterview])
      }
      handleCancelInterview()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelInterview = () => {
    setInterviewDialogVisible(false)
    setCurrentInterview({ id: "", value: "", description: "", type: "" })
    setEditInterviewMode(false)
  }

  const renderInterviewEditButton = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentInterview({ ...rowData })
        setInterviewDialogVisible(true)
        setEditInterviewMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderInterviewDeleteButton = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setInterviewData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewInterview = () => {
    setCurrentInterview({ id: "", value: "", description: "", type: "" })
    setInterviewDialogVisible(true)
    setEditInterviewMode(false)
  }

  // interview end

  // verification start
  const [verificationData, setVerificationData] = useState([])
  const [isVerificationDialogVisible, setVerificationDialogVisible] =
    useState(false)
  const [currentVerification, setCurrentVerification] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditVerificationMode, setEditVerificationMode] = useState(false)



  const handleSaveVerification = () => {
    if (
      currentVerification.value &&
      currentVerification.description &&
      currentVerification.type
    ) {
      if (isEditVerificationMode) {
        setVerificationData(prevData =>
          prevData.map(item =>
            item.id === currentVerification.id
              ? { ...currentVerification }
              : item
          )
        )
      } else {
        const newVerification = {
          ...currentVerification,
          id: Date.now().toString(),
        }
        setVerificationData(prevData => [...prevData, newVerification])
      }
      handleCancelVerification()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelVerification = () => {
    setVerificationDialogVisible(false)
    setCurrentVerification({ id: "", value: "", description: "", type: "" })
    setEditVerificationMode(false)
  }

  const renderVerificationEditButton = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentVerification({ ...rowData })
        setVerificationDialogVisible(true)
        setEditVerificationMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderVerificationDeleteButton = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setVerificationData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewVerification = () => {
    setCurrentVerification({ id: "", value: "", description: "", type: "" })
    setVerificationDialogVisible(true)
    setEditVerificationMode(false)
  }

  // verification end
  // selected start

  const [selectedData, setSelectedData] = useState([])
  const [isSelectedDialogVisible, setSelectedDialogVisible] = useState(false)
  const [currentSelected, setCurrentSelected] = useState({
    id: "",
    value: "",
    description: "",
    category: "",
  })
  const [isEditSelectedMode, setEditSelectedMode] = useState(false)



  const handleSaveSelected = () => {
    if (
      currentSelected.value &&
      currentSelected.description &&
      currentSelected.category
    ) {
      if (isEditSelectedMode) {
        setSelectedData(prevData =>
          prevData.map(item =>
            item.id === currentSelected.id ? { ...currentSelected } : item
          )
        )
      } else {
        const newSelected = {
          ...currentSelected,
          id: Date.now().toString(),
        }
        setSelectedData(prevData => [...prevData, newSelected])
      }
      handleCancelSelected()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelSelected = () => {
    setSelectedDialogVisible(false)
    setCurrentSelected({ id: "", value: "", description: "", category: "" })
    setEditSelectedMode(false)
  }

  const renderSelectedEditButton = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentSelected({ ...rowData })
        setSelectedDialogVisible(true)
        setEditSelectedMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderSelectedDeleteButton = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setSelectedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewSelected = () => {
    setCurrentSelected({ id: "", value: "", description: "", category: "" })
    setSelectedDialogVisible(true)
    setEditSelectedMode(false)
  }

  // selected end



  // Rejected start

  const [rejectedData, setRejectedData] = useState([])
  const [isRejectedDialogVisible, setRejectedDialogVisible] = useState(false)
  const [currentRejected, setCurrentRejected] = useState({
    id: "",
    value: "",
    description: "",
    reason: "",
  })
  const [isEditRejectedMode, setEditRejectedMode] = useState(false)

  const rejectedReasonOptions = [{ label: "User", value: "User" }]

  const handleSaveRejected = () => {
    if (
      currentRejected.value &&
      currentRejected.description &&
      currentRejected.reason
    ) {
      if (isEditRejectedMode) {
        setRejectedData(prevData =>
          prevData.map(item =>
            item.id === currentRejected.id ? { ...currentRejected } : item
          )
        )
      } else {
        const newRejected = {
          ...currentRejected,
          id: Date.now().toString(),
        }
        setRejectedData(prevData => [...prevData, newRejected])
      }
      handleCancelRejected()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelRejected = () => {
    setRejectedDialogVisible(false)
    setCurrentRejected({ id: "", value: "", description: "", reason: "" })
    setEditRejectedMode(false)
  }

  const renderRejectedEditButton = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentRejected({ ...rowData })
        setRejectedDialogVisible(true)
        setEditRejectedMode(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const renderRejectedDeleteButton = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setRejectedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewRejected = () => {
    setCurrentRejected({ id: "", value: "", description: "", reason: "" })
    setRejectedDialogVisible(true)
    setEditRejectedMode(false)
  }

  // Rejected end


  // offered start

  const [offeredData, setOfferedData] = useState([])
  const [isOfferedDialogVisible, setOfferedDialogVisible] = useState(false)
  const [currentOffered, setCurrentOffered] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingOffered, setIsEditingOffered] = useState(false)



  const handleSaveOffered = () => {
    if (
      currentOffered.value &&
      currentOffered.description &&
      currentOffered.type
    ) {
      if (isEditingOffered) {
        setOfferedData(prevData =>
          prevData.map(item =>
            item.id === currentOffered.id ? { ...currentOffered } : item
          )
        )
      } else {
        const newOffered = {
          ...currentOffered,
          id: Date.now().toString(),
        }
        setOfferedData(prevData => [...prevData, newOffered])
      }
      handleCancelOffered()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelOffered = () => {
    setOfferedDialogVisible(false)
    setCurrentOffered({ id: "", value: "", description: "", type: "" })
    setIsEditingOffered(false)
  }

  const editOfferedIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentOffered({ ...rowData })
        setOfferedDialogVisible(true)
        setIsEditingOffered(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteOfferedIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setOfferedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewOffered = () => {
    setCurrentOffered({ id: "", value: "", description: "", type: "" })
    setOfferedDialogVisible(true)
    setIsEditingOffered(false)
  }

  // offered end

  // Offer Accepted start

  const [offerAcceptedData, setOfferAcceptedData] = useState([])
  const [isOfferAcceptedDialogVisible, setOfferAcceptedDialogVisible] =
    useState(false)
  const [currentOfferAccepted, setCurrentOfferAccepted] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingOfferAccepted, setIsEditingOfferAccepted] = useState(false)



  const handleSaveOfferAccepted = () => {
    if (
      currentOfferAccepted.value &&
      currentOfferAccepted.description &&
      currentOfferAccepted.type
    ) {
      if (isEditingOfferAccepted) {
        setOfferAcceptedData(prevData =>
          prevData.map(item =>
            item.id === currentOfferAccepted.id
              ? { ...currentOfferAccepted }
              : item
          )
        )
      } else {
        const newOfferAccepted = {
          ...currentOfferAccepted,
          id: Date.now().toString(),
        }
        setOfferAcceptedData(prevData => [...prevData, newOfferAccepted])
      }
      handleCancelOfferAccepted()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelOfferAccepted = () => {
    setOfferAcceptedDialogVisible(false)
    setCurrentOfferAccepted({ id: "", value: "", description: "", type: "" })
    setIsEditingOfferAccepted(false)
  }

  const editOfferAcceptedIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentOfferAccepted({ ...rowData })
        setOfferAcceptedDialogVisible(true)
        setIsEditingOfferAccepted(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteOfferAcceptedIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setOfferAcceptedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewOfferAccepted = () => {
    setCurrentOfferAccepted({ id: "", value: "", description: "", type: "" })
    setOfferAcceptedDialogVisible(true)
    setIsEditingOfferAccepted(false)
  }

  // Offer Accepted end

  // Offer Rejected start

  const [offerRejectedData, setOfferRejectedData] = useState([])
  const [isOfferRejectedDialogVisible, setOfferRejectedDialogVisible] =
    useState(false)
  const [currentOfferRejected, setCurrentOfferRejected] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingOfferRejected, setIsEditingOfferRejected] = useState(false)



  const handleSaveOfferRejected = () => {
    if (
      currentOfferRejected.value &&
      currentOfferRejected.description &&
      currentOfferRejected.type
    ) {
      if (isEditingOfferRejected) {
        setOfferRejectedData(prevData =>
          prevData.map(item =>
            item.id === currentOfferRejected.id
              ? { ...currentOfferRejected }
              : item
          )
        )
      } else {
        const newOfferRejected = {
          ...currentOfferRejected,
          id: Date.now().toString(),
        }
        setOfferRejectedData(prevData => [...prevData, newOfferRejected])
      }
      handleCancelOfferRejected()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelOfferRejected = () => {
    setOfferRejectedDialogVisible(false)
    setCurrentOfferRejected({ id: "", value: "", description: "", type: "" })
    setIsEditingOfferRejected(false)
  }

  const editOfferRejectedIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentOfferRejected({ ...rowData })
        setOfferRejectedDialogVisible(true)
        setIsEditingOfferRejected(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteOfferRejectedIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setOfferRejectedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewOfferRejected = () => {
    setCurrentOfferRejected({ id: "", value: "", description: "", type: "" })
    setOfferRejectedDialogVisible(true)
    setIsEditingOfferRejected(false)
  }

  // Offer Rejected end


  // Offer released start

  const [offerReleasedData, setOfferReleasedData] = useState([])
  const [isOfferReleasedDialogVisible, setOfferReleasedDialogVisible] =
    useState(false)
  const [currentOfferReleased, setCurrentOfferReleased] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingOfferReleased, setIsEditingOfferReleased] = useState(false)



  const handleSaveOfferReleased = () => {
    if (
      currentOfferReleased.value &&
      currentOfferReleased.description &&
      currentOfferReleased.type
    ) {
      if (isEditingOfferReleased) {
        setOfferReleasedData(prevData =>
          prevData.map(item =>
            item.id === currentOfferReleased.id
              ? { ...currentOfferReleased }
              : item
          )
        )
      } else {
        const newOfferReleased = {
          ...currentOfferReleased,
          id: Date.now().toString(),
        }
        setOfferReleasedData(prevData => [...prevData, newOfferReleased])
      }
      handleCancelOfferReleased()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelOfferReleased = () => {
    setOfferReleasedDialogVisible(false)
    setCurrentOfferReleased({ id: "", value: "", description: "", type: "" })
    setIsEditingOfferReleased(false)
  }

  const editOfferReleasedIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentOfferReleased({ ...rowData })
        setOfferReleasedDialogVisible(true)
        setIsEditingOfferReleased(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteOfferReleasedIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setOfferReleasedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewOfferReleased = () => {
    setCurrentOfferReleased({ id: "", value: "", description: "", type: "" })
    setOfferReleasedDialogVisible(true)
    setIsEditingOfferReleased(false)
  }

  // Offer released end

  // Onboarding start

  const [onboardingData, setOnboardingData] = useState([])
  const [isOnboardingDialogVisible, setOnboardingDialogVisible] =
    useState(false)
  const [currentOnboarding, setCurrentOnboarding] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingOnboarding, setIsEditingOnboarding] = useState(false)



  const handleSaveOnboarding = () => {
    if (
      currentOnboarding.value &&
      currentOnboarding.description &&
      currentOnboarding.type
    ) {
      if (isEditingOnboarding) {
        setOnboardingData(prevData =>
          prevData.map(item =>
            item.id === currentOnboarding.id ? { ...currentOnboarding } : item
          )
        )
      } else {
        const newOnboarding = {
          ...currentOnboarding,
          id: Date.now().toString(),
        }
        setOnboardingData(prevData => [...prevData, newOnboarding])
      }
      handleCancelOnboarding()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelOnboarding = () => {
    setOnboardingDialogVisible(false)
    setCurrentOnboarding({ id: "", value: "", description: "", type: "" })
    setIsEditingOnboarding(false)
  }

  const editOnboardingIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentOnboarding({ ...rowData })
        setOnboardingDialogVisible(true)
        setIsEditingOnboarding(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteOnboardingIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setOnboardingData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewOnboarding = () => {
    setCurrentOnboarding({ id: "", value: "", description: "", type: "" })
    setOnboardingDialogVisible(true)
    setIsEditingOnboarding(false)
  }

  // Onboarding end

  // Joined start

  const [joinedData, setJoinedData] = useState([])
  const [isJoinedDialogVisible, setJoinedDialogVisible] = useState(false)
  const [currentJoined, setCurrentJoined] = useState({
    id: "",
    value: "",
    description: "",
    type: "",
  })
  const [isEditingJoined, setIsEditingJoined] = useState(false)



  const handleSaveJoined = () => {
    if (
      currentJoined.value &&
      currentJoined.description &&
      currentJoined.type
    ) {
      if (isEditingJoined) {
        setJoinedData(prevData =>
          prevData.map(item =>
            item.id === currentJoined.id ? { ...currentJoined } : item
          )
        )
      } else {
        const newJoined = {
          ...currentJoined,
          id: Date.now().toString(),
        }
        setJoinedData(prevData => [...prevData, newJoined])
      }
      handleCancelJoined()
    } else {
      alert("Please fill all fields before saving.")
    }
  }

  const handleCancelJoined = () => {
    setJoinedDialogVisible(false)
    setCurrentJoined({ id: "", value: "", description: "", type: "" })
    setIsEditingJoined(false)
  }

  const editJoinedIcon = rowData => (
    <Button
      icon="pi pi-pencil"
      onClick={() => {
        setCurrentJoined({ ...rowData })
        setJoinedDialogVisible(true)
        setIsEditingJoined(true)
      }}
      className="p-button-rounded p-button-info"
      disabled={rowData.type === "system"}
    />
  )

  const deleteJoinedIcon = rowData => (
    <Button
      icon="pi pi-trash"
      onClick={() => {
        setJoinedData(prevData =>
          prevData.filter(item => item.id !== rowData.id)
        )
      }}
      className="p-button-rounded p-button-danger"
      disabled={rowData.type === "system"}
    />
  )

  const addNewJoined = () => {
    setCurrentJoined({ id: "", value: "", description: "", type: "" })
    setJoinedDialogVisible(true)
    setIsEditingJoined(false)
  }

  // Joined end


  // categories start

  const [fetchedNodes, setFetchedNodes] = useState([]);
  const [editNodes, setEditNodes] = useState([]);
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [isEditingCategory, setIsEditingCategory] = useState(false);

  const fetchData = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-categories/`);
      const transformedData = transformData(response.data.results);
      setFetchedNodes(transformedData);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        `Failed to fetch categories. ${error.response?.data.error}` ||
        "Please try again.";
      triggerAlert("error", "Error", errorMessage);
    }
  };

  const transformData = (apiData) => {
    return apiData.map(item => ({
      key: item.category_id.toString(),
      label: item.name,
      type: item.type,
      children: item.subcategories ? transformData(item.subcategories) : [],
    }));
  };

  const createCategoryPayload = (nodes, isEditingCategory = false) => {
    if (isEditingCategory && nodes.length === 1) {
      return transformNode(nodes[0]);
    } else {
      return nodes.map(node => transformNode(node));
    }
  };

  const transformNode = (node) => {
    const category = {
      name: node.label,
      description: "",
    };

    if (node.key && !node.key.startsWith('new_')) {
      category.category_id = parseInt(node.key);
    }

    if (node.children && node.children.length > 0) {
      category.subcategories = createCategoryPayload(node.children);
    }

    return category;
  };

  const createNode = (parentId = null) => {
    if (parentId) {
      const findNode = (nodesList, key) => {
        for (const node of nodesList) {
          if (node.key === key) return node;
          if (node.children && node.children.length > 0) {
            const foundNode = findNode(node.children, key);
            if (foundNode) return foundNode;
          }
        }
        return null;
      };
      const parentNode = findNode(editNodes, parentId);
      if (parentNode?.type === 'system') {
        triggerAlert('warning', 'Warning', 'Cannot add children to system categories.');
        return;
      }
    }
    const newNode = {
      key: `new_${Date.now()}`,
      label: "",
      parentId,
      children: [],
    };

    if (!parentId) {
      setEditNodes([...editNodes, newNode]);
    } else {
      const updateNodes = (nodesList) => {
        return nodesList.map(node => {
          if (node.key === parentId) {
            return {
              ...node,
              children: [...(node.children || []), newNode],
            };
          }
          if (node.children && node.children.length > 0) {
            return {
              ...node,
              children: updateNodes(node.children),
            };
          }
          return node;
        });
      };
      setEditNodes(updateNodes(editNodes));
    }
  };

  const updateNodeLabel = (id, newLabel) => {
    if (newLabel.length > 100) {
      triggerAlert('error', 'Error', 'Category name cannot exceed 100 characters.');
      return;
    }
    if (newLabel.trim() === '' && newLabel !== '') {
      triggerAlert('error', 'Error', 'Category name cannot contain only spaces.');
      return;
    }
    if (newLabel.startsWith(' ')) {
      triggerAlert('error', 'Error', 'Category name cannot start with a space.');
      return;
    }
    if (!/^[a-zA-Z0-9\s\-()&.]+$/.test(newLabel)) {
      triggerAlert('error', 'Error', 'Only letters, numbers, spaces, and these special characters are allowed: - ( ) & .');
      return;
    }

    const updateNodes = (nodesList) => {
      return nodesList.map(node => {
        if (node.key === id) {
          return { ...node, label: newLabel };
        }
        if (node.children && node.children.length > 0) {
          return {
            ...node,
            children: updateNodes(node.children),
          };
        }
        return node;
      });
    };
    setEditNodes(updateNodes(editNodes));
  };

  const deleteCategory = async (categoryId) => {
    try {
      const response = await axios.delete(`/api/v1/categories/${categoryId}/`);
      if (response.status === 200 || response.status === 204) {
        triggerAlert('success', 'Success', 'Category deleted successfully.');
        const updatedResponse = await axios.get(`/api/v1/get-all-categories/`);
        const transformedData = transformData(updatedResponse.data.results);
        setFetchedNodes(transformedData);
      }
    } catch (error) {
      const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message ||
        `Failed to delete category. Status code: ${error.response?.status}` ||
        "Please try again.";
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const deleteNode = (id) => {
    const findNode = (nodesList, key) => {
      for (const node of nodesList) {
        if (node.key === key) return node;
        if (node.children && node.children.length > 0) {
          const foundNode = findNode(node.children, key);
          if (foundNode) return foundNode;
        }
      }
      return null;
    };
    const node = findNode(editNodes, id);
    if (node?.type === 'system') {
      triggerAlert('warning', 'Warning', 'System categories cannot be deleted.');
      return;
    }
    if (!id) {
      triggerAlert('warning', 'Warning', 'Invalid Category ID.');
      return;
    }

    ConfirmationAlert('Are you sure you want to delete this category?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await deleteCategory(id);
        const removeNode = (nodesList) => {
          return nodesList.filter(node => {
            if (node.key === id) {
              return false;
            }
            if (node.children && node.children.length > 0) {
              node.children = removeNode(node.children);
            }
            return true;
          });
        };
        setEditNodes(removeNode(editNodes));
      } catch (error) {
        //console.error('Error deleting node:', error);
      } finally {
        setIsDeleting(false); // Reset loading state
      }
    });
  };

  const handleNodeSelect = (nodeKey) => {
    setSelectedNodeKey(nodeKey);
    if (nodeKey) {
      const findFullParentTree = (nodes, key) => {
        for (const node of nodes) {
          if (node.key === key) {
            return node; // Found the exact node
          }
          if (node.children && node.children.length > 0) {
            const foundChild = findFullParentTree(node.children, key);
            if (foundChild) {
              return node; // Return the full parent node (with all children intact)
            }
          }
        }
        return null;
      };

      const parentTree = findFullParentTree(fetchedNodes, nodeKey);
      if (parentTree) {
        setEditNodes([parentTree]); // Show full parent with all children
        setIsEditingCategory(true);
      }
    } else {
      setEditNodes([]);
      setIsEditingCategory(false);
    }
  };


  const handleSaveNode = async () => {
    const validateNodes = (nodes) => {
      for (const node of nodes) {
        if (node.label.length > 100) {
          triggerAlert('error', 'Error', 'Category name cannot exceed 100 characters.');
          return false;
        }
        if (node.label.trim() === '' && node.label !== '') {
          triggerAlert('error', 'Error', 'Category name cannot contain only spaces.');
          return false;
        }
        if (node.label.startsWith(' ')) {
          triggerAlert('error', 'Error', 'Category name cannot start with a space.');
          return false;
        }
        if (node.label === '') {
          triggerAlert('error', 'Error', 'No empty nodes allowed.');
          return false;
        }
        if (node.children && node.children.length > 0) {
          if (!validateNodes(node.children)) {
            return false;
          }
        }
      }
      return true;
    };

    if (!validateNodes(editNodes)) {
      return;
    }

    try {
      const payload = createCategoryPayload(editNodes);
      const response = await axios.post(`/api/v1/categories/`, payload);
      if (response.data) {
        triggerAlert('success', 'Success', 'Categories created successfully.');
        setEditNodes([]);
        setIsEditingCategory(false);
        const updatedResponse = await axios.get(`/api/v1/get-all-categories/`);
        const transformedData = transformData(updatedResponse.data.results);
        setFetchedNodes(transformedData);
      }
    } catch (error) {
      //console.error('Error saving categories:', error);
      const errorMessage = error.response?.data?.error || 'Failed to create categories.';
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const handleEditNode = async () => {
    const validateNodes = (nodes) => {
      for (const node of nodes) {
        if (node.label.length > 100) {
          triggerAlert('error', 'Error', 'Category name cannot exceed 100 characters.');
          return false;
        }
        if (node.label.trim() === '' && node.label !== '') {
          triggerAlert('error', 'Error', 'Category name cannot contain only spaces.');
          return false;
        }
        if (node.label.startsWith(' ')) {
          triggerAlert('error', 'Error', 'Category name cannot start with a space.');
          return false;
        }
        if (node.label === '') {
          triggerAlert('error', 'Error', 'No empty nodes allowed.');
          return false;
        }
        if (node.children && node.children.length > 0) {
          if (!validateNodes(node.children)) {
            return false;
          }
        }
      }
      return true;
    };

    if (!validateNodes(editNodes)) {
      return;
    }

    try {
      const payload = createCategoryPayload(editNodes, true);
      const response = await axios.put(`/api/v1/categories/${selectedNodeKey}/`, payload);
      if (response.data) {
        triggerAlert('success', 'Success', 'Category updated successfully.');
        setEditNodes([]);
        setSelectedNodeKey(null);
        setIsEditingCategory(false);
        const updatedResponse = await axios.get(`/api/v1/get-all-categories/`);
        const transformedData = transformData(updatedResponse.data.results);
        setFetchedNodes(transformedData);
      }
    } catch (error) {
      //console.error('Error updating category:', error);
      const errorMessage = error.response?.data?.error || 'Failed to update category.';
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const handleCancel = () => {
    setEditNodes([]);
    setSelectedNodeKey(null);
    setIsEditingCategory(false);
  };

  const removeUnsavedNode = (nodeKey) => {
    // Recursively remove a node from editNodes by key
    const removeNode = (nodesList) => {
      return nodesList.filter(node => {
        if (node.key === nodeKey) {
          // Filter out this node (effectively deleting it)
          return false;
        }
        // Go deeper for children
        if (node.children && node.children.length > 0) {
          node.children = removeNode(node.children);
        }
        return true;
      });
    };
    setEditNodes(prev => removeNode(prev));
  };

  const RenderNode = ({ node }) => {
    const [localLabel, setLocalLabel] = useState(node.label);
    const isNewNode = node.key.startsWith('new_');
    const isSystemNode = node.type === 'system';

    const handleInputChange = (e) => {
      if (isSystemNode) return;
      setLocalLabel(e.target.value);
    };

    return (
      <div className="ml-4">
        <div className="flex items-center gap-2 my-2">
          <InputText
            value={localLabel}
            onChange={handleInputChange}
            onBlur={() => {
              if (isSystemNode) return;
              if (localLabel !== node.label) {
                updateNodeLabel(node.key, localLabel);
              }
            }}
            placeholder="Enter node label"
            className="p-inputtext"
            disabled={isSystemNode}
            style={{ cursor: isSystemNode ? 'not-allowed' : 'text' }}
          />
          <Button
            icon="pi pi-plus"
            className="p-button-rounded p-button-success p-button-text"
            onClick={() => {
              if (isSystemNode) return;
              createNode(node.key);
            }}
            tooltip="Add child node"
            disabled={isSystemNode}
            style={{ cursor: isSystemNode ? 'not-allowed' : 'pointer' }}
          />
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-danger p-button-text"
            onClick={() => {
              if (isSystemNode) return;
              if (isNewNode) {
                removeUnsavedNode(node.key);
              } else {
                deleteNode(node.key);
              }
            }}
            tooltip="Delete node"
            disabled={isSystemNode}
            style={{ cursor: isSystemNode ? 'not-allowed' : 'pointer' }}
          />
        </div>
        {node.children && node.children.length > 0 && (
          <div className="ml-4">
            {node.children.map(childNode => (
              <RenderNode key={childNode.key} node={childNode} />
            ))}
          </div>
        )}
      </div>
    );
  };




  // Categories end

  // Groups start

  const [fetchedGroupNodes, setFetchedGroupNodes] = useState([]);
  const [editGroupNodes, setEditGroupNodes] = useState([]);
  const [selectedGroupKey, setSelectedGroupKey] = useState(null);
  const [isEditingGroup, setIsEditingGroup] = useState(false);

  const fetchGroups = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-groups/`);
      const transformedData = transformgroupData(response.data.results);
      setFetchedGroupNodes(transformedData);
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        `Failed to fetch groups. ${error.response?.data.error}` ||
        "Please try again.";
      triggerAlert("error", "Error", errorMessage);
    }
  };

  const transformgroupData = (apiData) => {
    return apiData.map(item => ({
      key: item.group_id.toString(),
      label: item.name,
      type: item.type,
      children: item.subgroups ? transformgroupData(item.subgroups) : [],
    }));
  };

  const createGroupPayload = (nodes, isEditingGroup = false) => {
    if (isEditingGroup && nodes.length === 1) {
      return transformGroupNode(nodes[0]);
    }
    return nodes.map(node => transformGroupNode(node));
  };

  const transformGroupNode = (node) => {
    const group = {
      name: node.label,
      description: node.description || "",
    };

    if (node.key && !node.key.startsWith('new_')) {
      group.group_id = parseInt(node.key);
    }

    if (node.children && node.children.length > 0) {
      group.subgroups = createGroupPayload(node.children);
    }

    return group;
  };

  const createGroup = (parentGroupId = null) => {
    if (parentGroupId) {
      const findGroup = (groupsList, key) => {
        for (const group of groupsList) {
          if (group.key === key) return group;
          if (group.children && group.children.length > 0) {
            const foundGroup = findGroup(group.children, key);
            if (foundGroup) return foundGroup;
          }
        }
        return null;
      };
      const parentGroup = findGroup(editGroupNodes, parentGroupId);
      if (parentGroup?.type === 'system') {
        triggerAlert('warning', 'Warning', 'Cannot add children to system groups.');
        return;
      }
    }
    const newGroup = {
      key: `new_${Date.now()}`,
      label: "",
      parentGroupId,
      children: [],
    };
    if (!parentGroupId) {
      setEditGroupNodes([...editGroupNodes, newGroup]);
    } else {
      const updateGroups = groupsList => {
        return groupsList.map(group => {
          if (group.key === parentGroupId) {
            return {
              ...group,
              children: [...(group.children || []), newGroup],
            };
          }
          if (group.children && group.children.length > 0) {
            return {
              ...group,
              children: updateGroups(group.children),
            };
          }
          return group;
        });
      };
      setEditGroupNodes(updateGroups(editGroupNodes));
    }
  };
  const updateGroupLabel = (id, newLabel) => {
    const findGroup = (groupsList, key) => {
      for (const group of groupsList) {
        if (group.key === key) return group;
        if (group.children && group.children.length > 0) {
          const foundGroup = findGroup(group.children, key);
          if (foundGroup) return foundGroup;
        }
      }
      return null;
    };
    const group = findGroup(editGroupNodes, id);
    if (group?.type === 'system') {
      triggerAlert('warning', 'Warning', 'System groups cannot be edited.');
      return;
    }
    if (newLabel.length > 100) {
      triggerAlert('error', 'Error', 'Group name cannot exceed 100 characters.');
      return;
    }
    if (newLabel.trim() === '' && newLabel !== '') {
      triggerAlert('error', 'Error', 'Group name cannot contain only spaces.');
      return;
    }
    if (newLabel.startsWith(' ')) {
      triggerAlert('error', 'Error', 'Group name cannot start with a space.');
      return;
    }
    if (!/^[a-zA-Z0-9\s\-()&.]+$/.test(newLabel)) {
      triggerAlert('error', 'Error', 'Only letters, numbers, spaces, and these special characters are allowed: - ( ) & .');
      return;
    }

    const updateGroups = groupsList => {
      return groupsList.map(group => {
        if (group.key === id) {
          return { ...group, label: newLabel };
        }
        if (group.children && group.children.length > 0) {
          return {
            ...group,
            children: updateGroups(group.children),
          };
        }
        return group;
      });
    };
    setEditGroupNodes(updateGroups(editGroupNodes));
  };

  const deleteGroupFromServer = async (groupId) => {
    try {
      const response = await axios.delete(`/api/v1/groups/${groupId}/`);
      if (response.status === 200 || response.status === 204) {
        triggerAlert('success', 'Success', 'Group deleted successfully.');
        const updatedResponse = await axios.get(`/api/v1/get-all-groups/`);
        const transformedData = transformgroupData(updatedResponse.data.results);
        setFetchedGroupNodes(transformedData);
      }
    } catch (error) {
      const errorMessage = error?.response.data?.error || error?.response?.data?.message || error?.response?.data?.detail || error?.message ||
        `Failed to delete group. Status code: ${error.response?.status}` ||
        "Please try again.";
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const deleteGroup = (id) => {
    const findGroup = (groupsList, key) => {
      for (const group of groupsList) {
        if (group.key === key) return group;
        if (group.children && group.children.length > 0) {
          const foundGroup = findGroup(group.children, key);
          if (foundGroup) return foundGroup;
        }
      }
      return null;
    };
    const group = findGroup(editGroupNodes, id);
    if (group?.type === 'system') {
      triggerAlert('warning', 'Warning', 'System groups cannot be deleted.');
      return;
    }
    if (!id) {
      triggerAlert('warning', 'Warning', 'Invalid Group ID.');
      return;
    }
    ConfirmationAlert('Are you sure you want to delete this group?', 'Delete', async () => {
      setIsDeleting(true);
      try {
        await deleteGroupFromServer(id);
        const removeGroup = (groupsList) => {
          return groupsList.filter(group => {
            if (group.key === id) {
              return false;
            }
            if (group.children && group.children.length > 0) {
              group.children = removeGroup(group.children);
            }
            return true;
          });
        };
        setEditGroupNodes(removeGroup(editGroupNodes));
      } catch (error) {
        //console.error('Error deleting group:', error);
      } finally {
        setIsDeleting(false);
      }
    });
  };

  const handleGroupSelect = (groupKey) => {
    setSelectedGroupKey(groupKey);
    if (groupKey) {
      const findFullParentTree = (nodes, key) => {
        for (const node of nodes) {
          if (node.key === key) {
            return node; // Found exact node
          }
          if (node.children && node.children.length > 0) {
            const foundChild = findFullParentTree(node.children, key);
            if (foundChild) {
              return node; // Return full parent with all children
            }
          }
        }
        return null;
      };

      const parentTree = findFullParentTree(fetchedGroupNodes, groupKey);
      if (parentTree) {
        setEditGroupNodes([parentTree]); // Show parent with all children
        setIsEditingGroup(true);
      }
    } else {
      setEditGroupNodes([]);
      setIsEditingGroup(false);
    }
  };


  const handleSaveGroup = async () => {
    const validateNodes = (nodes) => {
      for (const node of nodes) {
        if (node.type === 'system') {
          triggerAlert('warning', 'Warning', 'System groups cannot be saved.');
          return false;
        }
        if (node.label.length > 100) {
          triggerAlert('error', 'Error', 'Group name cannot exceed 100 characters.');
          return false;
        }
        if (node.label.trim() === '' && node.label !== '') {
          triggerAlert('error', 'Error', 'Group name cannot contain only spaces.');
          return false;
        }
        if (node.label.startsWith(' ')) {
          triggerAlert('error', 'Error', 'Group name cannot start with a space.');
          return false;
        }
        if (node.label === '') {
          triggerAlert('error', 'Error', 'No empty nodes allowed.');
          return false;
        }
        if (node.children && node.children.length > 0) {
          if (!validateNodes(node.children)) {
            return false;
          }
        }
      }
      return true;
    };

    if (!validateNodes(editGroupNodes)) {
      return;
    }

    try {
      const payload = createGroupPayload(editGroupNodes);
      const response = await axios.post(`/api/v1/groups/`, payload);
      if (response.data) {
        triggerAlert('success', 'Success', 'Groups created successfully.');
        setEditGroupNodes([]);
        setIsEditingGroup(false);
        const updatedResponse = await axios.get(`/api/v1/get-all-groups/`);
        const transformedData = transformgroupData(updatedResponse.data.results);
        setFetchedGroupNodes(transformedData);
      }
    } catch (error) {
      //console.error('Error saving groups:', error);
      const errorMessage = error.response?.data?.error || 'Failed to create groups.';
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const handleEditGroup = async () => {
    const validateNodes = (nodes) => {
      for (const node of nodes) {
        if (node.label.length > 100) {
          triggerAlert('error', 'Error', 'Group name cannot exceed 100 characters.');
          return false;
        }
        if (node.label.trim() === '' && node.label !== '') {
          triggerAlert('error', 'Error', 'Group name cannot contain only spaces.');
          return false;
        }
        if (node.label.startsWith(' ')) {
          triggerAlert('error', 'Error', 'Group name cannot start with a space.');
          return false;
        }
        if (node.label === '') {
          triggerAlert('error', 'Error', 'No empty nodes allowed.');
          return false;
        }
        if (node.children && node.children.length > 0) {
          if (!validateNodes(node.children)) {
            return false;
          }
        }
      }
      return true;
    };

    if (!validateNodes(editGroupNodes)) {
      return;
    }

    try {
      const payload = createGroupPayload(editGroupNodes, true);
      const response = await axios.put(`/api/v1/groups/${selectedGroupKey}/`, payload);
      if (response.data) {
        triggerAlert('success', 'Success', 'Group updated successfully.');
        setEditGroupNodes([]);
        setSelectedGroupKey(null);
        setIsEditingGroup(false);
        const updatedResponse = await axios.get(`/api/v1/get-all-groups/`);
        const transformedData = transformgroupData(updatedResponse.data.results);
        setFetchedGroupNodes(transformedData);
      }
    } catch (error) {
      //console.error('Error updating group:', error);
      const errorMessage = error.response?.data?.error || 'Failed to update group.';
      triggerAlert('error', 'Error', errorMessage);
    }
  };

  const handleCancelGroup = () => {
    setEditGroupNodes([]);
    setSelectedGroupKey(null);
    setIsEditingGroup(false);
  };

  const removeUnsavedGroupNode = (nodeKey) => {
    const removeNode = (nodesList) =>
      nodesList.filter(group => {
        if (group.key === nodeKey) return false;
        if (group.children && group.children.length > 0) {
          group.children = removeNode(group.children);
        }
        return true;
      });
    setEditGroupNodes(prev => removeNode(prev));
  };

  const RenderGroup = ({ group }) => {
    const [localGroupLabel, setLocalGroupLabel] = useState(group.label);
    const isNewNode = group.key.startsWith('new_');
    const isSystemGroup = group.type === 'system'; // Same as Categories

    const handleInputChange = (e) => {
      if (isSystemGroup) return; // Prevent typing
      setLocalGroupLabel(e.target.value);
    };

    return (
      <div className="ml-4">
        <div className="flex items-center gap-2 my-2">
          <InputText
            value={localGroupLabel}
            onChange={handleInputChange}
            onBlur={() => {
              if (isSystemGroup) return;
              if (localGroupLabel !== group.label) {
                updateGroupLabel(group.key, localGroupLabel);
              }
            }}
            placeholder="Enter group label"
            className="p-inputtext"
            disabled={isSystemGroup} // Disable typing for system
            style={{ cursor: isSystemGroup ? 'not-allowed' : 'text' }}
          />
          <Button
            icon="pi pi-plus"
            className="p-button-rounded p-button-success p-button-text"
            onClick={() => {
              if (isSystemGroup) return; // Prevent add
              createGroup(group.key);
            }}
            tooltip="Add child group"
            disabled={isSystemGroup}
            style={{ cursor: isSystemGroup ? 'not-allowed' : 'pointer' }}
          />
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-danger p-button-text"
            onClick={() => {
              if (isSystemGroup) return; // Prevent delete
              if (isNewNode) {
                removeUnsavedGroupNode(group.key);
              } else {
                deleteGroup(group.key);
              }
            }}
            tooltip="Delete group"
            disabled={isSystemGroup}
            style={{ cursor: isSystemGroup ? 'not-allowed' : 'pointer' }}
          />
        </div>
        {group.children && group.children.length > 0 && (
          <div className="ml-4">
            {group.children.map(childGroup => (
              <RenderGroup key={childGroup.key} group={childGroup} />
            ))}
          </div>
        )}
      </div>
    );
  };



  /////////////////////////////////////////////// Sahitis Code /////////////////////////////////////////////////////////////// 
  const getaddCountries = async () => {
    try {
      const response = await axios.get(`/api/v1/get-all-countries/`);
      const transformedData = response.data.results.map((country) => ({
        name: country.name,
        id: country.country_id,
      }));
      setAddCountries(transformedData);
      // Also update countriesData for consistency
      setCountriesData(
        response.data.results.map((country) => ({
          id: country.country_id,
          name: country.name,
          description: country.name,
          type: country.type || "Country",
        }))
      );
    } catch (error) {
      //console.error("Error fetching countries:", error);
    }
  };
  const getaddStates = async (countryId) => {
    if (!countryId) {
      //console.error("Country ID is undefined");
      return;
    }

    try {
      const response = await axios.get(
        `/api/v1/get-all-states/?country_id=${countryId}`
      );
      const transformedData = response.data.results.map((state) => ({
        name: state.name,
        id: state.state_id,
      }));
      setAddStates(transformedData);
    } catch (error) {
      //console.error("Error fetching states:", error);
    }
  };

  const getaddCities = async (stateId) => {
    if (!stateId) {
      //console.error("state ID is undefined");
      return;
    }
    try {
      const response = await axios.get(`/api/v1/get-all-cities/?state_id=${stateId}`, {});
      const transformedData = response.data.results.map((city) => ({
        name: city.name,
        id: city.city_id,
      }));
      setaddCities(transformedData);

    }
    catch (error) {
    }
  };

  const fetchUserRoles = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-roles/`)
      if (response?.status === 200) {
        setUserRoles(response?.data?.results)

      }
    }
    catch (error) {
      //////console.log('error occured ', error.message)
    }
  }
  const fetchAllCompanies = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-companies/`)
      if (response?.status === 200) {
        setAllCompanies(response?.data?.results)

      }
    }
    catch (error) {
      //////console.log('error occured ', error.message)
    }
  }
  const fetchAllDepartments = async () => {
    try {
      const response = await axios.get(`api/v1/get-all-departments/`)
      if (response?.status === 200) {
        setAllDepartments(response?.data?.results)

      }
    }
    catch (error) {
      //////console.log('error occured ', error.message)
    }
  }

  // Handle edit
  const handleEditUser = (rowData) => {

    ////console.log(rowData)
    setValue('user_id', rowData.user_id);
    setValue('email', rowData.email);
    setValue('password', rowData.password);
    setValue("role_id", rowData.role_id, { shouldValidate: true }); // Ensure validation runs
    setValue('company', rowData.company);
    setValue('first_name', rowData.first_name);
    setValue('middle_name', rowData.middle_name);
    setValue('last_name', rowData.last_name);
    setValue('phone_number', rowData.phone_number);
    setValue('job_title', rowData.job_title);
    setValue('department', rowData.department);
    setValue('category', rowData.category);
    setValue('group', rowData.group);
    setStreet1(rowData.street_address);
    setStreet2(rowData.street_address_line_2);
    setSelectedLabel1(rowData.label);
    setPostalCode(rowData.pincode);

    setValue('label', rowData.label);
    setIsEditMode(rowData?.id)
    setFormVisible(true)

  }


  const addNewUser = async (data) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`/api/v1/users/`, data);
      //////console.log("response", response)
      if (response.status === 201) {
        setIsLoading(false);
        fetchUserManagementDetails();
        resetForm();
      }
    } catch (error) {
      ////console.error(error);
      setIsLoading(false);
    }
  }
  const editNewUser = async (id, data) => {
    setIsLoading(true);
    try {
      const response = await axios.put(`/api/v1/users/${id}`, data);
      //////console.log("response", response)
      if (response.status === 201) {
        setIsLoading(false);
        fetchUserManagementDetails();
        resetForm();
      }
    } catch (error) {
      ////console.error(error);
      setIsLoading(false);
    }
  }
  // Handle form submit (Add or Edit user)
  const handleFormSubmit = (data) => {
    //////console.log("data", data);
    data.street_address = street1;
    data.street_address_line_2 = street2;
    data.pincode = postalCode;
    data.label = selectedLabel1?.name;
    data.category = data.category?.id;
    if (isEditMode) {
      // Update existing user
      editNewUser(isEditMode, data);
    } else {
      // Add new user

      addNewUser(data)
    }
    // resetForm()
  }
  // Handle delete
  const handleDeleteUser = id => {
    ConfirmationAlert('You want to continue?', 'Continue', async () => {
      setIsDeleting(true);
      try {
        const response = await axios.delete(`/api/v1/users/${id}/`, {

        });
        if (response.status === 200) {
          const responseData = response.data.results;
          fetchUserManagementDetails();
        }

      } catch (error) {

      } finally {
        setIsDeleting(false); // Reset loading state
      }
    })
  }

  const getcategoriesitem = async () => {

    try {
      const response = await axios.get(`/api/v1/get-all-categories/`, {

      });

      if (response.data && response.data.results) {
        const transformedData = response.data.results.map((Categories) => ({
          name: Categories.name,
          id: Categories.category_id,
        }));
        setcategoriesitem(transformedData);
      }
    } catch (error) {

    }
  };

  const getgroupsitemsub = async (category_ids) => {

    try {
      const response = await axios.get(`/api/v1/get-all-groups/?category_id=${category_ids}`, {

      });
      if (response.data && response.data.results) {
        const transformedDatagroup = response.data.results.map((Groups) => ({
          name: Groups.name,
          id: Groups.group_id,
        }));
        setgroupitem(transformedDatagroup);
      }

    } catch (error) {

    }
  };
  const fetchUserManagementDetails = async () => {
    try {
      const response = await axios.get(`/api/v1/users/`, {

      });
      if (response.status === 200) {
        const responseData = response.data.results;
        setUserList(responseData);
      }

    } catch (error) {

    }
  }

  useEffect(() => {

    getcategoriesitem()
    fetchUserManagementDetails();
  }, [])
  useEffect(() => {
    if (formVisible) {
      fetchUserRoles();
      fetchAllCompanies();
      fetchAllDepartments();
    }

  }, [formVisible])
  useEffect(() => {
    if (selectedCountry) {
      getaddStates(selectedCountry.id);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedState) {
      getaddCities(selectedState.id);
    }
  }, [selectedState]);
  /////////////////////////////////////////////////////naveen pss////////////////////////////

  const [modulepermissions, setmodulepermissions] = useState([]);

  const [roleslist, setroleslist] = useState([]);
  const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, getValues: getValues1, setValue: setValue1, trigger: trigger1, reset: reset1, } = useForm({ mode: "onBlur" });
  const [selectedParent, setSelectedParent] = useState([]);
  const [selectedChildren, setSelectedChildren] = useState([]);
  const [actions, setActions] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
  const [smShow, setSmShow] = useState(false)
  const [successAlert, setSuccessAlert] = useState(false);
  const [deleteRowId, setDeleteRowID] = useState(null)
  const [isEdited, setisEdited] = useState(false);
  const [editId, setEditId] = useState(null);
  const [disable, setDisable] = useState(false);

  const handleShowAddUser = () => {
    fetchUserRoles();
    fetchAllCompanies();
    fetchAllDepartments();
    setFormVisible(true)

  }

  useEffect(() => {
    getAllrolesList();
  }, [lazyParams]);

  const onPageChange = (event) => {
    setLazyParams({ page: event.page, rows: event.rows });
  };

  const getAllrolesList = async () => {
    try {
      const response = await axios.get(`/api/v1/roles/?page=${lazyParams.page + 1}&size=${lazyParams.rows}`, {});
      if (response.data && response.data.results) {

        setroleslist(response.data.results);
        setTotalRecords(response.data.count || 0)
      }
    } catch (error) {
    }
  };

  const getAllSublist = async () => {
    try {
      const response = await axios.get(`/api/v1/get-menu-data/`, {});
      if (response.data && response.data.results) {
        setmodulepermissions(response.data.results);
      }
    } catch (error) {
    }
  };



  const getAllSublistupdate = async (id) => {
    try {
      const response = await axios.get(`/api/v1/roles/${id}/`, {});
      if (response.data) {
        let results = response.data;

        setValue1("roleName", results.role_data.role_name)
        setValue1("createdatesrole", moment(results.role_data.created_at).format("YYYY-MM-DD"))
        let permissions = results.permission_data || [];
        let parentPermissions = new Set();
        let childPermissions = new Set();
        let actionPermissions = {};

        permissions.forEach(permission => {
          let parentIds = permission.parent_id ? permission.parent_id.split(',').map(Number) : [];
          let childIds = permission.child_id ? permission.child_id.split(',').map(Number) : [];

          parentIds.forEach(pid => parentPermissions.add(pid));
          childIds.forEach(cid => childPermissions.add(cid));

          childIds.forEach(cid => {
            actionPermissions[cid] = {
              add: permission.add === cid.toString(),
              edit: permission.edit === cid.toString(),
              delete: permission.delete === cid.toString(),
              view: permission.view === cid.toString(),
            };
          });
        });

        setSelectedParent(Array.from(parentPermissions));
        setSelectedChildren(Array.from(childPermissions));
        setActions(actionPermissions);


      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getAllSublist()
    getAllrolesList()

  }, [])


  const handleParentSelect = (parentId, subMenus) => {
    let updatedSelectedChildren = [...selectedChildren];
    let updatedActions = { ...actions };

    if (selectedParent.includes(parentId)) {
      // If parent is already selected, remove it and all its children
      updatedSelectedChildren = updatedSelectedChildren.filter(
        (id) => !subMenus.map((sub) => sub.menu_id).includes(id)
      );
      setSelectedParent(selectedParent.filter((id) => id !== parentId));
    } else {
      // If parent is selected, add all its children
      updatedSelectedChildren = [
        ...new Set([...updatedSelectedChildren, ...subMenus.map((sub) => sub.menu_id)]),
      ];
      setSelectedParent([...selectedParent, parentId]);
    }

    setSelectedChildren(updatedSelectedChildren);
    setActions(updatedActions);
  };
  // Handle Child Selection
  const handleChildSelect = (childId, parentId) => {
    let updatedSelectedChildren = [...selectedChildren];

    if (selectedChildren.includes(childId)) {
      // If child is selected, remove it
      updatedSelectedChildren = updatedSelectedChildren.filter((id) => id !== childId);
    } else {
      // If child is selected, add it and ensure parent is also selected
      updatedSelectedChildren.push(childId);
      if (!selectedParent.includes(parentId)) {
        setSelectedParent([...selectedParent, parentId]);
      }
    }

    // If no more children are selected, remove the parent
    const parentHasChildren = modulepermissions.find(
      (mod) => mod.menu_id === parentId
    )?.sub_menus?.some((sub) => updatedSelectedChildren.includes(sub.menu_id));

    if (!parentHasChildren) {
      setSelectedParent(selectedParent.filter((id) => id !== parentId));
    }

    setSelectedChildren(updatedSelectedChildren);
  };
  const handleActionSelect = (menuId, actionType) => {
    setActions((prev) => ({
      ...prev,
      [menuId]: {
        ...prev[menuId],
        [actionType]: prev[menuId]?.[actionType] === "10" ? "" : "10",
      },
    }));
  };


  const onSubmit = async (data) => {


    const req = {
      role_name: data.roleName,
      createdatesrole: data.createdatesrole,
      parent_id: selectedParent.join(",") || "",
      child_id: selectedChildren.join(",") || "",
      add: selectedChildren
        .filter((id) => actions[id]?.add === "10")
        .join(",") || "",

      edit: selectedChildren
        .filter((id) => actions[id]?.edit === "10")
        .join(",") || "",

      delete: selectedChildren
        .filter((id) => actions[id]?.delete === "10")
        .join(",") || "",

      view: selectedChildren
        .filter((id) => actions[id]?.view === "10")
        .join(",") || "",
    };

    if (!isEdited) {
      try {
        var rolepost = await axios.post(`/api/v1/roles/`, req,);
        if (rolepost.data) {
          setIsFormVisible(false)
          setaddrolespopup(false)
          getAllrolesList();
        }
        setLoading(false);
        setDisable(false)
      } catch (error) {
        setLoading(false);
        setDisable(false)
      }
    } else {
      try {
        var response = await axios.put(`/api/v1/roles/${editId}/`, req,);
        if (response.data) {
          setaddrolespopup(false)
          getAllrolesList();
        }
        setLoading(false);
        setDisable(false)
      } catch (error) {
        setLoading(false);
        setDisable(false)
      }
    }
  };

  const deleteHandler = async () => {
    let id = deleteRowId
    await axios.delete(`/api/v1/roles/${id}/`)
      .then((resp) => {
        getAllrolesList()
        setSmShow(false)
        setSuccessAlert(true)
      })
      .catch((error) => {
      });
  }
  const [addrolespopup, setaddrolespopup] = useState(false)
  // useEffect(() => {
  //   ////console.log("jobTitlesData updated:", jobTitlesData);
  // }, [jobTitlesData]);

  // console.log("totalPipelineRecords", totalPipelineRecords);

  return (
    <React.Fragment>
      <Container fluid={true}>
        <div className="tabsmargin">
          <AdminDasboardats />
          <div className="">
            <div className="container-fluid">
              <div className="row lookup-cust">
                <LoadingOverlay isVisible={isDeleting} />
                <div className="col-6">
                  <Accordion className="mt-3" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchPipelineData()} onTabClose={() => setPaginationParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Pipeline Status">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={pipelineData}
                          // responsiveLayout="scroll"
                          paginator
                          lazy
                          rows={paginationParams.rows}
                          first={paginationParams.page * paginationParams.rows}
                          totalRecords={Number(totalPipelineRecords)}
                          onPage={onPageChange1}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          id="LookupCustomize"
                          resizableColumns
                          columnResizeMode="expand"
                          style={{ marginTop: '1rem' }}
                        >
                          <Column field="value" header="Value" style={{ width: '25%' }} />
                          <Column field="description" header="Description" style={{ width: '25%' }} />
                          {/* <Column field="type" header="Type" style={{ width: '25%' }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {editPipelineIcon(rowData)}
                                {deletePipelineIcon(rowData)}
                              </div>
                            )}
                            style={{ width: '10%' }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-briefcase"
                            onClick={addNewPipeline}
                            className="mt-3 btn btn-primary waves-effect"
                            style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        <Dialog
                          header={isEditingPipeline ? 'Edit Pipeline Status' : 'Add New Pipeline Status'}
                          visible={isPipelineDialogVisible}
                          style={{ width: '30vw' }}
                          onHide={handleCancelPipeline}
                        >
                          <form onSubmit={handleSubmit(handleSavePipeline)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="pipelineValue" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: 'Value is required',
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                                        return 'Special characters are not allowed';
                                      }
                                      return true; // Return true if validation passes
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="pipelineValue"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      disabled={currentPipeline.type === 'system' && isEditingPipeline}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Special characters are not allowed"
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="pipelineDescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Return true if validation passes
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="pipelineDescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="pipelineType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: 'Type is required' }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="pipelineType"
                                      {...field}
                                      options={typeOptions}
                                      optionLabel="label"
                                      optionValue="value"
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      disabled={currentPipeline.type === 'System' && isEditingPipeline}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}

                              {/* <div className="mb-2">
                              <label htmlFor="pipeline" className="block">
                                Pipeline
                              </label>
                              <Controller
                                name="pipeline"
                                control={control}
                                rules={{
                                  required: 'Pipeline is required',
                                  validate: value => {
                                    if (!value) {
                                      return 'Pipeline is required';
                                    }
                                    const stringValue = String(value);
                                    if (stringValue.includes(' ')) {
                                      return 'Spaces are not allowed';
                                    }
                                    if (!/^\d+$/.test(stringValue)) {
                                      return 'Pipeline must be a number';
                                    }
                                    return true; // Return true if validation passes
                                  }
                                }}
                                render={({ field }) => (
                                  <InputText
                                    id="pipeline"
                                    {...field}
                                    placeholder="Enter pipeline"
                                    className={`bgclr w-full ${errors.pipeline ? "p-invalid" : ""}`}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      field.onChange(value);
                                      const stringValue = String(value);
                                      if (stringValue.includes(' ')) {
                                        setError("pipeline", {
                                          type: "manual",
                                          message: "Spaces are not allowed"
                                        });
                                      } else if (!/^\d+$/.test(stringValue)) {
                                        setError("pipeline", {
                                          type: "manual",
                                          message: "Pipeline must be a number"
                                        });
                                      } else {
                                        clearErrors("pipeline");
                                      }
                                    }}
                                  />
                                )}
                              />
                              {errors.pipeline && <Message severity="error" text={errors.pipeline.message} className="mt-2" />}
                            </div> */}
                              <div className="mb-2">
                                <label htmlFor="pipelineOrder" className="block">
                                  Order (1-100)<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="order"
                                  control={control}
                                  rules={{
                                    required: 'Order is required',
                                    validate: (value) => {
                                      if (value === null || value === undefined) {
                                        return 'Order is required';
                                      }
                                      const numValue = Number(value);
                                      return (numValue >= 1 && numValue <= 100) || 'Order must be between 1 and 100';
                                    },
                                  }}
                                  render={({ field }) => (
                                    <InputNumber
                                      id="pipelineOrder"
                                      value={field.value || null}
                                      onChange={(e) => {
                                        // Only update if value is within range or null
                                        const newValue = e.value;
                                        if (newValue === null || (newValue >= 1 && newValue <= 100)) {
                                          field.onChange(newValue);
                                        }
                                      }}
                                      onBlur={field.onBlur}
                                      className={`w-full ${errors.order ? 'p-invalid' : ''}`}
                                      min={1}
                                      max={100}
                                      useGrouping={false}
                                      // Prevent manual input of invalid values
                                      onKeyDown={(e) => {
                                        // Allow backspace, delete, arrows, etc.
                                        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                                        if (allowedKeys.includes(e.key)) return;
                                        // Prevent non-numeric or out-of-range input
                                        const input = e.target.value + e.key;
                                        const num = Number(input);
                                        if (isNaN(num) || num < 1 || num > 100) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.order && <Message severity="error" text={errors.order.message} className="mt-2" />}
                              </div>
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchResumeSource()} onTabClose={() => setLazyParamsResume({ page: 0, rows: 10 })} >
                    <AccordionTab header="Resume Source">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}

                          value={jobTitlesData}
                          lazy paginator first={lazyParamsResume.page * lazyParamsResume.rows}
                          rows={lazyParamsResume.rows} totalRecords={totalRecordsResume} onPage={onPageResume}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          id="LookupCustomize"
                          scrollable
                          emptyMessage="No data found."
                          rowClassName="row-bottom-color"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="value" header="Value" style={{ width: "25%" }} />
                          <Column field="description" header="Description" style={{ width: "25%" }} />
                          <Column
                            header="Upload file"
                            style={{ width: "15%" }}
                            className="d-none"
                            body={(rowData) =>
                              rowData.iconUrl ? (
                                <img
                                  src={rowData.iconUrl}
                                  alt={rowData.iconFilename || "Uploaded file"}
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    objectFit: "contain",
                                    borderRadius: "4px",
                                  }}
                                  onError={(e) => {
                                    e.target.src = "path/to/placeholder-image.png";
                                    e.target.alt = "Image failed to load";
                                  }}
                                />
                              ) : (
                                <span className="text-muted">-</span>
                              )
                            }
                          />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {editJobTitleIcon(rowData)}
                                {deleteJobTitleIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-briefcase" onClick={addNewJobTitle} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>
                        <Dialog header={isEditing ? "Edit Icon" : "Add New Icon"} visible={isEditDialogVisible} style={{ width: "30vw" }} onHide={handleCancelJobTitle}>
                          <form onSubmit={handleSubmit(handleSaveJobTitle)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="jobTitleValue" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }

                                      //                                     if (!/^[a-zA-Z0-9\s\-'/(),&]+$/.test(value)) {
                                      //   return 'Only letters, numbers, and these special characters are allowed: - \' / ( ) , &';
                                      // }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="jobTitleValue"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                          // } else if (!/^[a-zA-Z0-9\s\-'/(),&]+$/.test(value)) {
                                          //   setError("value", {
                                          //     type: "manual",
                                          //     message: "Only letters, numbers, and these special characters are allowed: - \' / ( ) , &"
                                          //   });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="jobTitleDescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="jobTitleDescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>
                              <div className="mb-2">
                                <label htmlFor="iconUpload" className="block">
                                  Upload file<span style={{ color: "red" }}>*</span>
                                </label>

                                <Controller
                                  name="iconFile"
                                  control={control}
                                  rules={{
                                    validate: (file) => {
                                      if (isEditing) return true;
                                      if (!file) return "Upload is required.";
                                      const allowed = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
                                      if (!allowed.includes(file.type))
                                        return "Only JPG, JPEG, PNG, or SVG files are allowed.";
                                      if (file.size > 1 * 1024 * 1024)
                                        return "File size must not exceed 1MB.";
                                      return true;
                                    },
                                  }}
                                  render={({ field }) => (
                                    <>
                                      <div style={{ position: "relative" }}>
                                        <InputText
                                          value={field.value?.name || currentJobTitle.iconFilename || ""}
                                          readOnly
                                          className={`w-full pr-6 ${errors.iconFile ? "p-invalid" : ""}`}
                                          placeholder="Choose file..."
                                        />

                                        <Button
                                          icon="pi pi-upload"
                                          type="button"
                                          className="p-button-text p-0"
                                          style={{
                                            position: "absolute",
                                            top: "0",
                                            right: "0",
                                            height: "100%",
                                            width: "2.5rem", // Adjust width as needed
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            borderTopRightRadius: 'var(--border-radius)',
                                            borderBottomRightRadius: 'var(--border-radius)',
                                          }}
                                          onClick={() => document.getElementById("iconUpload").click()}
                                        />


                                        <input
                                          type="file"
                                          id="iconUpload"
                                          accept=".jpg,.jpeg,.png,.svg"
                                          style={{ display: "none" }}
                                          onChange={(e) => {
                                            const file = e.target.files[0];
                                            field.onChange(file || null);
                                          }}
                                        />
                                      </div>

                                      {errors.iconFile && (
                                        <Message severity="error" text={errors.iconFile.message} className="mt-2" />
                                      )}
                                      <small style={{ color: "grey", display: "block", marginTop: "4px" }}>
                                        Image: JPG, JPEG, CSV, PDF, PNG, SVG, max 1MB
                                      </small>
                                    </>
                                  )}
                                />
                              </div>


                              {/* <div className="mb-2">
                                <label htmlFor="jobTitleType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="jobTitleType"
                                      {...field}
                                      value={currentJobTitle.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentJobTitle((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => { getaddCountries(); fetchAddressCity() }}
                    onTabClose={() => setCityLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Address City">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={citiesData}
                          lazy paginator first={cityLazyParams.page * cityLazyParams.rows}
                          rows={cityLazyParams.rows} totalRecords={cityTotalRecords} onPage={onPageCity}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          id="LookupCustomize"
                          columnResizeMode="expand"
                        >
                          <Column field="state_name" header="State Name" style={{ width: "25%" }} />
                          <Column field="name" header="City Name" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {editCityIcon(rowData)}
                                {deleteCityIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%", textAlign: "center" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewCity}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>
                        <Dialog
                          header={isCityEditing ? "Edit City" : "Add City"}
                          visible={isCityEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelCity}
                        >
                          <form onSubmit={handleSubmit(handleSaveCity)}>
                            <div>
                              {!isCityEditing && (
                                <Row className="mb-2">
                                  <Col xl={12}>
                                    <label htmlFor="country" className="block">Country<span style={{ color: "red" }}>*</span></label>
                                    <Controller
                                      name="country"
                                      control={control}
                                      rules={{ required: "Country is required" }}
                                      render={({ field }) => (
                                        <Dropdown
                                          id="country"
                                          {...field}
                                          value={selectedCountry}
                                          options={addCountries}
                                          optionLabel="name"
                                          optionValue="id"
                                          onChange={(e) => {
                                            field.onChange(e.value);
                                            setSelectedCountry(e.value);
                                            setSelectedState(null);
                                            getaddStates(e.value);
                                          }}
                                          placeholder="Select Country"
                                          className={`w-full ${errors.country ? "p-invalid" : ""}`}
                                        />
                                      )}
                                    />
                                    {errors.country && <Message severity="error" text={errors.country.message} className="mt-2" />}
                                  </Col>
                                </Row>
                              )}

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="state" className="block">State<span style={{ color: "red" }}>*</span></label>
                                  {isCityEditing ? (
                                    <InputText
                                      id="state"
                                      value={currentCity.state_name}
                                      disabled
                                      className="w-full"
                                    />
                                  ) : (
                                    <Controller
                                      name="state"
                                      control={control}
                                      rules={{ required: "State is required" }}
                                      render={({ field }) => (
                                        <Dropdown
                                          id="state"
                                          {...field}
                                          value={selectedState}
                                          options={addStates}
                                          optionLabel="name"
                                          optionValue="id"
                                          onChange={(e) => {
                                            field.onChange(e.value);
                                            setSelectedState(e.value);
                                          }}
                                          placeholder="Select State"
                                          className={`w-full ${errors.state ? "p-invalid" : ""}`}
                                        />
                                      )}
                                    />
                                  )}
                                  {errors.state && <Message severity="error" text={errors.state.message} className="mt-2" />}
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="city" className="block">City<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="name"
                                    control={control}
                                    rules={{
                                      required: "City is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'City must be a string';
                                        }
                                        if (value.length > 100) {
                                          return 'City must not exceed 100 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (!/^[a-zA-Z\s\-'.()]+$/.test(value)) {
                                          return 'Only letters, spaces, and these special characters are allowed: - \' . ( )';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="city"
                                        {...field}
                                        value={currentCity.name}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          setCurrentCity((prev) => ({
                                            ...prev,
                                            name: e.target.value,
                                          }));
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("name", {
                                              type: "manual",
                                              message: "City must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });

                                          } else if (!/^[a-zA-Z\s\-'.()]+$/.test(value)) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Only letters, spaces, and these special characters are allowed: - ' . ( )"
                                            });
                                          } else {
                                            clearErrors("name");
                                          }
                                        }}
                                        className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                                </Col>
                              </Row>

                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="jobTitleType" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="jobTitleType"
                                        {...field}
                                        value={currentCity.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentCity((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>



                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => { getaddCountries(); fetchAddressState(); }}
                    onTabClose={() => setStateLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Address State">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={statesData}
                          lazy
                          paginator
                          first={stateLazyParams.page * stateLazyParams.rows}
                          rows={stateLazyParams.rows}
                          totalRecords={stateTotalRecords}
                          onPage={onPageState}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          id="LookupCustomize"
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="country_name" header="Country Name" style={{ width: "25%" }} />
                          <Column field="name" header="State Name" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                {editStateIcon(rowData)}
                                {deleteStateIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%", textAlign: "center" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewState}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>
                        <Dialog
                          header={isStateEditing ? "Edit State" : "Add State"}
                          visible={isStateEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelState}
                        >
                          <form onSubmit={handleSubmit(handleSaveState)}>
                            <div>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="country" className="block">Country<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="country"
                                    control={control}
                                    rules={{ required: "Country is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="country"
                                        {...field}
                                        value={selectedCountry}
                                        options={addCountries}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setSelectedCountry(e.value);
                                        }}
                                        placeholder={loadingCountries ? "Loading..." : "Select Country"}
                                        className={`w-full ${errors.country ? "p-invalid" : ""}`}
                                        disabled={loadingCountries}
                                      />
                                    )}
                                  />
                                  {errors.country && <Message severity="error" text={errors.country.message} className="mt-2" />}
                                </Col>
                              </Row>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="stateName" className="block">State<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="name"
                                    control={control}
                                    rules={{
                                      required: "State name is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'State name must be a string';
                                        }
                                        if (value.length > 100) { // Adjust the length as needed
                                          return 'State name must not exceed 100 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (!/^[a-zA-Z\s\-'.()]+$/.test(value)) {
                                          return 'Only letters, spaces, and these special characters are allowed: - \' . ( )';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="stateName"
                                        {...field}
                                        value={currentEditingState.name}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("name", {
                                              type: "manual",
                                              message: "State name must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          }
                                          else if (!/^[a-zA-Z\s\-'.()]+$/.test(value)) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Only letters, spaces, and these special characters are allowed: - ' . ( )"
                                            });
                                          } else {
                                            clearErrors("name");
                                          }
                                          setCurrentEditingState((prev) => ({
                                            ...prev,
                                            name: e.target.value,
                                          }));
                                        }}
                                        className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                                </Col>
                              </Row>
                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="jobTitleType" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="jobTitleType"
                                        {...field}
                                        value={currentEditingState.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentEditingState((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>


                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchAddressCountry()} onTabClose={() => setCountryLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Address Country">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={countriesData}
                          lazy
                          paginator
                          first={countryLazyParams.page * countryLazyParams.rows}
                          rows={countryLazyParams.rows}
                          totalRecords={countryTotalRecords}
                          onPage={onPageCountry}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          id="LookupCustomize"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="name" header="Name" style={{ width: "35%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "35%" }} /> */}

                          {/* Actions column */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  // alignItems: "center",
                                  // justifyContent: "center",
                                }}
                              >
                                {editCountryIcon(rowData)}
                                {deleteCountryIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%", textAlign: "center" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewCountry}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        {/* Dialog for adding/editing country */}
                        <Dialog
                          header={isCountryBeingEdited ? "Edit Country" : "Add Country"}
                          visible={isCountryDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelCountry}
                        >
                          <form onSubmit={handleSubmit(handleSaveCountry)}>
                            <div>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="countryName" className="block">Name<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="countryName"
                                    control={control}
                                    rules={{
                                      required: "Country name is required",
                                      validate: (value) => {
                                        if (typeof value !== "string") {
                                          return "Country name must be a string";
                                        }
                                        if (value.length > 50) {
                                          return "Country name must not exceed 50 characters";
                                        }
                                        if (value.startsWith(" ")) {
                                          return "Leading spaces are not allowed";
                                        }
                                        if (!/^[a-zA-Z\s\-'.()]+$/.test(value)) {
                                          return 'Only letters, spaces, and these special characters are allowed: - \' . ( )';
                                        }
                                        return true;
                                      },
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="countryName"
                                        {...field}
                                        value={currentCountry.name}
                                        onChange={(e) => {
                                          const newValue = e.target.value;
                                          field.onChange(newValue);
                                          setCurrentCountry((prev) => ({
                                            ...prev,
                                            name: newValue,
                                          }));

                                          // Instant validation on input
                                          if (newValue.length > 50) {
                                            setError("countryName", {
                                              type: "manual",
                                              message: "Country name must not exceed 50 characters",
                                            });
                                          } else if (newValue.startsWith(" ")) {
                                            setError("countryName", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed",
                                            });
                                          } else if (!/^[a-zA-Z\s\-'.()]+$/.test(newValue)) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Only letters, spaces, and these special characters are allowed: - ' . ( )"
                                            });
                                          } else {
                                            clearErrors("countryName");
                                          }
                                        }}
                                        className={`w-full ${errors.countryName ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />

                                  {errors.countryName && <Message severity="error" text={errors.countryName.message} className="mt-2" />}
                                </Col>
                                {/* <Row className="mb-2">
                                  <Col xl={12}>
                                    <label htmlFor="jobTitleType" className="block">
                                      Type<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <Controller
                                      name="type"
                                      control={control}
                                      rules={{ required: "Type is required" }}
                                      render={({ field }) => (
                                        <Dropdown
                                          id="jobTitleType"
                                          {...field}
                                          value={currentCountry.type}
                                          options={typeOptions}
                                          onChange={(e) => {
                                            field.onChange(e.value);
                                            setCurrentCountry((prev) => ({ ...prev, type: e.value }));
                                          }}
                                          placeholder="Select Type"
                                          className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                        />
                                      )}
                                    />
                                    {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                  </Col>
                                </Row> */}
                              </Row>

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>


                  <Accordion className="mt-3"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchAddrLabel()} onTabClose={() => setAddressLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Address Label">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={addressLabelsData}
                          responsiveLayout="scroll"
                          lazy
                          paginator
                          first={addressLazyParams.page * addressLazyParams.rows}
                          rows={addressLazyParams.rows}
                          totalRecords={addressTotalRecords}
                          onPage={onPageAddress}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          id="LookupCustomize"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "25%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "25%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "25%" }}
                          /> */}


                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editAddressLabelIcon(rowData)}
                                {deleteAddressLabelIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add more"
                            icon="pi pi-plus"
                            onClick={addNewAddressLabel}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>


                        <Dialog
                          header={
                            isEditingAddressLabel
                              ? "Edit Address Label"
                              : "Add Address Label"
                          }
                          visible={isAddressLabelEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelAddressLabel}
                        >
                          <div>
                            <form onSubmit={handleSubmit(handleSaveAddressLabel)}>
                              <div>
                                <div className="mb-2">
                                  <label htmlFor="skillName" className="block">
                                    Value<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="value"
                                    control={control}
                                    rules={{
                                      required: "Value is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'Value must be a string';
                                        }
                                        if (value.length > 100) {
                                          return 'Value must not exceed 100 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (!/^[a-zA-Z0-9\s\-'/()&]+$/.test(value)) {
                                          return 'Only letters, numbers, spaces, and these special characters are allowed: - \' / ( ) &';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="skillName"
                                        {...field}
                                        className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Value must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (!/^[a-zA-Z0-9\s\-'/()&]+$/.test(value)) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Only letters, numbers, spaces, and these special characters are allowed: - ' / ( ) &"
                                            });
                                          } else {
                                            clearErrors("value");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                                </div>

                                <div className="mb-2">
                                  <label htmlFor="description" className="block">
                                    Description
                                  </label>
                                  <Controller
                                    name="description"
                                    control={control}
                                    rules={{
                                      validate: value => {
                                        // Only validate if the value is not empty
                                        if (value && typeof value !== 'string') {
                                          return 'Description must be a string';
                                        }
                                        if (value && value.length > 100) {
                                          return 'Description must not exceed 100 characters';
                                        }
                                        if (value && value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="description"
                                        {...field}
                                        className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Description must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else {
                                            clearErrors("description");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                                </div>


                                {/* <div className="mb-2">
                                  <label htmlFor="skillType" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="skillType"
                                        {...field}
                                        value={currentAddressLabel.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentAddressLabel((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </div> */}
                                <div className="d-flex justify-content-end mt-2">
                                  <Button type="submit" color="primary btn-main me-2">
                                    <i className="pi pi-check me-1"></i> Ok
                                  </Button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchSkills()} onTabClose={() => setSkillsLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Skills">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={skillsData}
                          lazy
                          paginator
                          first={skillsLazyParams.page * skillsLazyParams.rows}
                          rows={skillsLazyParams.rows}
                          totalRecords={skillsTotalRecords}
                          onPage={onPageSkills}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          id="LookupCustomize"
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="name" header="Value" style={{ width: "25%" }} />
                          <Column field="description" header="Description" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editSkillIcon(rowData)}
                                {deleteSkillIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-plus" onClick={addNewSkill} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>
                        <Dialog header={isEditingSkill ? "Edit Skill" : "Add New Skill"} visible={isSkillEditDialogVisible} style={{ width: "30vw" }} onHide={handleCancelSkill}>
                          <form onSubmit={handleSubmit(handleSaveSkill)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="skillName" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="name"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[A-Z]/.test(value)) {
                                        return 'First letter must be capital';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-'.()#+]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - \' . ( ) # +';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="skillName"
                                      {...field}
                                      className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[A-Z]/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "First letter must be capital"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-'.()#+]+$/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - ' . ( ) # +"
                                          });
                                        } else {
                                          clearErrors("name");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="skillDescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="skillDescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="skillType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="skillType"
                                      {...field}
                                      value={currentSkill.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentSkill((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchEmployeeType()} onTabClose={() => setEmployeesLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Employee Type">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={employeesData}
                          lazy
                          paginator
                          first={employeesLazyParams.page * employeesLazyParams.rows}
                          rows={employeesLazyParams.rows}
                          totalRecords={employeesTotalRecords}
                          onPage={onPageEmployees}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          id="LookupCustomize"
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="name" header="Value" style={{ width: "25%" }} />
                          <Column field="description" header="Description" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editEmployeeIcon(rowData)}
                                {deleteEmployeeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-plus" onClick={addNewEmployee} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>
                        <Dialog header={isEditingEmployee ? "Edit Employee" : "Add Employee"} visible={isEmployeeEditDialogVisible} style={{ width: "30vw" }} onHide={handleCancelEmployee}>
                          <form onSubmit={handleSubmit(handleSaveEmployee)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="employeeName" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="name"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 50) { // Character limit validation
                                        return 'Value must not exceed 50 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & .';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="employeeName"
                                      {...field}
                                      className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 50) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Value must not exceed 50 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & ."
                                          });
                                        } else {
                                          clearErrors("name");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="employeeDescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="employeeDescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="employeeType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="employeeType"
                                      {...field}
                                      value={currentEmployee.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentEmployee((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* <Accordion
                      className="mt-3"
                      multiple={false}
                      style={{ width: "100%" }}
                    >
                      <AccordionTab header="Source">
                        <div>
                          {/* Data Table with Pagination 
                          <DataTable
                            value={sourcesData}
                            responsiveLayout="scroll"
                            paginator
                            rows={5}
                          >
                            <Column
                              field="name"
                              header="Value"
                              style={{ width: "25%" }}
                            />
                            <Column
                              field="description"
                              header="Description"
                              style={{ width: "25%" }}
                            />
                            <Column
                              field="type"
                              header="Type"
                              style={{ width: "25%" }}
                            />

                            {/* Actions column 
                            <Column
                              header="Actions"
                              body={rowData => (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {editSourceIcon(rowData)}
                                  {deleteSourceIcon(rowData)}
                                </div>
                              )}
                              style={{ width: "10%" }}
                            />
                          </DataTable>

                          <div className="d-flex justify-content-end">
                            {/* Add new source button 
                            <Button
                              label="Add More"
                              icon="pi pi-plus"
                              onClick={addNewSource}
                              className="mt-3"
                            />
                          </div>

                          {/* Dialog for adding/editing source 
                          <Dialog
                            header={
                              isEditingSource ? "Edit Source" : "Add New Source"
                            }
                            visible={isSourceEditDialogVisible}
                            style={{ width: "30vw" }}
                            onHide={handleCancelSource}
                          >
                            <div>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="sourceName" className="block">
                                    Value
                                  </label>
                                  <InputText
                                    id="sourceName"
                                    value={currentSource.name}
                                    onChange={e =>
                                      setCurrentSource(prev => ({
                                        ...prev,
                                        name: e.target.value,
                                      }))
                                    }
                                    className="w-full"
                                  />
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label
                                    htmlFor="sourceDescription"
                                    className="block"
                                  >
                                    Description
                                  </label>
                                  <InputText
                                    id="sourceDescription"
                                    value={currentSource.description}
                                    onChange={e =>
                                      setCurrentSource(prev => ({
                                        ...prev,
                                        description: e.target.value,
                                      }))
                                    }
                                    className="w-full"
                                  />
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="sourceType" className="block">
                                    Type
                                  </label>
                                  <Dropdown
                                    id="sourceType"
                                    value={currentSource.type}
                                    options={typeOptions}
                                    onChange={e =>
                                      setCurrentSource(prev => ({
                                        ...prev,
                                        type: e.value,
                                      }))
                                    }
                                    placeholder="Select Type"
                                    className="bgclr w-full"
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button
                                      color="primary btn-main me-2"
                                      onClick={handleSaveSource}
                                    >
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Dialog>
                        </div>
                      </AccordionTab>
                    </Accordion> */}

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    onTabOpen={() => fetchReffredBy()} onTabClose={() => setRefferedLazyParams({ page: 0, rows: 10 })}
                    style={{ width: "100%" }}
                  >
                    <AccordionTab header="Referred by">
                      <div>

                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={referredData}
                          responsiveLayout="scroll"
                          paginator
                          lazy
                          first={reffredLazyParams.page * reffredLazyParams.rows}
                          rows={reffredLazyParams.rows}
                          totalRecords={reffredTotalRecords}
                          onPage={onPageReffer}
                          id="LookupCustomize"
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="name"
                            header="Value"
                            style={{ width: "25%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "25%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "25%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editReferredIcon(rowData)}
                                {deleteReferredIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">

                          <Button
                            label="Add Referred"
                            icon="pi pi-plus"
                            onClick={addNewReferred}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>


                        <Dialog
                          header={
                            isEditingReferred
                              ? "Edit Referred"
                              : "Add New Referred"
                          }
                          visible={isReferredEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelReferred}
                        >
                          <form onSubmit={handleSubmit(handleSaveReferred)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="reffered" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="name"
                                  control={control}
                                  rules={{
                                    required: "Referred by is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Referred by must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Referred by must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z\s\-&().]+$/.test(value)) {
                                        return 'Only letters, spaces, and these special characters are allowed: - & ( ) .';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="reffered"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Referred by must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z\s\-&().]+$/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Only letters, spaces, and these special characters are allowed: - & ( ) ."
                                          });
                                        } else {
                                          clearErrors("name");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="refferType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="refferType"
                                      {...field}
                                      value={currentReferred.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentReferred((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button
                                      color="primary btn-main me-2"

                                    >
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchDocuments()} onTabClose={() => setDocLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Document Type">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={docTypeData}
                          responsiveLayout="scroll"
                          lazy
                          paginator
                          first={docLazyParams.page * docLazyParams.rows}
                          rows={docLazyParams.rows}
                          totalRecords={docTotalRecords}
                          onPage={onPageDoc}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          id="LookupCustomize"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="name"
                            header="Value"
                            style={{ width: "25%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "25%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}


                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editDocTypeIcon(rowData)}
                                {deleteDocTypeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">

                          <Button
                            label="Add Document"
                            icon="pi pi-plus"
                            onClick={addNewDocType}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>


                        <Dialog
                          header={
                            isEditingDocType
                              ? "Edit Doc. Type"
                              : "Add New Doc. Type"
                          }
                          visible={isDocTypeEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelDocType}
                        >
                          <div>
                            <form onSubmit={handleSubmit(handleSaveDocu)}>
                              <div>
                                <div className="mb-2">
                                  <label htmlFor="docu" className="block">
                                    Value<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="name"
                                    control={control}
                                    rules={{
                                      required: "Value is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'Value must be a string';
                                        }
                                        if (value.length > 100) {
                                          return 'Value must not exceed 100 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (!/^[a-zA-Z0-9\s\-/(),.&]+$/.test(value)) {
                                          return 'Only letters, numbers, spaces, and these special characters are allowed: - / ( ) , . &';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="docu"
                                        {...field}
                                        className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Value must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (!/^[a-zA-Z0-9\s\-/(),.&]+$/.test(value)) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Only letters, numbers, spaces, and these special characters are allowed: - / ( ) , . &"
                                            });
                                          } else {
                                            clearErrors("name");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                                </div>
                                <div className="mb-2">
                                  <label htmlFor="description" className="block">
                                    Description
                                  </label>
                                  <Controller
                                    name="description"
                                    control={control}
                                    rules={{
                                      validate: value => {
                                        // Only validate if the value is not empty
                                        if (value && typeof value !== 'string') {
                                          return 'Description must be a string';
                                        }
                                        if (value && value.length > 100) {
                                          return 'Description must not exceed 100 characters';
                                        }
                                        if (value && value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="description"
                                        {...field}
                                        className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Description must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else {
                                            clearErrors("description");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                                </div>

                                {/* <div className="mb-2">
                                  <label htmlFor="skillType" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="skillType"
                                        {...field}
                                        value={currentDocType.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentDocType((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </div> */}
                                <div className="d-flex justify-content-end mt-2">
                                  <Button type="submit" color="primary btn-main me-2">
                                    <i className="pi pi-check me-1"></i> Ok
                                  </Button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchDegree()} onTabClose={() => setDegreeLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Degree">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={degreeData}
                          lazy
                          paginator
                          id="LookupCustomize"
                          first={degreeLazyParams.page * degreeLazyParams.rows}
                          rows={degreeLazyParams.rows}
                          totalRecords={degreeTotalRecords}
                          onPage={onPageDegree}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="value" header="Value" style={{ width: "25%" }} />
                          <Column field="description" header="Description" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editDegreeIcon(rowData)}
                                {deleteDegreeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-plus" onClick={addNewDegree} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>
                        <Dialog
                          header={isEditingDegree ? "Edit Degree" : "Add New Degree"}
                          visible={isDegreeEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelDegree}
                        >
                          <form onSubmit={handleSubmit(handleSaveDegree)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="institution_type" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Institution Type is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Institution Type must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Institution Type must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[A-Z]/.test(value)) {
                                        return 'First letter must be capital';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-.()&]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - . ( ) &';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="institution_type"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Institution Type must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[A-Z]/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "First letter must be capital"
                                          });
                                        }
                                        else if (!/^[a-zA-Z0-9\s\-.()&]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - . ( ) &"
                                          });
                                        }
                                        else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>
                              {/* <div className="mb-2">
                                <label htmlFor="type" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="type"
                                      {...field}
                                      options={typeOptions}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>


                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchInstitution()} onTabClose={() => setInstiLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="School / Institute">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}

                          value={institutionData}
                          responsiveLayout="scroll"
                          lazy
                          paginator
                          id="LookupCustomize"
                          first={instiLazyParams.page * instiLazyParams.rows}
                          rows={instiLazyParams.rows}
                          totalRecords={instiTotalRecords}
                          onPage={onPageInsti}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="name"
                            header="Value"
                            style={{ width: "25%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "25%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "25%" }}
                          /> */}

                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editInstitutionIcon(rowData)}
                                {deleteInstitutionIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">

                          <Button
                            label="Add Institution"
                            icon="pi pi-plus"
                            onClick={addNewInstitution}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>


                        <Dialog
                          header={
                            isEditingInstitution
                              ? "Edit Institution"
                              : "Add New Institution"
                          }
                          visible={isInstitutionEditDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelInstitution}
                        >
                          <form onSubmit={handleSubmit(handleSaveInstitution)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="instiname" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="name"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-'.()&,]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - \' . ( ) & ,';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="instiname"
                                      {...field}
                                      className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        }
                                        else if (!/^[a-zA-Z0-9\s\-'.()&,]+$/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - ' . ( ) & ,"
                                          });
                                        } else {
                                          clearErrors("name");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="insdescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }

                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="insdescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>
                              {/* <div className="mb-2">
                                <label htmlFor="skillType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="skillType"
                                      {...field}
                                      value={currentInstitution.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentInstitution((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>

                {/* Column 2 start  */}

                <div className="col-6">
                  <Accordion className="mt-3" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchSkills()} onTabClose={() => setSkillsLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Skills">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={skillsData}
                          lazy
                          id="LookupCustomize"
                          paginator
                          first={skillsLazyParams.page * skillsLazyParams.rows}
                          rows={skillsLazyParams.rows}
                          totalRecords={skillsTotalRecords}
                          onPage={onPageSkills}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="name" header="Value" style={{ width: "25%" }} />
                          <Column field="description" header="Description" style={{ width: "25%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "25%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editSkillIcon(rowData)}
                                {deleteSkillIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>
                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-plus" onClick={addNewSkill} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>
                        <Dialog header={isEditingSkill ? "Edit Skill" : "Add New Skill"} visible={isSkillEditDialogVisible} style={{ width: "30vw" }} onHide={handleCancelSkill}>
                          <form onSubmit={handleSubmit(handleSaveSkill)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="skillName" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="name"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[A-Z]/.test(value)) {
                                        return 'First letter must be capital';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-'.()#+]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - \' . ( ) # +';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="skillName"
                                      {...field}
                                      className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[A-Z]/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "First letter must be capital"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-'.()#+]+$/.test(value)) {
                                          setError("name", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - ' . ( ) # +"
                                          });
                                        } else {
                                          clearErrors("name");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="skillDescription" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="skillDescription"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="skillType" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="skillType"
                                      {...field}
                                      value={currentSkill.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentSkill((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchJobStatus()}
                    onTabClose={() => setJobStatusLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Job Status" >
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={jobStatusData}
                          lazy
                          paginator
                          id="LookupCustomize"
                          first={jobStatusLazyParams.page * jobStatusLazyParams.rows}
                          rows={jobStatusLazyParams.rows}
                          totalRecords={jobStatusTotalRecords}
                          onPage={onPageJobStatus}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}

                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editJobStatusIcon(rowData)}
                                {deleteJobStatusIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewJobStatus}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>
                        <Dialog
                          header={isEditingJobStatus ? "Edit Job Status" : "Add Job Status"}
                          visible={isJobStatusDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelJobStatus}
                        >
                          <form onSubmit={handleSubmit(handleSaveJobStatus)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 50) {
                                        return 'Value must not exceed 50 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-–/()&,.]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - – / ( ) & , .';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 50) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 50 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-–/()&,.]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - – / ( ) & , ."
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      // Only validate if the value is not empty
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="type" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="type"
                                      {...field}
                                      value={currentJobStatus.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentJobStatus((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchWorkPlace()} onTabClose={() => setWorkTypeLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Workplace Type">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={workTypeData}
                          lazy
                          paginator
                          id="LookupCustomize"
                          first={workTypeLazyParams.page * workTypeLazyParams.rows}
                          rows={workTypeLazyParams.rows}
                          totalRecords={workTypeTotalRecords}
                          onPage={onPageWorkType}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editWorkTypeIcon(rowData)}
                                {deleteWorkTypeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewWorkType}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>
                        <Dialog
                          header={isEditingWorkType ? "Edit Work Type" : "Add Work Type"}
                          visible={isWorkTypeDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelWorkType}
                        >
                          <form onSubmit={handleSubmit(handleSaveWorkType)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 30) {
                                        return 'Value must not exceed 30 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z\s\-/()&]+$/.test(value)) {
                                        return 'Only letters, spaces, and these special characters are allowed: - / ( ) &';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 30) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 30 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z\s\-/()&]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, spaces, and these special characters are allowed: - / ( ) &"
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <div className="mb-2">
                                <label htmlFor="type" className="block">
                                  Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="type"
                                  control={control}
                                  rules={{ required: "Type is required" }}
                                  render={({ field }) => (
                                    <Dropdown
                                      id="type"
                                      {...field}
                                      value={currentWorkType.type}
                                      options={typeOptions}
                                      onChange={(e) => {
                                        field.onChange(e.value);
                                        setCurrentWorkType((prev) => ({ ...prev, type: e.value }));
                                      }}
                                      placeholder="Select Type"
                                      className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                    />
                                  )}
                                />
                                {errors.type && <Message severity="error" text={errors.type.message} />}
                              </div> */}
                              <div className="d-flex justify-content-end mt-2">
                                <Button type="submit" color="primary btn-main me-2">
                                  <i className="pi pi-check me-1"></i> Ok
                                </Button>
                              </div>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchJobFunction()} onTabClose={() => setJobFunctionLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Job Function">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={jobFunctionData}
                          lazy
                          id="LookupCustomize"
                          paginator
                          first={jobFunctionLazyParams.page * jobFunctionLazyParams.rows}
                          rows={jobFunctionLazyParams.rows}
                          totalRecords={jobFunctionTotalRecords}
                          onPage={onPageJobFunction}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="value" header="Value" style={{ width: "30%" }} />
                          <Column field="description" header="Description" style={{ width: "30%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "20%" }} /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editJobFunction(rowData)}
                                {deleteJobFunctionIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button label="Add More" icon="pi pi-plus" onClick={addNewJobFunction} className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }} />
                        </div>

                        {/* Dialog for Adding/Editing Job Function */}
                        <Dialog
                          header={isEditingJobFunction ? "Edit Job Function" : "Add Job Function"}
                          visible={isJobFunctionDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelJobFunction}
                        >
                          <form onSubmit={handleSubmit(handleSaveJobFunction)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & .';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & ."
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>


                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentJobFunction.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentJobFunction((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row className="mt-2">
                                <Col xl={12} className="d-flex justify-content-end">
                                  <Button type="submit" className="btn-main">
                                    <i className="pi pi-check me-1"></i> Ok
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>


                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchJobType()}
                  >
                    <AccordionTab header="Job Type">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={jobTypeData}
                          lazy
                          paginator
                          id="LookupCustomize"
                          first={jobTypeLazyParams.page * jobTypeLazyParams.rows}
                          rows={jobTypeLazyParams.rows}
                          totalRecords={jobTypeTotalRecords}
                          onPage={onPageJobType}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editJobTypeIcon(rowData)}
                                {deleteJobTypeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewJobType}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        <Dialog
                          header={isEditingJobType ? "Edit Job Type" : "Add Job Type"}
                          visible={isJobTypeDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelJobType}
                        >
                          <form onSubmit={handleSubmit(handleSaveJobType)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 30) {
                                        return 'Value must not exceed 30 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9 /-]*$/.test(value)) {
                                        return 'Only letters, numbers, spaces, "/" and "-" are allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 30) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 30 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9 /-]*$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: 'Only letters, numbers, spaces, "/" and "-" are allowed'
                                          });
                                        }
                                        else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={field.value || currentJobType.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value); // Update react-hook-form
                                          setCurrentJobType((prev) => ({ ...prev, type: e.value })); // Update currentJobType
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* <Accordion className="mt-3" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchDepartment()} onTabClose={() => setDepartmentLazyParams({ page: 0, rows: 10 })}> */}
                  {/* <AccordionTab header="Department">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={departmentData}
                          lazy
                          paginator
                          first={departmentLazyParams.page * departmentLazyParams.rows}
                          rows={departmentLazyParams.rows}
                          totalRecords={departmentTotalRecords}
                          onPage={onPageDepartment}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          /> */}
                  {/* <Column
                            field="companyname"
                            header="Company Id"
                            style={{ width: "20%" }}
                          /> */}
                  {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                  {/* <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editDepartmentIcon(rowData)}
                                {deleteDepartmentIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable> */}

                  {/* <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewDepartment}
                            className="mt-3"
                          />
                        </div> */}

                  {/* <Dialog
                          header={isEditingDepartment ? "Edit Department" : "Add Department"}
                          visible={isDepartmentDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelDepartment}
                        >
                          <form onSubmit={handleSubmit(handleSaveDepartment)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
  return 'Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & .';
}
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-/()&.]+$/.test(value)) {
  setError("value", {
    type: "manual",
    message: "Only letters, numbers, spaces, and these special characters are allowed: - / ( ) & ."
  });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>


                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="company" className="block">Company<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="company"
                                    control={control}
                                    rules={{ required: "Company is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="company"
                                        {...field}
                                        value={field.value} // Use company_id
                                        options={allCompanies.map(company => ({
                                          label: company.company_name,
                                          value: company.company_id
                                        }))}
                                        onChange={(e) => {
                                          field.onChange(e.value); // Update form value with company_id
                                          setCurrentDepartment((prev) => ({ ...prev, company: e.value }));
                                        }}
                                        placeholder="Select Company"
                                        className={`bgclr w-full ${errors.company ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.company && <Message severity="error" text={errors.company.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                  {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentDepartment.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentDepartment((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                  {/* <Row> */}
                  {/* <Col xl={12}> */}
                  {/* <div className="d-flex justify-content-end mt-2"> */}
                  {/* <Button type="submit" color="primary btn-main me-2"> */}
                  {/* <i className="pi pi-check me-1"></i> Ok */}
                  {/* </Button> */}
                  {/* </div> */}
                  {/* </Col> */}
                  {/* </Row> */}
                  {/* </div> */}
                  {/* </form> */}
                  {/* </Dialog> */}

                  {/* </div> */}
                  {/* </AccordionTab> */}
                  {/* </Accordion> */}

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: '100%' }} onTabOpen={() => fetchSeniority()} onTabClose={() => setSeniorityLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Seniority">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={seniorityData}
                          lazy
                          paginator
                          first={seniorityLazyParams.page * seniorityLazyParams.rows}
                          rows={seniorityLazyParams.rows}
                          totalRecords={seniorityTotalRecords}
                          onPage={onPageSeniority}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editSeniorityIcon(rowData)}
                                {deleteSeniorityIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewSeniority}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>
                        <Dialog
                          header={isEditingSeniority ? "Edit Seniority" : "Add Seniority"}
                          visible={isSeniorityDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelSeniority}
                        >
                          <form onSubmit={handleSubmit(handleSaveSeniority)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 30) {
                                        return 'Value must not exceed 30 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-().+/]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - ( ) . + /';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 30) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 30 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-().+/]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - ( ) . + /"
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentSeniority.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentSeniority((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchSpeciality()} onTabClose={() => setSpecialityLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Speciality">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={specialtiesData}
                          responsiveLayout="scroll"
                          lazy
                          paginator
                          first={specialityLazyParams.page * specialityLazyParams.rows}
                          rows={specialityLazyParams.rows}
                          totalRecords={specialityTotalRecords}
                          onPage={onPageSpeciality}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="name"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editSpecialtyIcon(rowData)}
                                {deleteSpecialtyIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add Specialty"
                            icon="pi pi-plus"
                            onClick={addNewSpecialty}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        <Dialog
                          header={
                            isEditingSpecialty
                              ? "Edit Specialty"
                              : "Add Specialty"
                          }
                          visible={isSpecialtiesDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelSpecialty}
                        >
                          <div>
                            <form onSubmit={handleSubmit(handleSaveSpeciality)}>
                              <div>
                                <div className="mb-2">
                                  <label htmlFor="seniority" className="block">
                                    Value<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="name"
                                    control={control}
                                    rules={{
                                      required: "Value is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'Value must be a string';
                                        }
                                        if (value.length > 100) {
                                          return 'Value must not exceed 100 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (!/^[a-zA-Z0-9\s\-&/().]+$/.test(value)) {
                                          return 'Only letters, numbers, spaces, and these special characters are allowed: - & / ( ) .';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="seniority"
                                        {...field}
                                        className={`w-full ${errors.name ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Value must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("name", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (!/^[a-zA-Z0-9\s\-&/().]+$/.test(value)) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Only letters, numbers, spaces, and these special characters are allowed: - & / ( ) ."
                                            });
                                          } else {
                                            clearErrors("name");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.name && <Message severity="error" text={errors.name.message} className="mt-2" />}
                                </div>

                                <div className="mb-2">
                                  <label htmlFor="description" className="block">
                                    Description
                                  </label>
                                  <Controller
                                    name="description"
                                    control={control}
                                    rules={{
                                      validate: value => {
                                        // Only validate if the value is not empty
                                        if (value && typeof value !== 'string') {
                                          return 'Description must be a string';
                                        }
                                        if (value && value.length > 100) {
                                          return 'Description must not exceed 100 characters';
                                        }
                                        if (value && value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="description"
                                        {...field}
                                        className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Description must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else {
                                            clearErrors("description");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                                </div>


                                {/* <div className="mb-2">
                                  <label htmlFor="seniorityType" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="seniorityType"
                                        {...field}
                                        value={currentSpecialty.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentSpecialty((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </div> */}
                                <div className="d-flex justify-content-end mt-2">
                                  <Button type="submit" color="primary btn-main me-2">
                                    <i className="pi pi-check me-1"></i> Ok
                                  </Button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </Dialog>
                      </div>
                    </AccordionTab>
                  </Accordion>


                  {/* Industry start */}

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onClick={() => { fetchIndustry(); }}
                    onTabClose={() => setIndustryLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Industry" >
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={industryData}
                          lazy
                          paginator
                          first={industryLazyParams.page * industryLazyParams.rows}
                          rows={industryLazyParams.rows}
                          totalRecords={industryTotalRecords}
                          onPage={onPageIndustry}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editIndustryIcon(rowData)}
                                {deleteIndustryIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewIndustry}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        <Dialog
                          header={isEditingIndustry ? "Edit Industry" : "Add Industry"}
                          visible={isIndustryDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelIndustry}
                        >
                          <form onSubmit={handleSubmit(handleSaveIndustry)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 100) {
                                        return 'Value must not exceed 100 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z0-9\s\-&/(),.]+$/.test(value)) {
                                        return 'Only letters, numbers, spaces, and these special characters are allowed: - & / ( ) , .';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z0-9\s\-&/(),.]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, numbers, spaces, and these special characters are allowed: - & / ( ) , ."
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>


                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentIndustry.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentIndustry((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* Company Size */}

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchCompanySize()}
                    onTabClose={() => setCompanySizeLazyParams({ page: 0, rows: 10 })}
                  >
                    <AccordionTab header="Company Size">
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={companySizeData}
                          lazy
                          paginator
                          first={companySizeLazyParams.page * companySizeLazyParams.rows}
                          rows={companySizeLazyParams.rows}
                          totalRecords={companySizeTotalRecords}
                          onPage={onPageCompanySize}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column
                            field="value"
                            header="Value"
                            style={{ width: "30%" }}
                          />
                          <Column
                            field="description"
                            header="Description"
                            style={{ width: "30%" }}
                          />
                          {/* <Column
                            field="type"
                            header="Type"
                            style={{ width: "20%" }}
                          /> */}
                          <Column
                            header="Actions"
                            body={rowData => (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                {editCompanySizeIcon(rowData)}
                                {deleteCompanySizeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewCompanySize}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        <Dialog
                          header={isEditingCompanySize ? "Edit Company Size" : "Add Company Size"}
                          visible={isCompanySizeDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelCompanySize}
                        >
                          <form onSubmit={handleSubmit(handleSaveCompanySize)}>
                            <div>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="value" className="block">
                                    Company Size<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="value"
                                    control={control}
                                    rules={{
                                      required: "Company Size is required",
                                      validate: value => {
                                        if (!value) {
                                          return 'Company Size is required';
                                        }
                                        if (value.length > 50) {
                                          return 'Company Size must not exceed 50 characters';
                                        }
                                        if (value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        if (value.startsWith('-')) {
                                          return 'Company size cannot start with a negative sign';
                                        }
                                        if (!/^[a-zA-Z0-9\s\-–+,()]+$/.test(value)) {
                                          return 'Only letters, numbers, spaces, and these special characters are allowed: - – + , ( )';
                                        }
                                        return true;
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="value"
                                        {...field}
                                        className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          field.onChange(value);

                                          if (value.length > 50) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Company Size must not exceed 50 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (value.startsWith('-')) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Company size cannot start with a negative sign"
                                            });
                                          } else if (!/^[a-zA-Z0-9\s\-–+,()]+$/.test(value)) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Only letters, numbers, spaces, and these special characters are allowed: - – + , ( )"
                                            });
                                          } else {
                                            clearErrors("value");
                                          }
                                        }}


                                      />
                                    )}
                                  />
                                  {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="description" className="block">
                                    Description
                                  </label>
                                  <Controller
                                    name="description"
                                    control={control}
                                    rules={{

                                      validate: value => {
                                        if (value && typeof value !== 'string') {
                                          return 'Description must be a string';
                                        }
                                        if (value && value.length > 100) {
                                          return 'Description must not exceed 100 characters';
                                        }
                                        if (value && value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="description"
                                        {...field}
                                        className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          field.onChange(e.target.value);
                                          const value = e.target.value;
                                          if (value.length > 100) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Description must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else {
                                            clearErrors("description");
                                          }
                                        }}
                                      />
                                    )}
                                  />
                                  {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                                </Col>
                              </Row>

                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentCompanySize.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentCompanySize((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* Schedule Type */}

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: "100%" }} onTabOpen={() => fetchScheduleType()} onTabClose={() => setScheduleTypeLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Schedule Type" >
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={scheduleTypeData}
                          lazy
                          paginator
                          first={scheduleTypeLazyParams.page * scheduleTypeLazyParams.rows}
                          rows={scheduleTypeLazyParams.rows}
                          totalRecords={scheduleTypeTotalRecords}
                          onPage={onPageScheduleType}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="value" header="Value" style={{ width: "30%" }} />
                          <Column field="description" header="Description" style={{ width: "30%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "20%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editScheduleTypeIcon(rowData)}
                                {deleteScheduleTypeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewScheduleType}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        {/* Dialog for adding/editing schedule type */}
                        <Dialog
                          header={isEditingScheduleType ? "Edit Schedule Type" : "Add Schedule Type"}
                          visible={isScheduleTypeDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelScheduleType}
                        >
                          <form onSubmit={handleSubmit(handleSaveScheduleType)}>
                            <div>
                              <div className="mb-2">
                                <label htmlFor="value" className="block">
                                  Value<span style={{ color: "red" }}>*</span>
                                </label>
                                <Controller
                                  name="value"
                                  control={control}
                                  rules={{
                                    required: "Value is required",
                                    validate: value => {
                                      if (typeof value !== 'string') {
                                        return 'Value must be a string';
                                      }
                                      if (value.length > 50) {
                                        return 'Value must not exceed 50 characters';
                                      }
                                      if (value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      if (!/^[a-zA-Z\s\-()&]+$/.test(value)) {
                                        return 'Only letters, spaces, and these special characters are allowed: - ( ) &';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="value"
                                      {...field}
                                      className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 50) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Value must not exceed 50 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else if (!/^[a-zA-Z\s\-()&]+$/.test(value)) {
                                          setError("value", {
                                            type: "manual",
                                            message: "Only letters, spaces, and these special characters are allowed: - ( ) &"
                                          });
                                        } else {
                                          clearErrors("value");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                              </div>

                              <div className="mb-2">
                                <label htmlFor="description" className="block">
                                  Description
                                </label>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    validate: value => {
                                      if (value && typeof value !== 'string') {
                                        return 'Description must be a string';
                                      }
                                      if (value && value.length > 100) {
                                        return 'Description must not exceed 100 characters';
                                      }
                                      if (value && value.startsWith(' ')) {
                                        return 'Leading spaces are not allowed';
                                      }
                                      return true; // Validation passed
                                    }
                                  }}
                                  render={({ field }) => (
                                    <InputText
                                      id="description"
                                      {...field}
                                      className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                      onChange={(e) => {
                                        field.onChange(e.target.value);
                                        const value = e.target.value;
                                        if (value.length > 100) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Description must not exceed 100 characters"
                                          });
                                        } else if (value.startsWith(' ')) {
                                          setError("description", {
                                            type: "manual",
                                            message: "Leading spaces are not allowed"
                                          });
                                        } else {
                                          clearErrors("description");
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                              </div>

                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">
                                    Type<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentScheduleType.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentScheduleType((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* Schudule sub-type */}

                  <Accordion className="mt-3 border border-danger d-none" multiple={false} style={{ width: "100%" }} onTabOpen={() => { fetchScheduleType(); fetchScheduleSubType() }} onTabClose={() => setScheduleSubTypeLazyParams({ page: 0, rows: 10 })}>
                    <AccordionTab header="Schedule Sub-Type" >
                      <div>
                        <DataTable
                          tableStyle={{ minWidth: '50rem', borderRadius: '8px', boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)' }}
                          value={scheduleSubTypeData}
                          lazy
                          paginator
                          first={scheduleSubTypeLazyParams.page * scheduleSubTypeLazyParams.rows}
                          rows={scheduleSubTypeLazyParams.rows}
                          totalRecords={scheduleSubTypeTotalRecords}
                          onPage={onPageScheduleSubType}
                          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                          currentPageReportTemplate="{first} to {last} of {totalRecords}"
                          rowsPerPageOptions={[10, 20, 50, 100, 150]}
                          dataKey="id"
                          scrollable
                          emptyMessage="No data found."
                          rowGroupMode="rowspan"
                          rowClassName="row-bottom-color"
                          editMode="cell"
                          resizableColumns
                          columnResizeMode="expand"
                        >
                          <Column field="scheduleType" header="Schedule Type" style={{ width: "20%" }} />
                          <Column field="value" header="Value" style={{ width: "30%" }} />
                          <Column field="description" header="Description" style={{ width: "30%" }} />
                          {/* <Column field="type" header="Type" style={{ width: "20%" }} /> */}
                          <Column
                            header="Actions"
                            body={(rowData) => (
                              <div style={{ display: "flex", justifyContent: "space-between" }}>
                                {editScheduleSubTypeIcon(rowData)}
                                {deleteScheduleSubTypeIcon(rowData)}
                              </div>
                            )}
                            style={{ width: "10%" }}
                          />
                        </DataTable>

                        <div className="d-flex justify-content-end">
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            onClick={addNewScheduleSubType}
                            className="mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                          />
                        </div>

                        {/* Dialog for adding/editing schedule sub-type */}
                        <Dialog
                          header={isEditingScheduleSubType ? "Edit Schedule Sub-Type" : "Add Schedule Sub-Type"}
                          visible={isScheduleSubTypeDialogVisible}
                          style={{ width: "30vw" }}
                          onHide={handleCancelScheduleSubType}
                        >
                          <form onSubmit={handleSubmit(handleSaveScheduleSubType)}>
                            <div>
                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="scheduleType" className="block">Schedule Type<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="scheduleType"
                                    control={control}
                                    rules={{ required: "Schedule Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="scheduleType"
                                        {...field}
                                        options={scheduleTypeData}
                                        optionLabel="value"
                                        optionValue="id"
                                        value={currentScheduleSubType.scheduleType}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentScheduleSubType((prev) => ({ ...prev, scheduleType: e.value }));
                                        }}
                                        placeholder="Select Schedule Type"
                                        className={`w-full ${errors.scheduleType ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.scheduleType && <Message severity="error" text={errors.scheduleType.message} className="mt-2" />}
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="value" className="block">Value<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="value"
                                    control={control}
                                    rules={{
                                      required: "Value is required",
                                      validate: value => {
                                        if (typeof value !== 'string') {
                                          return 'Value must be a string and leading spaces are not allowed';
                                        }
                                        if (value.length > 100) {
                                          return 'Value must not exceed 100 characters';
                                        }
                                        if (!/^[a-zA-Z\s\-()&]+$/.test(value)) {
                                          return 'Only letters, spaces, and these special characters are allowed: - ( ) &';
                                        }
                                        return !value.startsWith(' ') || 'Leading spaces are not allowed';
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="value"
                                        {...field}
                                        disabled={!currentScheduleSubType.scheduleType}
                                        className={`w-full ${errors.value ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          const inputVal = e.target.value;
                                          field.onChange(inputVal);

                                          if (inputVal.length > 100) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Value must not exceed 100 characters"
                                            });
                                          } else if (inputVal.startsWith(' ')) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (!/^[a-zA-Z\s\-()&]+$/.test(inputVal)) {
                                            setError("value", {
                                              type: "manual",
                                              message: "Only letters, spaces, and these special characters are allowed: - ( ) &"
                                            });
                                          } else {
                                            clearErrors("value");
                                          }
                                        }}

                                      />
                                    )}
                                  />
                                  {errors.value && <Message severity="error" text={errors.value.message} className="mt-2" />}
                                </Col>
                              </Row>

                              <Row className="mb-2">
                                <Col xl={12}>

                                  <label htmlFor="description" className="block">
                                    Description
                                  </label>
                                  <Controller
                                    name="description"
                                    control={control}
                                    rules={{
                                      validate: value => {
                                        if (value && typeof value !== 'string') {
                                          return 'Description must be a string';
                                        }
                                        if (value && value.length > 100) {
                                          return 'Description must not exceed 100 characters';
                                        }
                                        if (value && value.startsWith(' ')) {
                                          return 'Leading spaces are not allowed';
                                        }
                                        return true; // Validation passed
                                      }
                                    }}
                                    render={({ field }) => (
                                      <InputText
                                        id="description"
                                        {...field}
                                        className={`w-full ${errors.description ? "p-invalid" : ""}`}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          field.onChange(value);

                                          if (value.length > 100) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Description must not exceed 100 characters"
                                            });
                                          } else if (value.startsWith(' ')) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Leading spaces are not allowed"
                                            });
                                          } else if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                                            setError("description", {
                                              type: "manual",
                                              message: "Special characters are not allowed"
                                            });
                                          } else {
                                            clearErrors("description");
                                          }
                                        }}

                                      />
                                    )}
                                  />
                                  {errors.description && <Message severity="error" text={errors.description.message} className="mt-2" />}
                                </Col>
                              </Row>
                              {/* <Row className="mb-2">
                                <Col xl={12}>
                                  <label htmlFor="type" className="block">Type<span style={{ color: "red" }}>*</span></label>
                                  <Controller
                                    name="type"
                                    control={control}
                                    rules={{ required: "Type is required" }}
                                    render={({ field }) => (
                                      <Dropdown
                                        id="type"
                                        {...field}
                                        value={currentScheduleSubType.type}
                                        options={typeOptions}
                                        onChange={(e) => {
                                          field.onChange(e.value);
                                          setCurrentScheduleSubType((prev) => ({ ...prev, type: e.value }));
                                        }}
                                        placeholder="Select Type"
                                        className={`bgclr w-full ${errors.type ? "p-invalid" : ""}`}
                                      />
                                    )}
                                  />
                                  {errors.type && <Message severity="error" text={errors.type.message} className="mt-2" />}
                                </Col>
                              </Row> */}

                              <Row>
                                <Col xl={12}>
                                  <div className="d-flex justify-content-end mt-2">
                                    <Button type="submit" color="primary btn-main me-2">
                                      <i className="pi pi-check me-1"></i> Ok
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </form>
                        </Dialog>

                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* categories start */}
                  <Accordion className="mt-3"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchData()}
                    onTabClose={handleCancel}
                  >
                    <AccordionTab header="Categories">
                      <div className="max-w-2xl mx-auto">
                        <div className="mb-4 d-flex justify-content-end">
                          {editNodes.length > 0 && (
                            <>
                              <Button
                                label="Cancel"
                                icon="pi pi-times me-1"
                                className="p-button me-3"
                                onClick={handleCancel}
                              />
                              <Button
                                label={isEditingCategory ? "Update" : "Save"}
                                icon="pi pi-check me-1"
                                className="p-button me-3"
                                onClick={isEditingCategory ? handleEditNode : handleSaveNode}
                                disabled={
                                  isEditingCategory &&
                                  editNodes.length === 1 &&
                                  editNodes[0].type === 'system'
                                }
                              />
                            </>
                          )}
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            // className="p-button"
                            className="p-button mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                            onClick={() => {
                              createNode();
                              setIsEditingCategory(false);
                            }}
                            disabled={isEditingCategory}
                          />
                        </div>
                        <div className="border rounded-lg p-4 bg-white">
                          {editNodes.map(node => (
                            <RenderNode key={node.key} node={node} />
                          ))}
                        </div>
                        {fetchedNodes.length > 0 && (
                          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                            <h3 className="font-semibold mb-2">
                              View the Category Component:
                            </h3>
                            <TreeSelect
                              value={selectedNodeKey}
                              options={fetchedNodes}
                              onChange={(e) => handleNodeSelect(e.value)}
                              placeholder="Select a node"
                              className="w-full"
                            />
                          </div>
                        )}
                      </div>
                    </AccordionTab>
                  </Accordion>

                  {/* categories end */}

                  {/* Groups start */}

                  <Accordion className="mt-3 border border-danger d-none"
                    multiple={false}
                    style={{ width: "100%" }}
                    onTabOpen={() => fetchGroups()}
                    onTabClose={handleCancelGroup}
                  >
                    <AccordionTab header="Groups">
                      <div className="max-w-2xl mx-auto">
                        <div className="mb-4 d-flex justify-content-end">
                          {editGroupNodes.length > 0 && (
                            <>
                              <Button
                                label="Cancel"
                                icon="pi pi-times me-1"
                                className="p-button me-3"
                                onClick={handleCancelGroup}
                              />
                              <Button
                                label={isEditingGroup ? "Update" : "Save"}
                                icon="pi pi-check me-1"
                                className="p-button me-3"
                                onClick={isEditingGroup ? handleEditGroup : handleSaveGroup}
                                disabled={
                                  (isEditingGroup &&
                                    editGroupNodes.length === 1 &&
                                    editGroupNodes[0].type === 'system') ||
                                  (isEditingGroup && editGroupNodes.some(node => node.type === 'system'))
                                }
                              />
                            </>
                          )}
                          <Button
                            label="Add More"
                            icon="pi pi-plus"
                            // className="p-button"
                            className="p-button mt-3 btn btn-primary waves-effect" style={{ borderRadius: '4px', color: "white" }}
                            onClick={() => {
                              createGroup();
                              setIsEditingGroup(false);
                            }}
                            disabled={isEditingGroup}
                          />
                        </div>
                        <div className="border rounded-lg p-4 bg-white">
                          {editGroupNodes.map(group => (
                            <RenderGroup key={group.key} group={group} />
                          ))}
                        </div>
                        {fetchedGroupNodes.length > 0 && (
                          <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                            <h3 className="font-semibold mb-2">
                              View the Group Component:
                            </h3>
                            <TreeSelect
                              value={selectedGroupKey}
                              options={fetchedGroupNodes}
                              onChange={e => handleGroupSelect(e.value)}
                              placeholder="Select a group"
                              className="w-full"
                            />
                          </div>
                        )}
                      </div>
                    </AccordionTab>
                  </Accordion>
                </div>


              </div>
            </div>

          </div ></div>
      </Container >


      <Modal size="md" show={smShow} onHide={() => setSmShow(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Delete</h1></Modal.Header>
        <div className="text-center m-3 text-danger">  </div>
        <h4 className="text-center m-2"> Are you sure you want to delete this </h4>
        <div className="text-center m-3">
          <Button className="btn btn-primary m-1" onClick={() => setSmShow(false)} >Cancel</Button>
          <button className="btn btn-primary m-1" onClick={deleteHandler}> Delete </button>
        </div>
      </Modal>
      <Modal size="md" show={successAlert} onHide={() => setSuccessAlert(false)} className="text-center" >
        <Modal.Header closeButton><h1 className="modal-title fs-5 "> Success</h1></Modal.Header>
        <div className="text-center m-3"> </div>
        <h4 className="text-center">Delete  Successfully</h4>
        <div className="text-center m-3">
          <button className="btn btn-primary" onClick={() => setSuccessAlert(false)} > OK </button>
        </div>
      </Modal>

    </React.Fragment >

  )
}

export default Lookup_Cus
